import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CgTemplate } from "react-icons/cg";
import { FaDownload } from "react-icons/fa6";
import { API_URL } from "../../Config";

const BrochurePDF = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [brochure, setBrochure] = useState(null);
  const [amenities, setAmenities] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagesToRender, setPagesToRender] = useState([]);
  const [dynamicPages, setDynamicPages] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");
    if (savedState !== null) return JSON.parse(savedState);
    return window.innerWidth >= 1024;
  });
  useEffect(() => {
    const fetchBrochure = async () => {
      try {
        const res = await fetch(`${API_URL}/getBrochure/${id}`);

        const rawText = await res.text();
        // console.log("RAW RESPONSE:", rawText);

        let json;
        try {
          json = JSON.parse(rawText);
          // console.log("Parsed JSON:", json);
        } catch (parseError) {
          console.error("JSON Parse Error:", parseError);
          throw new Error(
            `Invalid response from server. Status: ${res.status}`,
          );
        }

        if (!json.success) throw new Error(json.message);
        setBrochure(json.data);

        // Parse dynamic pages if they exist
        let dynamicPagesData = [];
        if (json.data.dynamic_pages && Array.isArray(json.data.dynamic_pages)) {
          dynamicPagesData = json.data.dynamic_pages;
          setDynamicPages(dynamicPagesData);
          // console.log("Dynamic pages:", dynamicPagesData);
        }

        const amenityIds = Array.isArray(json.data.amenity_ids)
          ? json.data.amenity_ids
          : JSON.parse(json.data.amenity_ids || "[]");

        let amenitiesData = [];
        if (amenityIds.length > 0) {
          const amenityRes = await fetch(
            `${API_URL}/getAmenitiesById?ids=${amenityIds.join(",")}`,
          );
          const amenityJson = await amenityRes.json();
          if (amenityJson.success) {
            amenitiesData = amenityJson.data;
            setAmenities(amenitiesData);
          }
        }

        // Build Property object to check images
        const Property = {
          villa: {
            logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
            title: json.data.villa_name,
            text: json.data.top_text,
            mainImage: json.data.img_page1,
            signature: json.data.location,
            contact: {
              website: "www.zorbastays.com",
              email: "info@zorbastays.com",
              phones: "63552-31066, 98750-28066",
            },
          },
          amenities: {
            logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
            items: amenitiesData.map((a) => ({
              name: a.name,
              imgSrc: a.url,
            })),
          },
          theVilla: {
            logo: "https://zorbastays.com/android-chrome-512x512.png",
            image: json.data.img_page3,
            paragraph1: json.data.villa_desc1,
            paragraph2: json.data.villa_desc2,
          },
          curation: {
            title: json.data.the_title,
            footerWebsite: "www.zorbastays.com",
            steps: [
              {
                heading: json.data.curate_title1,
                description: json.data.curate_desc1,
              },
              {
                heading: json.data.curate_title2,
                description: json.data.curate_desc2,
              },
              {
                heading: json.data.curate_title3,
                description: json.data.curate_desc3,
              },
              {
                heading: json.data.curate_title4,
                description: json.data.curate_desc4,
              },
              {
                heading: json.data.curate_title5,
                description: json.data.curate_desc5,
              },
            ],
          },
          gallery: {
            signature: json.data.pool_title,
            logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
            images: [
              json.data.img_page5_1,
              json.data.img_page5_2,
              json.data.img_page5_3,
            ],
          },
          living: {
            logo: "https://zorbastays.com/android-chrome-512x512.png",
            livingImage: json.data.img_page6,
            paragraph1: json.data.living_desc1,
            paragraph2: json.data.living_desc2,
          },
          kitchenDining: {
            title: json.data.kitchen_title,
            images: [json.data.img_page7_1, json.data.img_page7_2],
          },
          bedrooms: {
            logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
            bedroomImage: json.data.img_page8,
            paragraph1: json.data.bed_desc1,
            paragraph2: json.data.bed_desc2,
          },
          bedroomGallery: {
            images: [json.data.img_page9_1, json.data.img_page9_2],
          },
          bedroomGallery2: {
            images: [json.data.img_page10_1, json.data.img_page10_2],
          },
          bedroomGalleryMixed: {
            images: [
              json.data.img_page11_1,
              json.data.img_page11_2,
              json.data.img_page11_3,
            ],
          },
          bedroomGalleryMixed2: {
            images: [
              json.data.img_page12_1,
              json.data.img_page12_2,
              json.data.img_page12_3,
            ],
          },
          bedroomGalleryMixed3: {
            images: [
              json.data.img_page13_1,
              json.data.img_page13_2,
              json.data.img_page13_3,
            ],
          },
          bedroomGallery3: {
            images: [json.data.img_page14_1, json.data.img_page14_2],
          },
          commonareas: {
            title: json.data.common_areas,
            images: [json.data.img_page15_1, json.data.img_page15_2],
          },
          bedroomGallery4: {
            images: [json.data.img_page16_1, json.data.img_page16_2],
          },
          bedroomGallery5: {
            images: [json.data.img_page17_1, json.data.img_page17_2],
          },
          bedroomGalleryMixed4: {
            images: [
              json.data.img_page18_1,
              json.data.img_page18_2,
              json.data.img_page18_3,
            ],
          },
          bedroomGallery6: {
            images: [json.data.img_page19_1, json.data.img_page19_2],
          },
          bedroomGallery7: {
            images: [json.data.img_page20_1, json.data.img_page20_2],
          },
          services: {
            section1: {
              title: json.data.destination,
              description: json.data.destination_desc,
              bannerText: json.data.travel_title,
              link: json.data.travel_link,
            },
            section2: {
              title: json.data.service,
              description: json.data.service_desc,
              bannerText: json.data.concierge_title,
              link: json.data.concierge_link,
            },
          },
          aboutZorba: {
            title: json.data.nature,
            heading: json.data.nature_desc1,
            paragraph1: json.data.nature_desc2,
            paragraph2: json.data.nature_desc3,
            paragraph3: "",
          },
          backCover: {
            logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
            quoteLine1: "Indulge in the extraordinary;",
            quoteLine2: "life's too short for ordinary",
            contact: {
              website: "www.zorbastays.com",
              email: "info@zorbastays.com",
              phones: "63552-31066, 98750-28066",
            },
          },
        };

        const hasValidImages = (images) => {
          if (!images || !Array.isArray(images)) return false;
          return images.some(
            (img) => img && img.trim() !== "" && img !== "null",
          );
        };

        // const pagesConfig = [
        //   { id: "cover", condition: true },
        //   {
        //     id: "amenities",
        //     condition:
        //       Property.amenities.items && Property.amenities.items.length > 0,
        //   },
        //   {
        //     id: "theVilla",
        //     condition:
        //       Property.theVilla.image &&
        //       Property.theVilla.image.trim() !== "" &&
        //       Property.theVilla.image !== "null",
        //   },
        //   { id: "curation", condition: true },
        //   { id: "gallery", condition: hasValidImages(Property.gallery.images) },
        //   {
        //     id: "living",
        //     condition:
        //       Property.living.livingImage &&
        //       Property.living.livingImage.trim() !== "" &&
        //       Property.living.livingImage !== "null",
        //   },
        //   {
        //     id: "kitchenDining",
        //     condition: hasValidImages(Property.kitchenDining.images),
        //   },
        //   {
        //     id: "bedrooms",
        //     condition:
        //       Property.bedrooms.bedroomImage &&
        //       Property.bedrooms.bedroomImage.trim() !== "" &&
        //       Property.bedrooms.bedroomImage !== "null",
        //   },
        //   {
        //     id: "bedroomGallery",
        //     condition: hasValidImages(Property.bedroomGallery.images),
        //   },
        //   {
        //     id: "bedroomGallery2",
        //     condition: hasValidImages(Property.bedroomGallery2.images),
        //   },
        //   {
        //     id: "bedroomGalleryMixed",
        //     condition: hasValidImages(Property.bedroomGalleryMixed.images),
        //   },
        //   {
        //     id: "bedroomGalleryMixed2",
        //     condition: hasValidImages(Property.bedroomGalleryMixed2.images),
        //   },
        //   {
        //     id: "bedroomGalleryMixed3",
        //     condition: hasValidImages(Property.bedroomGalleryMixed3.images),
        //   },
        //   {
        //     id: "bedroomGallery3",
        //     condition: hasValidImages(Property.bedroomGallery3.images),
        //   },
        //   {
        //     id: "commonareas",
        //     condition: hasValidImages(Property.commonareas.images),
        //   },
        //   {
        //     id: "bedroomGallery4",
        //     condition: hasValidImages(Property.bedroomGallery4.images),
        //   },
        //   {
        //     id: "bedroomGallery5",
        //     condition: hasValidImages(Property.bedroomGallery5.images),
        //   },
        //   {
        //     id: "bedroomGalleryMixed4",
        //     condition: hasValidImages(Property.bedroomGalleryMixed4.images),
        //   },
        //   {
        //     id: "bedroomGallery6",
        //     condition: hasValidImages(Property.bedroomGallery6.images),
        //   },
        //   {
        //     id: "bedroomGallery7",
        //     condition: hasValidImages(Property.bedroomGallery7.images),
        //   },
        //   { id: "services", condition: true },
        //   { id: "aboutZorba", condition: true },
        //   { id: "backCover", condition: true },
        // ];

        // Filter to only pages that pass their condition

        const pagesConfig = [
          { id: "cover", condition: true },
          {
            id: "amenities",
            condition:
              Property.amenities.items && Property.amenities.items.length > 0,
          },
          {
            id: "theVilla",
            condition: true,
          },
          { id: "curation", condition: true },
          { id: "gallery", condition: true },
          {
            id: "living",
            condition: true,
          },
          {
            id: "kitchenDining",
            condition: true,
          },
          {
            id: "bedrooms",
            condition: true,
          },
          {
            id: "bedroomGallery",
            condition: true,
          },
          {
            id: "bedroomGallery2",
            condition: hasValidImages(Property.bedroomGallery2.images),
          },
          {
            id: "bedroomGalleryMixed",
            condition: hasValidImages(Property.bedroomGalleryMixed.images),
          },
          {
            id: "bedroomGalleryMixed2",
            condition: hasValidImages(Property.bedroomGalleryMixed2.images),
          },
          {
            id: "bedroomGalleryMixed3",
            condition: hasValidImages(Property.bedroomGalleryMixed3.images),
          },
          {
            id: "bedroomGallery3",
            condition: hasValidImages(Property.bedroomGallery3.images),
          },
          {
            id: "commonareas",
            condition: hasValidImages(Property.commonareas.images),
          },
          {
            id: "bedroomGallery4",
            condition: hasValidImages(Property.bedroomGallery4.images),
          },
          {
            id: "bedroomGallery5",
            condition: hasValidImages(Property.bedroomGallery5.images),
          },
          {
            id: "bedroomGalleryMixed4",
            condition: hasValidImages(Property.bedroomGalleryMixed4.images),
          },
          {
            id: "bedroomGallery6",
            condition: hasValidImages(Property.bedroomGallery6.images),
          },
          {
            id: "bedroomGallery7",
            condition: hasValidImages(Property.bedroomGallery7.images),
          },
          { id: "services", condition: true },
          { id: "aboutZorba", condition: true },
          { id: "backCover", condition: true },
        ];
        const filteredPages = pagesConfig.filter((page) => page.condition);

        // Build a lookup: pageId → index in filteredPages
        // e.g. "afterPage9" means after the page at index 9 (1-based) → insert after filteredPages[8]
        // The section string is like "afterPage9", "afterPage16", etc.
        const parseAfterIndex = (section) => {
          const match = section?.match(/afterPage(\d+)/);
          if (!match) return null;
          const n = parseInt(match[1]);
          // If the requested page number exceeds filtered list, insert before backCover
          return Math.min(n, filteredPages.length - 1);
        };
        const sectionToPageId = {
          afterBedroomGallery: "bedroomGallery",
          afterBedroomGallery4: "bedroomGallery4",
        };
        // Build the final ordered list with dynamic pages inserted at right spots
        // We insert dynamic pages AFTER the Nth page in the filtered list
        // Collect all dynamic insertions grouped by target index
        const insertions = {}; // { afterIndex: [dynamicId, ...] }

        // dynamicPagesData.forEach((page, index) => {
        //   const hasImages =
        //     page.images &&
        //     page.images.length > 0 &&
        //     page.images.some(
        //       (img) => img && img.trim() !== "" && img !== "null",
        //     );
        //   if (!hasImages) return;

        //   const anchorPageId = sectionToPageId[page.section];
        //   if (!anchorPageId) return;

        //   if (!insertions[anchorPageId]) insertions[anchorPageId] = [];
        //   insertions[anchorPageId].push(`dynamic_${index}`);
        // });

        // Build final list - inject after the matching page ID

        // NEW - always show dynamic pages if they have a layout assigned
        dynamicPagesData.forEach((page, index) => {
          // Only skip if there's no section/anchor defined — not based on image content
          const anchorPageId = sectionToPageId[page.section];
          if (!anchorPageId) return;

          if (!insertions[anchorPageId]) insertions[anchorPageId] = [];
          insertions[anchorPageId].push(`dynamic_${index}`);
        });
        const finalPages = [];
        filteredPages.forEach((page) => {
          finalPages.push(page.id);
          if (insertions[page.id]) {
            insertions[page.id].forEach((dynId) => finalPages.push(dynId));
          }
        });

        setPagesToRender(finalPages);
      } catch (err) {
        console.error("Fetch error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBrochure();
  }, [id]);

  const loadingMessages = [
    "Loading brochure...",
    "Please wait...",
    "Getting brochure ready...",
  ];
  const [loadingMsgIndex, setLoadingMsgIndex] = useState(0);

  useEffect(() => {
    if (!loading) return;
    const interval = setInterval(() => {
      setLoadingMsgIndex((prev) => (prev + 1) % loadingMessages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [loading]);
  if (loading) {
    return (
      <div className="flex bg-[#F8F9FA] min-h-screen">
        <main
          className={`flex-1 flex items-center justify-center transition-all duration-500 ${isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"}`}
        >
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-green-600 mx-auto mb-4"></div>
            <p className="text-gray-600 text-lg">
              {" "}
              {loadingMessages[loadingMsgIndex]}
            </p>
          </div>
        </main>
      </div>
    );
  }
  if (error)
    return (
      <div className="flex items-center justify-center min-h-screen text-red-500">
        {error}
      </div>
    );
  if (!brochure) return null;
  const fillText = (text, maxChars = 100) => {
    if (text && text.trim() !== "" && text !== "null") return text;
    const block = "#####";
    const unit = block + " "; // "##### " = 6 chars
    let result = "";
    while (result.length + block.length <= maxChars) {
      result += unit;
    }
    return result.trimEnd();
  };
  // const Property = {
  //   villa: {
  //     logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
  //     title: brochure.villa_name,
  //     text: brochure.top_text,
  //     mainImage: brochure.img_page1,
  //     signature: brochure.location,
  //     contact: {
  //       website: "www.zorbastays.com",
  //       email: "info@zorbastays.com",
  //       phones: "63552-31066, 98750-28066",
  //     },
  //   },
  //   amenities: {
  //     logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
  //     items: amenities.map((a) => ({
  //       name: a.name,
  //       imgSrc: a.url,
  //     })),
  //   },
  //   theVilla: {
  //     logo: "https://zorbastays.com/android-chrome-512x512.png",
  //     image: brochure.img_page3,
  //     villaTitle1: brochure.the_title_prefix,
  //     villaTitle2: brochure.villa_title_prefix,
  //     paragraph1: brochure.villa_desc1,
  //     paragraph2: brochure.villa_desc2,
  //   },
  //   // curation: {
  //   //   title: brochure.the_title,
  //   //   footerWebsite: "www.zorbastays.com",
  //   //   steps: [
  //   //     { heading: brochure.curate_title1, description: brochure.curate_desc1 },
  //   //     { heading: brochure.curate_title2, description: brochure.curate_desc2 },
  //   //     { heading: brochure.curate_title3, description: brochure.curate_desc3 },
  //   //     { heading: brochure.curate_title4, description: brochure.curate_desc4 },
  //   //     { heading: brochure.curate_title5, description: brochure.curate_desc5 },
  //   //   ],
  //   // },
  //   curation: {
  //     title: "The way we curate.",
  //     footerWebsite: "www.zorbastays.com",
  //     steps: [
  //       {
  //         heading: "We Choose with Care",
  //         description:
  //           "Every Zorba stay is personally verified for its design, service, and sense of place.",
  //       },
  //       {
  //         heading: "We Understand Your \n “Why” Before the “Where”",
  //         description:
  //           "Every journey begins with intent. We craft stays that reflect your purpose, your people, and the memories you seek to create.",
  //       },
  //       {
  //         heading: "We’re Your Constant \n Point of Support",
  //         description:
  //           "From the first conversation to your final day, our team ensures every detail flows seamlessly.",
  //       },
  //       {
  //         heading: "We Bring Access, Not Aggregation",
  //         description:
  //           "Our collection opens doors to stays and experiences you won’t find online, offered through trust and discovery.",
  //       },
  //       {
  //         heading: "Beyond Travel — \n We Stay in Touch",
  //         description:
  //           "We stay connected beyond your travels — inspiring your next journey with new destinations and discoveries.",
  //       },
  //     ],
  //   },
  //   gallery: {
  //     signature: brochure.pool_title,
  //     logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
  //     images: [
  //       brochure.img_page5_1,
  //       brochure.img_page5_2,
  //       brochure.img_page5_3,
  //     ],
  //   },
  //   living: {
  //     logo: "https://zorbastays.com/android-chrome-512x512.png",
  //     livingImage: brochure.img_page6,
  //     livingtitle1: brochure.the_title,
  //     livingtitle2: brochure.living_title,
  //     paragraph1: brochure.living_desc1,
  //     paragraph2: brochure.living_desc2,
  //   },
  //   kitchenDining: {
  //     title: brochure.kitchen_title,
  //     images: [brochure.img_page7_1, brochure.img_page7_2],
  //   },
  //   bedrooms: {
  //     logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
  //     bedroomImage: brochure.img_page8,
  //     bedroomtitle1: brochure.the_bed_title,
  //     bedroomtitle2: brochure.bedroom_title,
  //     paragraph1: brochure.bed_desc1,
  //     paragraph2: brochure.bed_desc2,
  //   },
  //   bedroomGallery: { images: [brochure.img_page9_1, brochure.img_page9_2] },
  //   bedroomGallery2: { images: [brochure.img_page10_1, brochure.img_page10_2] },
  //   bedroomGalleryMixed: {
  //     images: [
  //       brochure.img_page11_1,
  //       brochure.img_page11_2,
  //       brochure.img_page11_3,
  //     ],
  //   },
  //   bedroomGalleryMixed2: {
  //     images: [
  //       brochure.img_page12_1,
  //       brochure.img_page12_2,
  //       brochure.img_page12_3,
  //     ],
  //   },
  //   bedroomGalleryMixed3: {
  //     images: [
  //       brochure.img_page13_1,
  //       brochure.img_page13_2,
  //       brochure.img_page13_3,
  //     ],
  //   },
  //   bedroomGallery3: { images: [brochure.img_page14_1, brochure.img_page14_2] },
  //   commonareas: {
  //     title: brochure.common_areas,
  //     images: [brochure.img_page15_1, brochure.img_page15_2],
  //   },
  //   bedroomGallery4: { images: [brochure.img_page16_1, brochure.img_page16_2] },
  //   bedroomGallery5: { images: [brochure.img_page17_1, brochure.img_page17_2] },
  //   bedroomGalleryMixed4: {
  //     images: [
  //       brochure.img_page18_1,
  //       brochure.img_page18_2,
  //       brochure.img_page18_3,
  //     ],
  //   },
  //   bedroomGallery6: { images: [brochure.img_page19_1, brochure.img_page19_2] },
  //   bedroomGallery7: { images: [brochure.img_page20_1, brochure.img_page20_2] },
  //   services: {
  //     section1: {
  //       title: brochure.destination,
  //       description: brochure.destination_desc,
  //       bannerText: brochure.travel_title,
  //       link: brochure.travel_link,
  //     },
  //     section2: {
  //       title: brochure.service,
  //       description: brochure.service_desc,
  //       bannerText: brochure.concierge_title,
  //       link: brochure.concierge_link,
  //     },
  //   },
  //   aboutZorba: {
  //     heading: brochure.nature,
  //     paragraph1: brochure.nature_desc1,
  //     paragraph2: brochure.nature_desc2,
  //     paragraph3: brochure.nature_desc3,

  //   },
  //   backCover: {
  //     logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
  //     quoteLine1: "Indulge in the extraordinary;",
  //     quoteLine2: "life's too short for ordinary",
  //     contact: {
  //       website: "www.zorbastays.com",
  //       email: "info@zorbastays.com",
  //       phones: "63552-31066, 98750-28066",
  //     },
  //   },
  // };
  const Property = {
    villa: {
      logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
      title: fillText(brochure.villa_name, 40),
      text: fillText(brochure.top_text, 60),
      mainImage: brochure.img_page1,
      signature: fillText(brochure.location, 30),
      contact: {
        website: "www.zorbastays.com",
        email: "info@zorbastays.com",
        phones: "63552-31066, 98750-28066",
      },
    },

    amenities: {
      logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
      items: amenities.map((a) => ({
        name: a.name,
        imgSrc: a.url,
      })),
    },

    theVilla: {
      logo: "https://zorbastays.com/android-chrome-512x512.png",
      image: brochure.img_page3,
      villaTitle1: fillText(brochure.the_title_prefix, 30),
      villaTitle2: fillText(brochure.villa_title_prefix, 40),
      paragraph1: fillText(brochure.villa_desc1, 500),
      paragraph2: fillText(brochure.villa_desc2, 500),
    },

    curation: {
      title: "The way we curate.",
      footerWebsite: "www.zorbastays.com",
      steps: [
        {
          heading: "We Choose with Care",
          description:
            "Every Zorba stay is personally verified for its design, service, and sense of place.",
        },
        {
          heading:
            "We Understand Your \n \u201cWhy\u201d Before the \u201cWhere\u201d",
          description:
            "Every journey begins with intent. We craft stays that reflect your purpose, your people, and the memories you seek to create.",
        },
        {
          heading: "We\u2019re Your Constant \n Point of Support",
          description:
            "From the first conversation to your final day, our team ensures every detail flows seamlessly.",
        },
        {
          heading: "We Bring Access, Not Aggregation",
          description:
            "Our collection opens doors to stays and experiences you won\u2019t find online, offered through trust and discovery.",
        },
        {
          heading: "Beyond Travel \u2014 \n We Stay in Touch",
          description:
            "We stay connected beyond your travels \u2014 inspiring your next journey with new destinations and discoveries.",
        },
      ],
    },

    gallery: {
      signature: fillText(brochure.pool_title, 40),
      logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
      images: [
        brochure.img_page5_1,
        brochure.img_page5_2,
        brochure.img_page5_3,
      ],
    },

    living: {
      logo: "https://zorbastays.com/android-chrome-512x512.png",
      livingImage: brochure.img_page6,
      livingtitle1: fillText(brochure.the_title, 30),
      livingtitle2: fillText(brochure.living_title, 40),
      paragraph1: fillText(brochure.living_desc1, 500),
      paragraph2: fillText(brochure.living_desc2, 500),
    },

    kitchenDining: {
      title: fillText(brochure.kitchen_title, 40),
      images: [brochure.img_page7_1, brochure.img_page7_2],
    },

    bedrooms: {
      logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
      bedroomImage: brochure.img_page8,
      bedroomtitle1: fillText(brochure.the_bed_title, 30),
      bedroomtitle2: fillText(brochure.bedroom_title, 40),
      paragraph1: fillText(brochure.bed_desc1, 500),
      paragraph2: fillText(brochure.bed_desc2, 500),
    },

    // Gallery pages — images only, no text fields
    bedroomGallery: { images: [brochure.img_page9_1, brochure.img_page9_2] },
    bedroomGallery2: { images: [brochure.img_page10_1, brochure.img_page10_2] },
    bedroomGalleryMixed: {
      images: [
        brochure.img_page11_1,
        brochure.img_page11_2,
        brochure.img_page11_3,
      ],
    },
    bedroomGalleryMixed2: {
      images: [
        brochure.img_page12_1,
        brochure.img_page12_2,
        brochure.img_page12_3,
      ],
    },
    bedroomGalleryMixed3: {
      images: [
        brochure.img_page13_1,
        brochure.img_page13_2,
        brochure.img_page13_3,
      ],
    },
    bedroomGallery3: { images: [brochure.img_page14_1, brochure.img_page14_2] },
    bedroomGallery4: { images: [brochure.img_page16_1, brochure.img_page16_2] },
    bedroomGallery5: { images: [brochure.img_page17_1, brochure.img_page17_2] },
    bedroomGalleryMixed4: {
      images: [
        brochure.img_page18_1,
        brochure.img_page18_2,
        brochure.img_page18_3,
      ],
    },
    bedroomGallery6: { images: [brochure.img_page19_1, brochure.img_page19_2] },
    bedroomGallery7: { images: [brochure.img_page20_1, brochure.img_page20_2] },

    commonareas: {
      title: fillText(brochure.common_areas, 40),
      images: [brochure.img_page15_1, brochure.img_page15_2],
    },

    services: {
      section1: {
        title: fillText(brochure.destination, 60),
        description: fillText(brochure.destination_desc, 500),
        bannerText: fillText(brochure.travel_title, 60),
        link: brochure.travel_link, // links — never fill with hashes
      },
      section2: {
        title: fillText(brochure.service, 60),
        description: fillText(brochure.service_desc, 500),
        bannerText: fillText(brochure.concierge_title, 60),
        link: brochure.concierge_link, // links — never fill with hashes
      },
    },

    aboutZorba: {
      heading: fillText(brochure.nature, 80),
      paragraph1: fillText(brochure.nature_desc1, 500),
      paragraph2: fillText(brochure.nature_desc2, 500),
      paragraph3: fillText(brochure.nature_desc3, 500),
    },

    backCover: {
      logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
      quoteLine1: "Indulge in the extraordinary;", // hardcoded — no fill needed
      quoteLine2: "life's too short for ordinary", // hardcoded — no fill needed
      contact: {
        website: "www.zorbastays.com",
        email: "info@zorbastays.com",
        phones: "63552-31066, 98750-28066",
      },
    },
  };
  const handleDownload = () => {
    window.print();
  };

  // Render dynamic page based on layout
  const renderDynamicPage = (dynamicPage, index) => {
    const { layout, images, section } = dynamicPage;
    if (!images || images.length === 0) return null;

    if (layout === "layout1") {
      return (
        <div
          key={`dynamic_${index}`}
          className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative overflow-hidden"
        >
          <div className="w-full h-full flex flex-col relative pt-16 px-1">
            <div className="flex flex-col space-y-6 w-full">
              <div className="h-[450px] overflow-hidden">
                <img
                  src={
                    images[0] ||
                    "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                  }
                  alt="Dynamic 1"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="h-[420px] overflow-hidden">
                <img
                  src={
                    images[1] ||
                    "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                  }
                  // src={images[1]||" https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/e6cae93f-fd4e-4ace-9187-a7430d2dd000/public"}
                  alt="Dynamic 2"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (layout === "layout2") {
      return (
        <div
          key={`dynamic_${index}`}
          className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative overflow-hidden"
        >
          <div className="w-full h-full flex flex-col relative pt-10 px-1">
            <div className="flex flex-col space-y-4 w-full h-full pb-16">
              <div className="w-full h-[450px] overflow-hidden">
                <img
                  src={
                    images[0] ||
                    "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                  }
                  alt="Dynamic 1"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex space-x-4 w-full h-[450px]">
                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      images[1] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Dynamic 2"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      images[2] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Dynamic 3"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (layout === "layout3") {
      return (
        <div
          key={`dynamic_${index}`}
          className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative overflow-hidden"
        >
          <div className="w-full h-full flex flex-col relative pt-10 px-1">
            <div className="flex flex-col space-y-4 w-full h-full pb-16">
              <div className="w-full h-[450px] overflow-hidden">
                <img
                  src={
                    images[0] ||
                    "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                  }
                  alt="Dynamic 1"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex space-x-4 w-full items-start">
                <div className="flex-1 h-[300px] overflow-hidden">
                  <img
                    src={
                      images[1] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Dynamic 2"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 h-[450px] overflow-hidden">
                  <img
                    src={
                      images[2] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Dynamic 3"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  const renderPage = (pageId) => {
    // Check if it's a dynamic page
    if (pageId.startsWith("dynamic_")) {
      const index = parseInt(pageId.split("_")[1]);
      const dynamicPage = dynamicPages[index];
      if (dynamicPage) {
        return renderDynamicPage(dynamicPage, index);
      }
      return null;
    }

    switch (pageId) {
      case "cover":
        return (
          <div
            key="cover"
            className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative flex flex-col items-center p-12"
          >
            <div className="absolute top-0 left-12 w-[1px] h-80 bg-gray-400"></div>
            <div className="absolute top-0 left-20 w-[1px] h-60 bg-gray-400"></div>

            <div className="mt-8 flex flex-col items-center">
              <img
                src={Property.villa.logo}
                alt={Property.villa.title}
                className="h-28 w-auto object-contain"
              />
            </div>

            <h2 className="mt-20 text-4xl PlayfairDisplay text-gray-800 tracking-wide">
              {Property.villa.title}
            </h2>

            <div className="mt-20 w-full relative group px-4">
              <p className="montserrat absolute -top-4 right-4 text-[10px] tracking-[0.2em] text-gray-800 uppercase">
                {Property.villa.text}
              </p>

              <div className="w-full aspect-[4/3] bg-gray-200 overflow-hidden">
                <img
                  src={
                    Property.villa.mainImage ||
                    "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                  }
                  alt={Property.villa.title}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="absolute -mt-2 right-0 transform z-10">
                <span className="windsong text-7xl text-gray-900">
                  {Property.villa.signature}
                </span>
              </div>
            </div>

            <div className="montserrat absolute bottom-3">
              <div className="flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
                <a
                  href={`https://zorbastays.com/`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>{Property.villa.contact.website}</span>
                </a>
                <span className="h-3 w-[1px] bg-gray-400"></span>
                <a href={`mailto:info@zorbastays.com`}>
                  <span>{Property.villa.contact.email}</span>
                </a>
                <span className="h-3 w-[1px] bg-gray-400"></span>
                <span>{Property.villa.contact.phones}</span>
              </div>
            </div>
          </div>
        );

      case "amenities":
        if (!Property.amenities.items.length) return null;
        return Array.from(
          { length: Math.ceil(Property.amenities.items.length / 10) },
          (_, i) => Property.amenities.items.slice(i * 10, i * 10 + 10),
        ).map((amenityGroup, pageIndex, allPages) => (
          <div
            key={`amenities-${pageIndex}`}
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative flex flex-col"
          >
            {pageIndex === 0 && (
              <div className="mt-8 ml-6 flex-none">
                <h1 className="text-3xl EBGaramond text-gray-800">The</h1>
                <h2 className="text-4xl PlayfairDisplay tracking-widest text-gray-800 uppercase mt-2">
                  Amenities
                </h2>
              </div>
            )}

            <div
              className={`flex-grow flex items-start justify-center ${pageIndex === 0 ? "pt-20" : "pt-32"}`}
            >
              <div className="grid grid-cols-2 gap-y-12 gap-x-12 px-4 w-full">
                {amenityGroup.map((item, index) => (
                  <div key={index} className="flex items-center space-x-6">
                    <div className="w-24 h-24 flex items-center justify-center flex-none">
                      <img
                        src={item.imgSrc}
                        alt={item.name}
                        className="max-w-full max-h-full object-contain brightness-0 grayscale"
                      />
                    </div>
                    <span className="text-[11px] font-medium tracking-[0.2em] uppercase text-gray-800 leading-tight">
                      {item.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            {pageIndex === allPages.length - 1 && (
              <div className="mt-auto mb-4 flex justify-center items-center space-x-4">
                <div className="w-12 h-[1px] bg-gray-400"></div>
                <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
                  <img
                    src={Property.amenities.logo}
                    alt="logo"
                    className="w-8 h-5 brightness-0"
                  />
                </div>
                <div className="w-12 h-[1px] bg-gray-400"></div>
              </div>
            )}
          </div>
        ));

      case "theVilla":
        return (
          <div
            key="theVilla"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            {(() => {
              const totalChars =
                (Property.theVilla.paragraph1?.length || 0) +
                (Property.theVilla.paragraph2?.length || 0);

              const imageBottom =
                totalChars > 600 ? "bottom-[40px]" : "bottom-[170px]";
              const logoBottom =
                totalChars > 600 ? "bottom-[20px]" : "bottom-[70px]";

              return (
                <>
                  <div className="mb-8 ml-1">
                    <h1 className="text-3xl EBGaramond text-gray-800 leading-tight">
                      {Property.theVilla.villaTitle1}
                    </h1>
                    <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2">
                      {Property.theVilla.villaTitle2}
                    </h2>
                  </div>

                  <div
                    className="montserrat flex flex-col ml-1 space-y-6 text-gray-800 tracking-widest text-base text-justify max-w-[100%]"
                    style={{ wordSpacing: "1px" }}
                  >
                    <p>{Property.theVilla.paragraph1}</p>
                    <p>{Property.theVilla.paragraph2}</p>
                  </div>

                  <div
                    className={`absolute left-12 right-12 h-[430px] z-20 ${imageBottom}`}
                  >
                    <img
                      src={
                        Property.theVilla.image ||
                        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                      }
                      alt="Villa Exterior"
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <div
                    className={`absolute left-8 w-28 h-28 opacity-20 grayscale z-20 ${logoBottom}`}
                  >
                    <img
                      src={Property.theVilla.logo}
                      alt="Logo Watermark"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </>
              );
            })()}
          </div>
        );

      case "curation":
        return (
          <div
            key="curation"
            className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col pt-10 px-16 relative">
              <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-20 -ml-5">
                The way we curate.
              </h2>

              <div className="relative w-full flex-1">
                <div className="absolute -top-16 mt-4 -right-5 inset-0 flex justify-center pointer-events-none">
                  <img
                    src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/3ea0d39f-9e34-4305-7ea0-07304c880a00/public"
                    alt="timeline"
                    className="opacity-60 w-auto h-[750px] object-contain"
                  />
                </div>

                <div className="relative z-10 flex flex-col space-y-3">
                  {Property.curation.steps?.map((step, idx) => (
                    <div
                      key={idx}
                      className={`max-w-auto ${
                        idx === 0
                          ? "ml-5 self-start max-w-[180px]"
                          : idx === 1
                            ? "w-full self-end mr-20 relative -top-8 max-w-[230px]"
                            : idx === 2
                              ? "w-full self-end mr-36 relative top-16 max-w-[240px]"
                              : idx === 3
                                ? "w-full self-start relative ml-8 top-20 max-w-[240px]"
                                : idx === 4
                                  ? "w-full self-end relative mr-5 top-36 max-w-[230px]"
                                  : ""
                      }`}
                    >
                      <h3 className="PlayfairDisplay text-xl text-gray-800 leading-tight mb-2 whitespace-pre-line">
                        {step.heading}
                      </h3>

                      <p className="montserrat text-[13px] text-gray-800 leading-relaxed tracking-wide">
                        {step.description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="absolute -bottom-56 left-0 w-full text-center">
                <a
                  href="https://zorbastays.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-[15px] tracking-[0.1em] text-gray-500">
                    {Property.curation.footerWebsite}
                  </span>
                </a>
              </div>
            </div>
          </div>
        );

      case "gallery":
        return (
          <div
            key="gallery"
            className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12"
          >
            <div className="w-full h-full flex flex-col relative">
              <div className="absolute -top-20 left-6 w-[1px] h-[280px] bg-gray-400"></div>

              <div className="flex flex-col items-end z-10 mt-24">
                <span className="waterfall text-7xl text-gray-900 text-right max-w-[90%]">
                  {Property.gallery.signature}
                </span>
              </div>

              <div className="w-full flex flex-row space-x-4">
                <div className="flex flex-col space-y-4 w-[65%]">
                  <div className="aspect-[16/12] overflow-hidden">
                    <img
                      src={
                        Property.gallery.images[0] ||
                        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                      }
                      alt="Pool view 1"
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <div className="aspect-[16/12] overflow-hidden">
                    <img
                      src={
                        Property.gallery.images[1] ||
                        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                      }
                      alt="Archway view"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                <div className="flex-1 h-[400px] overflow-hidden">
                  <img
                    src={
                      Property.gallery.images[2] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Pool view 2"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="absolute -bottom-40 w-full flex justify-center items-center space-x-4">
                <div className="w-12 h-[1.5px] bg-gray-400"></div>
                <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
                  <img
                    src={Property.gallery.logo}
                    alt={Property.gallery.title}
                    className="w-8 h-5 brightness-0"
                  />
                </div>
                <div className="w-12 h-[1.5px] bg-gray-400"></div>
              </div>
            </div>
          </div>
        );

      case "living":
        return (
          <div
            key="living"
            className="print-page bg-[#f8f7f6] w-[210mm] h-[297mm] p-12 pt-20 flex flex-col shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full relative flex flex-col px-1 pt-10">
              {/* Watermark */}
              <div
                className="absolute -top-10 right-0 w-[430px] h-[430px] opacity-5 pointer-events-none translate-x-14 -translate-y-14"
                style={{ wordSpacing: "4px" }}
              >
                <img
                  src={Property.living.logo}
                  alt="Watermark"
                  className="w-full h-full object-contain grayscale"
                />
              </div>

              {/* Content */}
              <div className="relative z-10 flex flex-col h-full">
                {/* Heading */}
                <div>
                  <h1 className="text-3xl EBGaramond text-gray-800 leading-tight">
                    {Property.living.livingtitle1}
                  </h1>

                  <h2 className="text-4xl PlayfairDisplay text-gray-800 tracking-widest uppercase mb-8">
                    {Property.living.livingtitle2}
                  </h2>

                  {/* Paragraphs */}
                  <div className="montserrat flex flex-col space-y-6 text-gray-800 text-[15px] tracking-widest max-w-[100%]">
                    <p>{Property.living.paragraph1}</p>
                    <p>{Property.living.paragraph2}</p>
                  </div>
                </div>

                {/* Bottom Fixed Image */}
                <div className="absolute left-0 right-0 bottom-20 h-[460px]">
                  <div className="w-full h-[460px] overflow-hidden border-2 border-gray-300">
                    <img
                      src={
                        Property.living.livingImage ||
                        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                      }
                      alt="Living Area"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>

              {/* Bottom Lines */}
              <div className="absolute -bottom-16 left-12 flex gap-6">
                <div className="w-[1px] h-36 bg-gray-400"></div>
                <div className="w-[1px] h-36 bg-gray-400"></div>
              </div>
            </div>
          </div>
        );

      case "kitchenDining":
        return (
          <div
            key="kitchenDining"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col relative pt-10 px-1">
              <div className="absolute top-4 right-1 z-20">
                <span className="waterfall text-7xl text-gray-900 drop-shadow-sm">
                  {Property.kitchenDining.title}
                </span>
              </div>

              <div className="flex flex-col space-y-6 w-full h-full pt-20">
                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.kitchenDining.images[0] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Kitchen Area"
                    className="w-full h-[420px] object-cover"
                  />
                </div>

                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.kitchenDining.images[1] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Dining Area"
                    className="w-full h-[420px] object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "bedrooms":
        return (
          <div
            key="bedrooms"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col px-1 pt-20 relative">
              <div className="mb-8">
                <h1 className="text-3xl EBGaramond text-gray-800 leading-tight">
                  {Property.bedrooms.bedroomtitle1}
                </h1>
                <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2 tracking-wide">
                  {Property.bedrooms.bedroomtitle2}
                </h2>
              </div>

              <div
                className="montserrat flex flex-col space-y-8 text-gray-800 tracking-widest text-[14px] text-justify max-w-[95%] leading-relaxed"
                style={{ wordSpacing: "1px" }}
              >
                <p>{Property.bedrooms.paragraph1}</p>
                <p>{Property.bedrooms.paragraph2}</p>
              </div>

              <div className="mt-10 w-full aspect-[16/11] overflow-hidden">
                <img
                  src={
                    Property.bedrooms.bedroomImage ||
                    "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                  }
                  alt="Bedroom Interior"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="absolute -bottom-12 left-0 w-full flex justify-center items-center space-x-4">
                <div className="w-12 h-[2px] bg-gray-400"></div>
                <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
                  <img
                    src={Property.bedrooms.logo}
                    alt="Logo"
                    className="w-7 h-5 brightness-0 opacity-70"
                  />
                </div>
                <div className="w-12 h-[2px] bg-gray-400"></div>
              </div>
            </div>
          </div>
        );

      case "bedroomGallery":
        return (
          <div
            key="bedroomGallery"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col relative pt-10 px-1">
              <div className="flex flex-col space-y-4 w-full h-full pt-10">
                <div className="flex-1 overflow-hidden shadow-sm">
                  <img
                    src={
                      Property.bedroomGallery.images[0] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 1"
                    className="w-full h-[450px] object-cover"
                  />
                </div>

                <div className="flex-1 overflow-hidden shadow-sm">
                  <img
                    src={
                      Property.bedroomGallery.images[1] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 2"
                    className="w-full h-[420px] object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "bedroomGallery2":
        return (
          <div
            key="bedroomGallery2"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col relative pt-10 px-1">
              <div className="flex flex-col space-y-4 w-full h-full pt-10">
                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.bedroomGallery2.images[0] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 1"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.bedroomGallery2.images[1] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 2"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "bedroomGalleryMixed":
        return (
          <div
            key="bedroomGalleryMixed"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col relative pt-5 px-1">
              <div className="flex flex-col space-y-4 w-full h-full pb-10">
                <div className="w-full h-[45%] overflow-hidden">
                  <img
                    src={
                      Property.bedroomGalleryMixed.images[0] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Master Bedroom View"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex space-x-4 w-full h-[45%]">
                  <div className="flex-1 overflow-hidden">
                    <img
                      src={
                        Property.bedroomGalleryMixed.images[1] ||
                        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                      }
                      alt="Bedroom Seating"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 overflow-hidden">
                    <img
                      src={
                        Property.bedroomGalleryMixed.images[2] ||
                        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                      }
                      alt="Bedroom Detail"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case "bedroomGalleryMixed2":
        return (
          <div
            key="bedroomGalleryMixed2"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col relative pt-0 px-1">
              <div className="flex flex-col space-y-4 w-full h-full pb-16">
                <div className="w-full h-[45%] overflow-hidden">
                  <img
                    src={
                      Property.bedroomGalleryMixed2.images[0] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Master Bedroom View"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex space-x-4 w-full h-[45%]">
                  <div className="flex-1 overflow-hidden">
                    <img
                      src={
                        Property.bedroomGalleryMixed2.images[1] ||
                        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                      }
                      alt="Bedroom Seating"
                      className="w-full h-[25vh] object-cover"
                    />
                  </div>
                  <div className="flex-1 overflow-hidden">
                    <img
                      src={
                        Property.bedroomGalleryMixed2.images[2] ||
                        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                      }
                      alt="Bedroom Detail"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case "bedroomGalleryMixed3":
        return (
          <div
            key="bedroomGalleryMixed3"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col relative pt-5 px-1">
              <div className="flex flex-col space-y-4 w-full h-full pb-16">
                <div className="w-full h-[45%] overflow-hidden">
                  <img
                    src={
                      Property.bedroomGalleryMixed3.images[0] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Master Bedroom View"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex space-x-4 w-full h-[45%]">
                  <div className="flex-1 overflow-hidden">
                    <img
                      src={
                        Property.bedroomGalleryMixed3.images[1] ||
                        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                      }
                      alt="Bedroom Seating"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 overflow-hidden">
                    <img
                      src={
                        Property.bedroomGalleryMixed3.images[2] ||
                        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                      }
                      alt="Bedroom Detail"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case "bedroomGallery3":
        return (
          <div
            key="bedroomGallery3"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col relative pt-10 px-1">
              <div className="flex flex-col space-y-4 w-full h-full pt-10">
                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.bedroomGallery3.images[0] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 1"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.bedroomGallery3.images[1] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 2"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "commonareas":
        return (
          <div
            key="commonareas"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col relative pt-10 px-1">
              <div className="absolute top-0 left-6 z-20 flex items-center w-full">
                <span className="waterfall text-7xl text-gray-800 pr-6">
                  {Property.commonareas.title}
                </span>
                <div className="flex-1 h-[1px] bg-gray-400 -mr-6"></div>
              </div>

              <div className="absolute top-24 left-3 w-[1px] h-[970px] bg-gray-400"></div>

              <div className="flex flex-col space-y-4 w-full h-[950px] pt-28 pl-16">
                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.commonareas.images[0] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Common Area Overview"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.commonareas.images[1] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Lounge and Staircase"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "bedroomGallery4":
        return (
          <div
            key="bedroomGallery4"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col relative pt-5 px-1">
              <div className="flex flex-col space-y-4 w-full h-full pt-10">
                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.bedroomGallery4.images[0] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 1"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.bedroomGallery4.images[1] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 2"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "bedroomGallery5":
        return (
          <div
            key="bedroomGallery5"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col relative pt-10 px-1">
              <div className="flex flex-col space-y-4 w-full h-full pt-10">
                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.bedroomGallery5.images[0] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 1"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.bedroomGallery5.images[1] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 2"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "bedroomGalleryMixed4":
        return (
          <div
            key="bedroomGalleryMixed4"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col relative pt-5 px-1">
              <div className="flex flex-col space-y-4 w-full h-full pb-16">
                <div className="w-full h-[45%] overflow-hidden">
                  <img
                    src={
                      Property.bedroomGalleryMixed4.images[0] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Master Bedroom View"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex space-x-4 w-full h-[45%]">
                  <div className="flex-1 overflow-hidden">
                    <img
                      src={
                        Property.bedroomGalleryMixed4.images[1] ||
                        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                      }
                      alt="Bedroom Seating"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 overflow-hidden">
                    <img
                      src={
                        Property.bedroomGalleryMixed4.images[2] ||
                        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                      }
                      alt="Bedroom Detail"
                      className="w-full h-[25vh] object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case "bedroomGallery6":
        return (
          <div
            key="bedroomGallery6"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col relative pt-10 px-1">
              <div className="flex flex-col space-y-4 w-full h-full pt-10">
                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.bedroomGallery6.images[0] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 1"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.bedroomGallery6.images[1] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 2"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "bedroomGallery7":
        return (
          <div
            key="bedroomGallery7"
            className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
          >
            <div className="w-full h-full flex flex-col relative pt-10 px-1">
              <div className="flex flex-col space-y-4 w-full h-full pt-10">
                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.bedroomGallery7.images[0] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 1"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex-1 overflow-hidden">
                  <img
                    src={
                      Property.bedroomGallery7.images[1] ||
                      "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/27cd7a39-2588-483b-9f85-7d58f9d27300/public"
                    }
                    alt="Bedroom Suite 2"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "services":
        return (
          <div
            key="services"
            className="print-page w-[210mm] min-h-[297mm] pl-8 pr-5 pt-20 flex flex-col relative bg-[#f8f7f6] shadow-md"
          >
            <div className="mb-12 max-w-[92%] ml-5">
              <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-6">
                {Property.services.section1.title}
              </h2>
              <p
                className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-10"
                style={{ wordSpacing: "1px" }}
              >
                {Property.services.section1.description}
              </p>

              <div
                className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-center"
                style={{
                  backgroundImage:
                    "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
                }}
              >
                <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
                <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
                  {Property.services.section1.bannerText}
                </h3>
                <a
                  href={Property.services.section1.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
                    Click Here
                  </button>
                </a>
              </div>
            </div>

            <div className="max-w-[92%] ml-5">
              <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-10 mt-10">
                {Property.services.section2.title}
              </h2>
              <p
                className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-8"
                style={{ wordSpacing: "1px" }}
              >
                {Property.services.section2.description}
              </p>

              <div
                className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-top"
                style={{
                  backgroundImage:
                    "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
                }}
              >
                <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
                <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
                  {Property.services.section2.bannerText}
                </h3>
                <a
                  href={Property.services.section2.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
                    Click Here
                  </button>
                </a>
              </div>
            </div>
          </div>
        );

      case "aboutZorba":
        return (
          <div
            key="aboutZorba"
            className="print-page w-[210mm] min-h-[297mm] relative flex flex-col pt-10 pl-5 px-1 overflow-hidden bg-[#f8f7f6] shadow-md"
          >
            <div className="absolute top-10 right-12 z-20 flex items-center justify-end w-full">
              <div className="flex-1 h-[1px] bg-gray-400 ml-0"></div>
              <span className="waterfall text-8xl text-gray-800 pl-6">
                {/* {Property.aboutZorba.title || "About"} */}
                {"About Zorba"}
              </span>
            </div>

            <div className="absolute top-32 -bottom-12 right-12 w-[1.5px] bg-gray-400"></div>

            <div className="flex flex-col justify-center h-full max-w-[95%] pr-16 pl-8 pt-[40vh]">
              <h2 className="text-5xl PlayfairDisplay text-gray-800 mb-8 leading-tight">
                {Property.aboutZorba.heading}
              </h2>

              <div
                className="montserrat flex flex-col space-y-8 text-gray-800 text-[15px] tracking-widest text-justify"
                style={{ wordSpacing: "1px" }}
              >
                <p>{Property.aboutZorba.paragraph1}</p>
                <p>{Property.aboutZorba.paragraph2}</p>
                <p>{Property.aboutZorba.paragraph3}</p>
              </div>
            </div>
          </div>
        );

      case "backCover":
        return (
          <div
            key="backCover"
            className="print-page w-[210mm] min-h-[297mm] flex flex-col justify-between items-center py-16 px-1 bg-[#f8f7f6] shadow-md relative"
          >
            <div className="flex flex-col items-center mt-60">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public"
                alt="Logo"
                className="h-44 w-auto object-contain"
              />
            </div>

            <div className="flex flex-col items-center space-y-32">
              <div className="text-center">
                <span className="waterfall text-8xl block">
                  {Property.backCover.quoteLine1}
                </span>
                <span className="waterfall text-7xl block">
                  {Property.backCover.quoteLine2}
                </span>
              </div>

              <div className="montserrat flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
                <a
                  href={`https://zorbastays.com/`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {Property.backCover.contact.website}
                </a>
                <span className="h-3 w-[1px] bg-gray-400"></span>
                <a href={`mailto:info@zorbastays.com`}>
                  {Property.backCover.contact.email}
                </a>
                <span className="h-3 w-[1px] bg-gray-400"></span>
                <span>{Property.backCover.contact.phones}</span>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="bg-white min-h-screen flex flex-col items-center py-10 gap-10 print:gap-0 print:py-0 print:p-0 print:bg-[#f8f7f6]">
      <div className="fixed right-5 bottom-20 print:hidden">
        <button
          onClick={handleDownload}
          className="flex gap-2 justify-center items-center bg-black text-white w-48 py-3 rounded-md tracking-widest text-sm hover:bg-green-800 transition duration-200 ease-linear"
        >
          <FaDownload />
          Download PDF
        </button>
      </div>

      <div className="fixed right-5 bottom-5 print:hidden">
        <button
          onClick={() => navigate("/PropertyBrochure")}
          className="flex gap-2 justify-center items-center border-2 border-black text-black font-semibold w-48 py-2.5 rounded-md tracking-widest text-sm hover:bg-black hover:text-white transition duration-200 ease-linear"
        >
          <CgTemplate />
          Back to Brochures
        </button>
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html: `
            @page {
              size: A4 portrait;
              margin: 0;
            }

            @media print {
              html, body {
                width: 210mm;
                margin: 0;
                padding: 0;
                height: auto !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              body {
                zoom: 100%;
              }

              .print-page {
                width: 210mm !important;
                min-height: 297mm !important;
                page-break-after: always;
                break-after: page;
                page-break-inside: avoid;
                break-inside: avoid;
                margin: 0 !important;
              }

              .print-page:last-of-type {
                page-break-after: auto !important;
                break-after: auto !important;
              }

              .shadow-md {
                box-shadow: none !important;
              }
            }
          `,
        }}
      />

      {pagesToRender.map((pageId) => renderPage(pageId))}
    </div>
  );
};

export default BrochurePDF;

// ====================================  Till 18/05/2026 Code  =========================================

// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { CgTemplate } from "react-icons/cg";
// import { FaDownload } from "react-icons/fa6";

// const BrochurePDF = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [brochure, setBrochure] = useState(null);
//   const [amenities, setAmenities] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [pagesToRender, setPagesToRender] = useState([]);
//   const [dynamicPages, setDynamicPages] = useState([]);

//   useEffect(() => {
//     const fetchBrochure = async () => {
//       try {
//         const res = await fetch(
//           `https://dash.zorbastays.com/web-backend/getBrochure/${id}`,
//         );

//         const rawText = await res.text();
//         console.log("RAW RESPONSE:", rawText);

//         let json;
//         try {
//           json = JSON.parse(rawText);
//           console.log("Parsed JSON:", json);
//         } catch (parseError) {
//           console.error("JSON Parse Error:", parseError);
//           throw new Error(
//             `Invalid response from server. Status: ${res.status}`,
//           );
//         }

//         if (!json.success) throw new Error(json.message);
//         setBrochure(json.data);

//         // Parse dynamic pages if they exist
//         let dynamicPagesData = [];
//         if (json.data.dynamic_pages && Array.isArray(json.data.dynamic_pages)) {
//           dynamicPagesData = json.data.dynamic_pages;
//           setDynamicPages(dynamicPagesData);
//           console.log("Dynamic pages:", dynamicPagesData);
//         }

//         const amenityIds = Array.isArray(json.data.amenity_ids)
//           ? json.data.amenity_ids
//           : JSON.parse(json.data.amenity_ids || "[]");

//         let amenitiesData = [];
//         if (amenityIds.length > 0) {
//           const amenityRes = await fetch(
//             `https://dash.zorbastays.com/web-backend/getAmenitiesById?ids=${amenityIds.join(",")}`,
//           );
//           const amenityJson = await amenityRes.json();
//           if (amenityJson.success) {
//             amenitiesData = amenityJson.data;
//             setAmenities(amenitiesData);
//           }
//         }

//         // Build Property object to check images
//         const Property = {
//           villa: {
//             logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
//             title: json.data.villa_name,
//             text: json.data.top_text,
//             mainImage: json.data.img_page1,
//             signature: json.data.location,
//             contact: {
//               website: "www.zorbastays.com",
//               email: "info@zorbastays.com",
//               phones: "63552-31066, 98750-28066",
//             },
//           },
//           amenities: {
//             logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
//             items: amenitiesData.map((a) => ({
//               name: a.name,
//               imgSrc: a.url,
//             })),
//           },
//           theVilla: {
//             logo: "https://zorbastays.com/android-chrome-512x512.png",
//             image: json.data.img_page3,
//             paragraph1: json.data.villa_desc1,
//             paragraph2: json.data.villa_desc2,
//           },
//           curation: {
//             title: json.data.the_title,
//             footerWebsite: "www.zorbastays.com",
//             steps: [
//               {
//                 heading: json.data.curate_title1,
//                 description: json.data.curate_desc1,
//               },
//               {
//                 heading: json.data.curate_title2,
//                 description: json.data.curate_desc2,
//               },
//               {
//                 heading: json.data.curate_title3,
//                 description: json.data.curate_desc3,
//               },
//               {
//                 heading: json.data.curate_title4,
//                 description: json.data.curate_desc4,
//               },
//               {
//                 heading: json.data.curate_title5,
//                 description: json.data.curate_desc5,
//               },
//             ],
//           },
//           gallery: {
//             signature: json.data.pool_title,
//             logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
//             images: [
//               json.data.img_page5_1,
//               json.data.img_page5_2,
//               json.data.img_page5_3,
//             ],
//           },
//           living: {
//             logo: "https://zorbastays.com/android-chrome-512x512.png",
//             livingImage: json.data.img_page6,
//             paragraph1: json.data.living_desc1,
//             paragraph2: json.data.living_desc2,
//           },
//           kitchenDining: {
//             title: json.data.kitchen_title,
//             images: [json.data.img_page7_1, json.data.img_page7_2],
//           },
//           bedrooms: {
//             logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
//             bedroomImage: json.data.img_page8,
//             paragraph1: json.data.bed_desc1,
//             paragraph2: json.data.bed_desc2,
//           },
//           bedroomGallery: {
//             images: [json.data.img_page9_1, json.data.img_page9_2],
//           },
//           bedroomGallery2: {
//             images: [json.data.img_page10_1, json.data.img_page10_2],
//           },
//           bedroomGalleryMixed: {
//             images: [
//               json.data.img_page11_1,
//               json.data.img_page11_2,
//               json.data.img_page11_3,
//             ],
//           },
//           bedroomGalleryMixed2: {
//             images: [
//               json.data.img_page12_1,
//               json.data.img_page12_2,
//               json.data.img_page12_3,
//             ],
//           },
//           bedroomGalleryMixed3: {
//             images: [
//               json.data.img_page13_1,
//               json.data.img_page13_2,
//               json.data.img_page13_3,
//             ],
//           },
//           bedroomGallery3: {
//             images: [json.data.img_page14_1, json.data.img_page14_2],
//           },
//           commonareas: {
//             title: json.data.common_areas,
//             images: [json.data.img_page15_1, json.data.img_page15_2],
//           },
//           bedroomGallery4: {
//             images: [json.data.img_page16_1, json.data.img_page16_2],
//           },
//           bedroomGallery5: {
//             images: [json.data.img_page17_1, json.data.img_page17_2],
//           },
//           bedroomGalleryMixed4: {
//             images: [
//               json.data.img_page18_1,
//               json.data.img_page18_2,
//               json.data.img_page18_3,
//             ],
//           },
//           bedroomGallery6: {
//             images: [json.data.img_page19_1, json.data.img_page19_2],
//           },
//           bedroomGallery7: {
//             images: [json.data.img_page20_1, json.data.img_page20_2],
//           },
//           services: {
//             section1: {
//               title: json.data.destination,
//               description: json.data.destination_desc,
//               bannerText: json.data.travel_title,
//               link: json.data.travel_link,
//             },
//             section2: {
//               title: json.data.service,
//               description: json.data.service_desc,
//               bannerText: json.data.concierge_title,
//               link: json.data.concierge_link,
//             },
//           },
//           aboutZorba: {
//             title: json.data.nature,
//             heading: json.data.nature_desc1,
//             paragraph1: json.data.nature_desc2,
//             paragraph2: json.data.nature_desc3,
//             paragraph3: "",
//           },
//           backCover: {
//             logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
//             quoteLine1: "Indulge in the extraordinary;",
//             quoteLine2: "life's too short for ordinary",
//             contact: {
//               website: "www.zorbastays.com",
//               email: "info@zorbastays.com",
//               phones: "63552-31066, 98750-28066",
//             },
//           },
//         };

//         const hasValidImages = (images) => {
//           if (!images || !Array.isArray(images)) return false;
//           return images.some(
//             (img) => img && img.trim() !== "" && img !== "null",
//           );
//         };

//         const pagesConfig = [
//           { id: "cover", condition: true },
//           {
//             id: "amenities",
//             condition:
//               Property.amenities.items && Property.amenities.items.length > 0,
//           },
//           {
//             id: "theVilla",
//             condition:
//               Property.theVilla.image &&
//               Property.theVilla.image.trim() !== "" &&
//               Property.theVilla.image !== "null",
//           },
//           { id: "curation", condition: true },
//           { id: "gallery", condition: hasValidImages(Property.gallery.images) },
//           {
//             id: "living",
//             condition:
//               Property.living.livingImage &&
//               Property.living.livingImage.trim() !== "" &&
//               Property.living.livingImage !== "null",
//           },
//           {
//             id: "kitchenDining",
//             condition: hasValidImages(Property.kitchenDining.images),
//           },
//           {
//             id: "bedrooms",
//             condition:
//               Property.bedrooms.bedroomImage &&
//               Property.bedrooms.bedroomImage.trim() !== "" &&
//               Property.bedrooms.bedroomImage !== "null",
//           },
//           {
//             id: "bedroomGallery",
//             condition: hasValidImages(Property.bedroomGallery.images),
//           },
//           {
//             id: "bedroomGallery2",
//             condition: hasValidImages(Property.bedroomGallery2.images),
//           },
//           {
//             id: "bedroomGalleryMixed",
//             condition: hasValidImages(Property.bedroomGalleryMixed.images),
//           },
//           {
//             id: "bedroomGalleryMixed2",
//             condition: hasValidImages(Property.bedroomGalleryMixed2.images),
//           },
//           {
//             id: "bedroomGalleryMixed3",
//             condition: hasValidImages(Property.bedroomGalleryMixed3.images),
//           },
//           {
//             id: "bedroomGallery3",
//             condition: hasValidImages(Property.bedroomGallery3.images),
//           },
//           {
//             id: "commonareas",
//             condition: hasValidImages(Property.commonareas.images),
//           },
//           {
//             id: "bedroomGallery4",
//             condition: hasValidImages(Property.bedroomGallery4.images),
//           },
//           {
//             id: "bedroomGallery5",
//             condition: hasValidImages(Property.bedroomGallery5.images),
//           },
//           {
//             id: "bedroomGalleryMixed4",
//             condition: hasValidImages(Property.bedroomGalleryMixed4.images),
//           },
//           {
//             id: "bedroomGallery6",
//             condition: hasValidImages(Property.bedroomGallery6.images),
//           },
//           {
//             id: "bedroomGallery7",
//             condition: hasValidImages(Property.bedroomGallery7.images),
//           },
//           { id: "services", condition: true },
//           { id: "aboutZorba", condition: true },
//           { id: "backCover", condition: true },
//         ];

//         // Filter to only pages that pass their condition
//         const filteredPages = pagesConfig.filter((page) => page.condition);

//         // Build a lookup: pageId → index in filteredPages
//         // e.g. "afterPage9" means after the page at index 9 (1-based) → insert after filteredPages[8]
//         // The section string is like "afterPage9", "afterPage16", etc.
//         const parseAfterIndex = (section) => {
//           const match = section?.match(/afterPage(\d+)/);
//           if (!match) return null;
//           const n = parseInt(match[1]);
//           // If the requested page number exceeds filtered list, insert before backCover
//           return Math.min(n, filteredPages.length - 1);
//         };
//         const sectionToPageId = {
//           afterBedroomGallery: "bedroomGallery",
//           afterBedroomGallery4: "bedroomGallery4",
//         };
//         // Build the final ordered list with dynamic pages inserted at right spots
//         // We insert dynamic pages AFTER the Nth page in the filtered list
//         // Collect all dynamic insertions grouped by target index
//         const insertions = {}; // { afterIndex: [dynamicId, ...] }

//         dynamicPagesData.forEach((page, index) => {
//           const hasImages =
//             page.images &&
//             page.images.length > 0 &&
//             page.images.some(
//               (img) => img && img.trim() !== "" && img !== "null",
//             );
//           if (!hasImages) return;

//           const anchorPageId = sectionToPageId[page.section];
//           if (!anchorPageId) return;

//           if (!insertions[anchorPageId]) insertions[anchorPageId] = [];
//           insertions[anchorPageId].push(`dynamic_${index}`);
//         });

//         // Build final list - inject after the matching page ID
//         const finalPages = [];
//         filteredPages.forEach((page) => {
//           finalPages.push(page.id);
//           if (insertions[page.id]) {
//             insertions[page.id].forEach((dynId) => finalPages.push(dynId));
//           }
//         });

//         setPagesToRender(finalPages);
//       } catch (err) {
//         console.error("Fetch error:", err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBrochure();
//   }, [id]);

//   if (loading)
//     return (
//       <div className="flex items-center justify-center min-h-screen">
//         Loading...
//       </div>
//     );
//   if (error)
//     return (
//       <div className="flex items-center justify-center min-h-screen text-red-500">
//         {error}
//       </div>
//     );
//   if (!brochure) return null;

//   const Property = {
//     villa: {
//       logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
//       title: brochure.villa_name,
//       text: brochure.top_text,
//       mainImage: brochure.img_page1,
//       signature: brochure.location,
//       contact: {
//         website: "www.zorbastays.com",
//         email: "info@zorbastays.com",
//         phones: "63552-31066, 98750-28066",
//       },
//     },
//     amenities: {
//       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
//       items: amenities.map((a) => ({
//         name: a.name,
//         imgSrc: a.url,
//       })),
//     },
//     theVilla: {
//       logo: "https://zorbastays.com/android-chrome-512x512.png",
//       image: brochure.img_page3,
//       villaTitle1: brochure.the_title_prefix,
//       villaTitle2: brochure.villa_title_prefix,
//       paragraph1: brochure.villa_desc1,
//       paragraph2: brochure.villa_desc2,
//     },
//     // curation: {
//     //   title: brochure.the_title,
//     //   footerWebsite: "www.zorbastays.com",
//     //   steps: [
//     //     { heading: brochure.curate_title1, description: brochure.curate_desc1 },
//     //     { heading: brochure.curate_title2, description: brochure.curate_desc2 },
//     //     { heading: brochure.curate_title3, description: brochure.curate_desc3 },
//     //     { heading: brochure.curate_title4, description: brochure.curate_desc4 },
//     //     { heading: brochure.curate_title5, description: brochure.curate_desc5 },
//     //   ],
//     // },
//     curation: {
//       title: "The way we curate.",
//       footerWebsite: "www.zorbastays.com",
//       steps: [
//         {
//           heading: "We Choose with Care",
//           description:
//             "Every Zorba stay is personally verified for its design, service, and sense of place.",
//         },
//         {
//           heading: "We Understand Your \n “Why” Before the “Where”",
//           description:
//             "Every journey begins with intent. We craft stays that reflect your purpose, your people, and the memories you seek to create.",
//         },
//         {
//           heading: "We’re Your Constant \n Point of Support",
//           description:
//             "From the first conversation to your final day, our team ensures every detail flows seamlessly.",
//         },
//         {
//           heading: "We Bring Access, Not Aggregation",
//           description:
//             "Our collection opens doors to stays and experiences you won’t find online, offered through trust and discovery.",
//         },
//         {
//           heading: "Beyond Travel — \n We Stay in Touch",
//           description:
//             "We stay connected beyond your travels — inspiring your next journey with new destinations and discoveries.",
//         },
//       ],
//     },
//     gallery: {
//       signature: brochure.pool_title,
//       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
//       images: [
//         brochure.img_page5_1,
//         brochure.img_page5_2,
//         brochure.img_page5_3,
//       ],
//     },
//     living: {
//       logo: "https://zorbastays.com/android-chrome-512x512.png",
//       livingImage: brochure.img_page6,
//       livingtitle1: brochure.the_title,
//       livingtitle2: brochure.living_title,
//       paragraph1: brochure.living_desc1,
//       paragraph2: brochure.living_desc2,
//     },
//     kitchenDining: {
//       title: brochure.kitchen_title,
//       images: [brochure.img_page7_1, brochure.img_page7_2],
//     },
//     bedrooms: {
//       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
//       bedroomImage: brochure.img_page8,
//       bedroomtitle1: brochure.the_bed_title,
//       bedroomtitle2: brochure.bedroom_title,
//       paragraph1: brochure.bed_desc1,
//       paragraph2: brochure.bed_desc2,
//     },
//     bedroomGallery: { images: [brochure.img_page9_1, brochure.img_page9_2] },
//     bedroomGallery2: { images: [brochure.img_page10_1, brochure.img_page10_2] },
//     bedroomGalleryMixed: {
//       images: [
//         brochure.img_page11_1,
//         brochure.img_page11_2,
//         brochure.img_page11_3,
//       ],
//     },
//     bedroomGalleryMixed2: {
//       images: [
//         brochure.img_page12_1,
//         brochure.img_page12_2,
//         brochure.img_page12_3,
//       ],
//     },
//     bedroomGalleryMixed3: {
//       images: [
//         brochure.img_page13_1,
//         brochure.img_page13_2,
//         brochure.img_page13_3,
//       ],
//     },
//     bedroomGallery3: { images: [brochure.img_page14_1, brochure.img_page14_2] },
//     commonareas: {
//       title: brochure.common_areas,
//       images: [brochure.img_page15_1, brochure.img_page15_2],
//     },
//     bedroomGallery4: { images: [brochure.img_page16_1, brochure.img_page16_2] },
//     bedroomGallery5: { images: [brochure.img_page17_1, brochure.img_page17_2] },
//     bedroomGalleryMixed4: {
//       images: [
//         brochure.img_page18_1,
//         brochure.img_page18_2,
//         brochure.img_page18_3,
//       ],
//     },
//     bedroomGallery6: { images: [brochure.img_page19_1, brochure.img_page19_2] },
//     bedroomGallery7: { images: [brochure.img_page20_1, brochure.img_page20_2] },
//     services: {
//       section1: {
//         title: brochure.destination,
//         description: brochure.destination_desc,
//         bannerText: brochure.travel_title,
//         link: brochure.travel_link,
//       },
//       section2: {
//         title: brochure.service,
//         description: brochure.service_desc,
//         bannerText: brochure.concierge_title,
//         link: brochure.concierge_link,
//       },
//     },
//     aboutZorba: {
//       title: brochure.nature,
//       heading: brochure.nature_desc1,
//       paragraph1: brochure.nature_desc2,
//       paragraph2: brochure.nature_desc3,
//       paragraph3: "",
//     },
//     backCover: {
//       logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
//       quoteLine1: "Indulge in the extraordinary;",
//       quoteLine2: "life's too short for ordinary",
//       contact: {
//         website: "www.zorbastays.com",
//         email: "info@zorbastays.com",
//         phones: "63552-31066, 98750-28066",
//       },
//     },
//   };

//   const handleDownload = () => {
//     window.print();
//   };

//   // Render dynamic page based on layout
//   const renderDynamicPage = (dynamicPage, index) => {
//     const { layout, images, section } = dynamicPage;
//     if (!images || images.length === 0) return null;

//     if (layout === "layout1") {
//       return (
//         <div
//           key={`dynamic_${index}`}
//           className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative overflow-hidden"
//         >
//           <div className="w-full h-full flex flex-col relative pt-16 px-1">
//             <div className="flex flex-col space-y-6 w-full">
//               <div className="h-[450px] overflow-hidden">
//                 <img
//                   src={images[0]}
//                   alt="Dynamic 1"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div className="h-[420px] overflow-hidden">
//                 <img
//                   src={images[1]}
//                   // src={images[1]||" https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/e6cae93f-fd4e-4ace-9187-a7430d2dd000/public"}
//                   alt="Dynamic 2"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       );
//     }

//     if (layout === "layout2") {
//       return (
//         <div
//           key={`dynamic_${index}`}
//           className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative overflow-hidden"
//         >
//           <div className="w-full h-full flex flex-col relative pt-10 px-1">
//             <div className="flex flex-col space-y-4 w-full h-full pb-16">
//               <div className="w-full h-[450px] overflow-hidden">
//                 <img
//                   src={images[0]}
//                   alt="Dynamic 1"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div className="flex space-x-4 w-full h-[450px]">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={images[1]}
//                     alt="Dynamic 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={images[2]}
//                     alt="Dynamic 3"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       );
//     }

//     if (layout === "layout3") {
//       return (
//         <div
//           key={`dynamic_${index}`}
//           className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative overflow-hidden"
//         >
//           <div className="w-full h-full flex flex-col relative pt-10 px-1">
//             <div className="flex flex-col space-y-4 w-full h-full pb-16">
//               <div className="w-full h-[450px] overflow-hidden">
//                 <img
//                   src={images[0]}
//                   alt="Dynamic 1"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div className="flex space-x-4 w-full items-start">
//                 <div className="flex-1 h-[300px] overflow-hidden">
//                   <img
//                     src={images[1]}
//                     alt="Dynamic 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//                 <div className="flex-1 h-[450px] overflow-hidden">
//                   <img
//                     src={images[2]}
//                     alt="Dynamic 3"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       );
//     }

//     return null;
//   };

//   const renderPage = (pageId) => {
//     // Check if it's a dynamic page
//     if (pageId.startsWith("dynamic_")) {
//       const index = parseInt(pageId.split("_")[1]);
//       const dynamicPage = dynamicPages[index];
//       if (dynamicPage) {
//         return renderDynamicPage(dynamicPage, index);
//       }
//       return null;
//     }

//     switch (pageId) {
//       case "cover":
//         return (
//           <div
//             key="cover"
//             className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative flex flex-col items-center p-12"
//           >
//             <div className="absolute top-0 left-12 w-[1px] h-80 bg-gray-400"></div>
//             <div className="absolute top-0 left-20 w-[1px] h-60 bg-gray-400"></div>

//             <div className="mt-8 flex flex-col items-center">
//               <img
//                 src={Property.villa.logo}
//                 alt={Property.villa.title}
//                 className="h-28 w-auto object-contain"
//               />
//             </div>

//             <h2 className="mt-20 text-4xl PlayfairDisplay text-gray-800 tracking-wide">
//               {Property.villa.title}
//             </h2>

//             <div className="mt-20 w-full relative group px-4">
//               <p className="montserrat absolute -top-4 right-4 text-[10px] tracking-[0.2em] text-gray-800 uppercase">
//                 {Property.villa.text}
//               </p>

//               <div className="w-full aspect-[4/3] bg-gray-200 overflow-hidden">
//                 <img
//                   src={Property.villa.mainImage}
//                   alt={Property.villa.title}
//                   className="w-full h-full object-cover"
//                 />
//               </div>

//               <div className="absolute -mt-2 right-0 transform z-10">
//                 <span className="windsong text-7xl text-gray-900">
//                   {Property.villa.signature}
//                 </span>
//               </div>
//             </div>

//             <div className="montserrat absolute bottom-3">
//               <div className="flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
//                 <a
//                   href={`https://zorbastays.com/`}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <span>{Property.villa.contact.website}</span>
//                 </a>
//                 <span className="h-3 w-[1px] bg-gray-400"></span>
//                 <a href={`mailto:info@zorbastays.com`}>
//                   <span>{Property.villa.contact.email}</span>
//                 </a>
//                 <span className="h-3 w-[1px] bg-gray-400"></span>
//                 <span>{Property.villa.contact.phones}</span>
//               </div>
//             </div>
//           </div>
//         );

//       case "amenities":
//         if (!Property.amenities.items.length) return null;
//         return Array.from(
//           { length: Math.ceil(Property.amenities.items.length / 10) },
//           (_, i) => Property.amenities.items.slice(i * 10, i * 10 + 10),
//         ).map((amenityGroup, pageIndex, allPages) => (
//           <div
//             key={`amenities-${pageIndex}`}
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative flex flex-col"
//           >
//             {pageIndex === 0 && (
//               <div className="mt-8 ml-6 flex-none">
//                 <h1 className="text-3xl EBGaramond text-gray-800">The</h1>
//                 <h2 className="text-4xl PlayfairDisplay tracking-widest text-gray-800 uppercase mt-2">
//                   Amenities
//                 </h2>
//               </div>
//             )}

//             <div
//               className={`flex-grow flex items-start justify-center ${pageIndex === 0 ? "pt-20" : "pt-32"}`}
//             >
//               <div className="grid grid-cols-2 gap-y-12 gap-x-12 px-4 w-full">
//                 {amenityGroup.map((item, index) => (
//                   <div key={index} className="flex items-center space-x-6">
//                     <div className="w-24 h-24 flex items-center justify-center flex-none">
//                       <img
//                         src={item.imgSrc}
//                         alt={item.name}
//                         className="max-w-full max-h-full object-contain brightness-0 grayscale"
//                       />
//                     </div>
//                     <span className="text-[11px] font-medium tracking-[0.2em] uppercase text-gray-800 leading-tight">
//                       {item.name}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             {pageIndex === allPages.length - 1 && (
//               <div className="mt-auto mb-4 flex justify-center items-center space-x-4">
//                 <div className="w-12 h-[1px] bg-gray-400"></div>
//                 <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
//                   <img
//                     src={Property.amenities.logo}
//                     alt="logo"
//                     className="w-8 h-5 brightness-0"
//                   />
//                 </div>
//                 <div className="w-12 h-[1px] bg-gray-400"></div>
//               </div>
//             )}
//           </div>
//         ));

//       case "theVilla":
//         return (
//           <div
//             key="theVilla"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             {(() => {
//               const totalChars =
//                 (Property.theVilla.paragraph1?.length || 0) +
//                 (Property.theVilla.paragraph2?.length || 0);

//               const imageBottom =
//                 totalChars > 600 ? "bottom-[40px]" : "bottom-[170px]";
//               const logoBottom =
//                 totalChars > 600 ? "bottom-[20px]" : "bottom-[70px]";

//               return (
//                 <>
//                   <div className="mb-8 ml-1">
//                     <h1 className="text-3xl EBGaramond text-gray-800 leading-tight">
//                       {Property.theVilla.villaTitle1}
//                     </h1>
//                     <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2">
//                       {Property.theVilla.villaTitle2}
//                     </h2>
//                   </div>

//                   <div
//                     className="montserrat flex flex-col ml-1 space-y-6 text-gray-800 tracking-widest text-base text-justify max-w-[100%]"
//                     style={{ wordSpacing: "1px" }}
//                   >
//                     <p>{Property.theVilla.paragraph1}</p>
//                     <p>{Property.theVilla.paragraph2}</p>
//                   </div>

//                   <div
//                     className={`absolute left-12 right-12 h-[430px] z-20 ${imageBottom}`}
//                   >
//                     <img
//                       src={Property.theVilla.image}
//                       alt="Villa Exterior"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>

//                   <div
//                     className={`absolute left-8 w-28 h-28 opacity-20 grayscale z-10 ${logoBottom}`}
//                   >
//                     <img
//                       src={Property.theVilla.logo}
//                       alt="Logo Watermark"
//                       className="w-full h-full object-contain"
//                     />
//                   </div>
//                 </>
//               );
//             })()}
//           </div>
//         );

//       case "curation":
//         return (
//           <div
//             key="curation"
//             className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col pt-10 px-16 relative">
//               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-20 -ml-5">
//                 The way we curate.
//               </h2>

//               <div className="relative w-full flex-1">
//                 <div className="absolute -top-16 mt-4 -right-5 inset-0 flex justify-center pointer-events-none">
//                   <img
//                     src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/3ea0d39f-9e34-4305-7ea0-07304c880a00/public"
//                     alt="timeline"
//                     className="opacity-60 w-auto h-[750px] object-contain"
//                   />
//                 </div>

//                 <div className="relative z-10 flex flex-col space-y-3">
//                   {Property.curation.steps?.map((step, idx) => (
//                     <div
//                       key={idx}
//                       className={`max-w-auto ${
//                         idx === 0
//                           ? "ml-5 self-start max-w-[180px]"
//                           : idx === 1
//                             ? "w-full self-end mr-20 relative -top-8 max-w-[230px]"
//                             : idx === 2
//                               ? "w-full self-end mr-36 relative top-16 max-w-[240px]"
//                               : idx === 3
//                                 ? "w-full self-start relative ml-8 top-20 max-w-[240px]"
//                                 : idx === 4
//                                   ? "w-full self-end relative mr-5 top-36 max-w-[230px]"
//                                   : ""
//                       }`}
//                     >
//                       <h3 className="PlayfairDisplay text-xl text-gray-800 leading-tight mb-2 whitespace-pre-line">
//                         {step.heading}
//                       </h3>

//                       <p className="montserrat text-[13px] text-gray-800 leading-relaxed tracking-wide">
//                         {step.description}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               <div className="absolute -bottom-56 left-0 w-full text-center">
//                 <a
//                   href="https://zorbastays.com/"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <span className="text-[15px] tracking-[0.1em] text-gray-500">
//                     {Property.curation.footerWebsite}
//                   </span>
//                 </a>
//               </div>
//             </div>
//           </div>
//         );

//       case "gallery":
//         return (
//           <div
//             key="gallery"
//             className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12"
//           >
//             <div className="w-full h-full flex flex-col relative">
//               <div className="absolute -top-20 left-6 w-[1px] h-[280px] bg-gray-400"></div>

//               <div className="flex flex-col items-end z-10 mt-24">
//                 <span className="waterfall text-7xl text-gray-900 text-right max-w-[90%]">
//                   {Property.gallery.signature}
//                 </span>
//               </div>

//               <div className="w-full flex flex-row space-x-4">
//                 <div className="flex flex-col space-y-4 w-[65%]">
//                   <div className="aspect-[16/12] overflow-hidden">
//                     <img
//                       src={Property.gallery.images[0]}
//                       alt="Pool view 1"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>

//                   <div className="aspect-[16/12] overflow-hidden">
//                     <img
//                       src={Property.gallery.images[1]}
//                       alt="Archway view"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 </div>

//                 <div className="flex-1 h-[400px] overflow-hidden">
//                   <img
//                     src={Property.gallery.images[2]}
//                     alt="Pool view 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>

//               <div className="absolute -bottom-40 w-full flex justify-center items-center space-x-4">
//                 <div className="w-12 h-[1.5px] bg-gray-400"></div>
//                 <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
//                   <img
//                     src={Property.gallery.logo}
//                     alt={Property.gallery.title}
//                     className="w-8 h-5 brightness-0"
//                   />
//                 </div>
//                 <div className="w-12 h-[1.5px] bg-gray-400"></div>
//               </div>
//             </div>
//           </div>
//         );

//       case "living":
//         return (
//           <div
//             key="living"
//             className="print-page bg-[#f8f7f6] w-[210mm] h-[297mm] p-12 pt-20 flex flex-col shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full relative flex flex-col px-1 pt-10">
//               {/* Watermark */}
//               <div
//                 className="absolute -top-10 right-0 w-[430px] h-[430px] opacity-5 pointer-events-none translate-x-14 -translate-y-14"
//                 style={{ wordSpacing: "4px" }}
//               >
//                 <img
//                   src={Property.living.logo}
//                   alt="Watermark"
//                   className="w-full h-full object-contain grayscale"
//                 />
//               </div>

//               {/* Content */}
//               <div className="relative z-10 flex flex-col h-full">
//                 {/* Heading */}
//                 <div>
//                   <h1 className="text-3xl EBGaramond text-gray-800 leading-tight">
//                     {Property.living.livingtitle1}
//                   </h1>

//                   <h2 className="text-4xl PlayfairDisplay text-gray-800 tracking-widest uppercase mb-8">
//                     {Property.living.livingtitle2}
//                   </h2>

//                   {/* Paragraphs */}
//                   <div className="montserrat flex flex-col space-y-6 text-gray-800 text-[15px] tracking-widest max-w-[100%]">
//                     <p>{Property.living.paragraph1}</p>
//                     <p>{Property.living.paragraph2}</p>
//                   </div>
//                 </div>

//                 {/* Bottom Fixed Image */}
//                 <div className="absolute left-0 right-0 bottom-20 h-[460px]">
//                   <div className="w-full h-[460px] overflow-hidden border-2 border-gray-300">
//                     <img
//                       src={Property.living.livingImage}
//                       alt="Living Area"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* Bottom Lines */}
//               <div className="absolute -bottom-16 left-12 flex gap-6">
//                 <div className="w-[1px] h-36 bg-gray-400"></div>
//                 <div className="w-[1px] h-36 bg-gray-400"></div>
//               </div>
//             </div>
//           </div>
//         );

//       case "kitchenDining":
//         return (
//           <div
//             key="kitchenDining"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="absolute top-4 right-1 z-20">
//                 <span className="waterfall text-7xl text-gray-900 drop-shadow-sm">
//                   {Property.kitchenDining.title}
//                 </span>
//               </div>

//               <div className="flex flex-col space-y-6 w-full h-full pt-20">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.kitchenDining.images[0]}
//                     alt="Kitchen Area"
//                     className="w-full h-[420px] object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.kitchenDining.images[1]}
//                     alt="Dining Area"
//                     className="w-full h-[420px] object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedrooms":
//         return (
//           <div
//             key="bedrooms"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col px-1 pt-20 relative">
//               <div className="mb-8">
//                 <h1 className="text-3xl EBGaramond text-gray-800 leading-tight">
//                   {Property.bedrooms.bedroomtitle1}
//                 </h1>
//                 <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2 tracking-wide">
//                   {Property.bedrooms.bedroomtitle2}
//                 </h2>
//               </div>

//               <div
//                 className="montserrat flex flex-col space-y-8 text-gray-800 tracking-widest text-[14px] text-justify max-w-[95%] leading-relaxed"
//                 style={{ wordSpacing: "1px" }}
//               >
//                 <p>{Property.bedrooms.paragraph1}</p>
//                 <p>{Property.bedrooms.paragraph2}</p>
//               </div>

//               <div className="mt-10 w-full aspect-[16/11] overflow-hidden">
//                 <img
//                   src={Property.bedrooms.bedroomImage}
//                   alt="Bedroom Interior"
//                   className="w-full h-full object-cover"
//                 />
//               </div>

//               <div className="absolute -bottom-12 left-0 w-full flex justify-center items-center space-x-4">
//                 <div className="w-12 h-[2px] bg-gray-400"></div>
//                 <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
//                   <img
//                     src={Property.bedrooms.logo}
//                     alt="Logo"
//                     className="w-7 h-5 brightness-0 opacity-70"
//                   />
//                 </div>
//                 <div className="w-12 h-[2px] bg-gray-400"></div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery":
//         return (
//           <div
//             key="bedroomGallery"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden shadow-sm">
//                   <img
//                     src={Property.bedroomGallery.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-[450px] object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden shadow-sm">
//                   <img
//                     src={Property.bedroomGallery.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-[420px] object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery2":
//         return (
//           <div
//             key="bedroomGallery2"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery2.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery2.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGalleryMixed":
//         return (
//           <div
//             key="bedroomGalleryMixed"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-5 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pb-10">
//                 <div className="w-full h-[45%] overflow-hidden">
//                   <img
//                     src={Property.bedroomGalleryMixed.images[0]}
//                     alt="Master Bedroom View"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex space-x-4 w-full h-[45%]">
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed.images[1]}
//                       alt="Bedroom Seating"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed.images[2]}
//                       alt="Bedroom Detail"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGalleryMixed2":
//         return (
//           <div
//             key="bedroomGalleryMixed2"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-0 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pb-16">
//                 <div className="w-full h-[45%] overflow-hidden">
//                   <img
//                     src={Property.bedroomGalleryMixed2.images[0]}
//                     alt="Master Bedroom View"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex space-x-4 w-full h-[45%]">
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed2.images[1]}
//                       alt="Bedroom Seating"
//                       className="w-full h-[25vh] object-cover"
//                     />
//                   </div>
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed2.images[2]}
//                       alt="Bedroom Detail"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGalleryMixed3":
//         return (
//           <div
//             key="bedroomGalleryMixed3"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-5 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pb-16">
//                 <div className="w-full h-[45%] overflow-hidden">
//                   <img
//                     src={Property.bedroomGalleryMixed3.images[0]}
//                     alt="Master Bedroom View"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex space-x-4 w-full h-[45%]">
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed3.images[1]}
//                       alt="Bedroom Seating"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed3.images[2]}
//                       alt="Bedroom Detail"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery3":
//         return (
//           <div
//             key="bedroomGallery3"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery3.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery3.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "commonareas":
//         return (
//           <div
//             key="commonareas"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="absolute top-0 left-6 z-20 flex items-center w-full">
//                 <span className="waterfall text-7xl text-gray-800 pr-6">
//                   {Property.commonareas.title}
//                 </span>
//                 <div className="flex-1 h-[1px] bg-gray-400 -mr-6"></div>
//               </div>

//               <div className="absolute top-24 left-3 w-[1px] h-[970px] bg-gray-400"></div>

//               <div className="flex flex-col space-y-4 w-full h-[950px] pt-28 pl-16">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.commonareas.images[0]}
//                     alt="Common Area Overview"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.commonareas.images[1]}
//                     alt="Lounge and Staircase"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery4":
//         return (
//           <div
//             key="bedroomGallery4"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-5 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery4.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery4.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery5":
//         return (
//           <div
//             key="bedroomGallery5"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery5.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery5.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGalleryMixed4":
//         return (
//           <div
//             key="bedroomGalleryMixed4"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-5 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pb-16">
//                 <div className="w-full h-[45%] overflow-hidden">
//                   <img
//                     src={Property.bedroomGalleryMixed4.images[0]}
//                     alt="Master Bedroom View"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex space-x-4 w-full h-[45%]">
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed4.images[1]}
//                       alt="Bedroom Seating"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed4.images[2]}
//                       alt="Bedroom Detail"
//                       className="w-full h-[25vh] object-cover"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery6":
//         return (
//           <div
//             key="bedroomGallery6"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery6.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery6.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery7":
//         return (
//           <div
//             key="bedroomGallery7"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery7.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery7.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "services":
//         return (
//           <div
//             key="services"
//             className="print-page w-[210mm] min-h-[297mm] pl-8 pr-5 pt-20 flex flex-col relative bg-[#f8f7f6] shadow-md"
//           >
//             <div className="mb-12 max-w-[92%] ml-5">
//               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-6">
//                 {Property.services.section1.title}
//               </h2>
//               <p
//                 className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-10"
//                 style={{ wordSpacing: "1px" }}
//               >
//                 {Property.services.section1.description}
//               </p>

//               <div
//                 className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-center"
//                 style={{
//                   backgroundImage:
//                     "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
//                 }}
//               >
//                 <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
//                 <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
//                   {Property.services.section1.bannerText}
//                 </h3>
//                 <a
//                   href={Property.services.section1.link}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
//                     Click Here
//                   </button>
//                 </a>
//               </div>
//             </div>

//             <div className="max-w-[92%] ml-5">
//               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-10 mt-10">
//                 {Property.services.section2.title}
//               </h2>
//               <p
//                 className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-8"
//                 style={{ wordSpacing: "1px" }}
//               >
//                 {Property.services.section2.description}
//               </p>

//               <div
//                 className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-top"
//                 style={{
//                   backgroundImage:
//                     "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
//                 }}
//               >
//                 <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
//                 <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
//                   {Property.services.section2.bannerText}
//                 </h3>
//                 <a
//                   href={Property.services.section2.link}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
//                     Click Here
//                   </button>
//                 </a>
//               </div>
//             </div>
//           </div>
//         );

//       case "aboutZorba":
//         return (
//           <div
//             key="aboutZorba"
//             className="print-page w-[210mm] min-h-[297mm] relative flex flex-col pt-10 pl-5 px-1 overflow-hidden bg-[#f8f7f6] shadow-md"
//           >
//             <div className="absolute top-10 right-12 z-20 flex items-center justify-end w-full">
//               <div className="flex-1 h-[1px] bg-gray-400 ml-0"></div>
//               <span className="waterfall text-8xl text-gray-800 pl-6">
//                 {/* {Property.aboutZorba.title || "About"} */}
//                 {"About Zorba"}
//               </span>
//             </div>

//             <div className="absolute top-32 -bottom-12 right-12 w-[1.5px] bg-gray-400"></div>

//             <div className="flex flex-col justify-center h-full max-w-[95%] pr-16 pl-8 pt-[40vh]">
//               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-8 leading-tight">
//                 {Property.aboutZorba.heading}
//               </h2>

//               <div
//                 className="montserrat flex flex-col space-y-8 text-gray-800 text-[15px] tracking-widest text-justify"
//                 style={{ wordSpacing: "1px" }}
//               >
//                 <p>{Property.aboutZorba.paragraph1}</p>
//                 <p>{Property.aboutZorba.paragraph2}</p>
//                 <p>{Property.aboutZorba.paragraph3}</p>
//               </div>
//             </div>
//           </div>
//         );

//       case "backCover":
//         return (
//           <div
//             key="backCover"
//             className="print-page w-[210mm] min-h-[297mm] flex flex-col justify-between items-center py-16 px-1 bg-[#f8f7f6] shadow-md relative"
//           >
//             <div className="flex flex-col items-center mt-60">
//               <img
//                 src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public"
//                 alt="Logo"
//                 className="h-44 w-auto object-contain"
//               />
//             </div>

//             <div className="flex flex-col items-center space-y-32">
//               <div className="text-center">
//                 <span className="waterfall text-8xl block">
//                   {Property.backCover.quoteLine1}
//                 </span>
//                 <span className="waterfall text-7xl block">
//                   {Property.backCover.quoteLine2}
//                 </span>
//               </div>

//               <div className="montserrat flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
//                 <a
//                   href={`https://zorbastays.com/`}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   {Property.backCover.contact.website}
//                 </a>
//                 <span className="h-3 w-[1px] bg-gray-400"></span>
//                 <a href={`mailto:info@zorbastays.com`}>
//                   {Property.backCover.contact.email}
//                 </a>
//                 <span className="h-3 w-[1px] bg-gray-400"></span>
//                 <span>{Property.backCover.contact.phones}</span>
//               </div>
//             </div>
//           </div>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="bg-white min-h-screen flex flex-col items-center py-10 gap-10 print:gap-0 print:py-0 print:p-0 print:bg-[#f8f7f6]">
//       <div className="fixed right-5 bottom-20 print:hidden">
//         <button
//           onClick={handleDownload}
//           className="flex gap-2 justify-center items-center bg-black text-white w-48 py-3 rounded-md tracking-widest text-sm hover:bg-green-800 transition duration-200 ease-linear"
//         >
//           <FaDownload />
//           Download PDF
//         </button>
//       </div>

//       <div className="fixed right-5 bottom-5 print:hidden">
//         <button
//           onClick={() => navigate("/PropertyBrochure")}
//           className="flex gap-2 justify-center items-center border-2 border-black text-black font-semibold w-48 py-2.5 rounded-md tracking-widest text-sm hover:bg-black hover:text-white transition duration-200 ease-linear"
//         >
//           <CgTemplate />
//           Back to Brochures
//         </button>
//       </div>

//       <style
//         dangerouslySetInnerHTML={{
//           __html: `
//             @page {
//               size: A4 portrait;
//               margin: 0;
//             }

//             @media print {
//               html, body {
//                 width: 210mm;
//                 margin: 0;
//                 padding: 0;
//                 height: auto !important;
//                 -webkit-print-color-adjust: exact;
//                 print-color-adjust: exact;
//               }

//               body {
//                 zoom: 100%;
//               }

//               .print-page {
//                 width: 210mm !important;
//                 min-height: 297mm !important;
//                 page-break-after: always;
//                 break-after: page;
//                 page-break-inside: avoid;
//                 break-inside: avoid;
//                 margin: 0 !important;
//               }

//               .print-page:last-of-type {
//                 page-break-after: auto !important;
//                 break-after: auto !important;
//               }

//               .shadow-md {
//                 box-shadow: none !important;
//               }
//             }
//           `,
//         }}
//       />

//       {pagesToRender.map((pageId) => renderPage(pageId))}
//     </div>
//   );
// };

// export default BrochurePDF;

// ====================================  Older Code  =========================================

// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { CgTemplate } from "react-icons/cg";
// import { FaDownload } from "react-icons/fa6";

// const BrochurePDF = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [brochure, setBrochure] = useState(null);
//   const [amenities, setAmenities] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [pagesToRender, setPagesToRender] = useState([]);
//   const [dynamicPages, setDynamicPages] = useState([]);

//   useEffect(() => {
//     const fetchBrochure = async () => {
//       try {
//         const res = await fetch(
//           `https://dash.zorbastays.com/web-backend/getBrochure/${id}`,
//         );

//         const rawText = await res.text();
//         console.log("RAW RESPONSE:", rawText);

//         let json;
//         try {
//           json = JSON.parse(rawText);
//           console.log("Parsed JSON:", json);
//         } catch (parseError) {
//           console.error("JSON Parse Error:", parseError);
//           throw new Error(
//             `Invalid response from server. Status: ${res.status}`,
//           );
//         }

//         if (!json.success) throw new Error(json.message);
//         setBrochure(json.data);

//         // Parse dynamic pages if they exist
//         let dynamicPagesData = [];
//         if (json.data.dynamic_pages && Array.isArray(json.data.dynamic_pages)) {
//           dynamicPagesData = json.data.dynamic_pages;
//           setDynamicPages(dynamicPagesData);
//           console.log("Dynamic pages:", dynamicPagesData);
//         }

//         const amenityIds = Array.isArray(json.data.amenity_ids)
//           ? json.data.amenity_ids
//           : JSON.parse(json.data.amenity_ids || "[]");

//         let amenitiesData = [];
//         if (amenityIds.length > 0) {
//           const amenityRes = await fetch(
//             `https://dash.zorbastays.com/web-backend/getAmenitiesById?ids=${amenityIds.join(",")}`,
//           );
//           const amenityJson = await amenityRes.json();
//           if (amenityJson.success) {
//             amenitiesData = amenityJson.data;
//             setAmenities(amenitiesData);
//           }
//         }

//         // Build Property object to check images
//         const Property = {
//           villa: {
//             logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
//             title: json.data.villa_name,
//             text: json.data.top_text,
//             mainImage: json.data.img_page1,
//             signature: json.data.location,
//             contact: {
//               website: "www.zorbastays.com",
//               email: "info@zorbastays.com",
//               phones: "63552-31066, 98750-28066",
//             },
//           },
//           amenities: {
//             logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
//             items: amenitiesData.map((a) => ({
//               name: a.name,
//               imgSrc: a.url,
//             })),
//           },
//           theVilla: {
//             logo: "https://zorbastays.com/android-chrome-512x512.png",
//             image: json.data.img_page3,
//             paragraph1: json.data.villa_desc1,
//             paragraph2: json.data.villa_desc2,
//           },
//           curation: {
//             title: json.data.the_title,
//             footerWebsite: "www.zorbastays.com",
//             steps: [
//               {
//                 heading: json.data.curate_title1,
//                 description: json.data.curate_desc1,
//               },
//               {
//                 heading: json.data.curate_title2,
//                 description: json.data.curate_desc2,
//               },
//               {
//                 heading: json.data.curate_title3,
//                 description: json.data.curate_desc3,
//               },
//               {
//                 heading: json.data.curate_title4,
//                 description: json.data.curate_desc4,
//               },
//               {
//                 heading: json.data.curate_title5,
//                 description: json.data.curate_desc5,
//               },
//             ],
//           },
//           gallery: {
//             signature: json.data.pool_title,
//             logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
//             images: [
//               json.data.img_page5_1,
//               json.data.img_page5_2,
//               json.data.img_page5_3,
//             ],
//           },
//           living: {
//             logo: "https://zorbastays.com/android-chrome-512x512.png",
//             livingImage: json.data.img_page6,
//             paragraph1: json.data.living_desc1,
//             paragraph2: json.data.living_desc2,
//           },
//           kitchenDining: {
//             title: json.data.kitchen_title,
//             images: [json.data.img_page7_1, json.data.img_page7_2],
//           },
//           bedrooms: {
//             logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
//             bedroomImage: json.data.img_page8,
//             paragraph1: json.data.bed_desc1,
//             paragraph2: json.data.bed_desc2,
//           },
//           bedroomGallery: {
//             images: [json.data.img_page9_1, json.data.img_page9_2],
//           },
//           bedroomGallery2: {
//             images: [json.data.img_page10_1, json.data.img_page10_2],
//           },
//           bedroomGalleryMixed: {
//             images: [
//               json.data.img_page11_1,
//               json.data.img_page11_2,
//               json.data.img_page11_3,
//             ],
//           },
//           bedroomGalleryMixed2: {
//             images: [
//               json.data.img_page12_1,
//               json.data.img_page12_2,
//               json.data.img_page12_3,
//             ],
//           },
//           bedroomGalleryMixed3: {
//             images: [
//               json.data.img_page13_1,
//               json.data.img_page13_2,
//               json.data.img_page13_3,
//             ],
//           },
//           bedroomGallery3: {
//             images: [json.data.img_page14_1, json.data.img_page14_2],
//           },
//           commonareas: {
//             title: json.data.common_areas,
//             images: [json.data.img_page15_1, json.data.img_page15_2],
//           },
//           bedroomGallery4: {
//             images: [json.data.img_page16_1, json.data.img_page16_2],
//           },
//           bedroomGallery5: {
//             images: [json.data.img_page17_1, json.data.img_page17_2],
//           },
//           bedroomGalleryMixed4: {
//             images: [
//               json.data.img_page18_1,
//               json.data.img_page18_2,
//               json.data.img_page18_3,
//             ],
//           },
//           bedroomGallery6: {
//             images: [json.data.img_page19_1, json.data.img_page19_2],
//           },
//           bedroomGallery7: {
//             images: [json.data.img_page20_1, json.data.img_page20_2],
//           },
//           services: {
//             section1: {
//               title: json.data.destination,
//               description: json.data.destination_desc,
//               bannerText: json.data.travel_title,
//               link: json.data.travel_link,
//             },
//             section2: {
//               title: json.data.service,
//               description: json.data.service_desc,
//               bannerText: json.data.concierge_title,
//               link: json.data.concierge_link,
//             },
//           },
//           aboutZorba: {
//             title: json.data.nature,
//             heading: json.data.nature_desc1,
//             paragraph1: json.data.nature_desc2,
//             paragraph2: json.data.nature_desc3,
//             paragraph3: "",
//           },
//           backCover: {
//             logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
//             quoteLine1: "Indulge in the extraordinary;",
//             quoteLine2: "life's too short for ordinary",
//             contact: {
//               website: "www.zorbastays.com",
//               email: "info@zorbastays.com",
//               phones: "63552-31066, 98750-28066",
//             },
//           },
//         };

//         const hasValidImages = (images) => {
//           if (!images || !Array.isArray(images)) return false;
//           return images.some(
//             (img) => img && img.trim() !== "" && img !== "null",
//           );
//         };

//         const pagesConfig = [
//           { id: "cover", condition: true },
//           {
//             id: "amenities",
//             condition:
//               Property.amenities.items && Property.amenities.items.length > 0,
//           },
//           {
//             id: "theVilla",
//             condition:
//               Property.theVilla.image &&
//               Property.theVilla.image.trim() !== "" &&
//               Property.theVilla.image !== "null",
//           },
//           { id: "curation", condition: true },
//           { id: "gallery", condition: hasValidImages(Property.gallery.images) },
//           {
//             id: "living",
//             condition:
//               Property.living.livingImage &&
//               Property.living.livingImage.trim() !== "" &&
//               Property.living.livingImage !== "null",
//           },
//           {
//             id: "kitchenDining",
//             condition: hasValidImages(Property.kitchenDining.images),
//           },
//           {
//             id: "bedrooms",
//             condition:
//               Property.bedrooms.bedroomImage &&
//               Property.bedrooms.bedroomImage.trim() !== "" &&
//               Property.bedrooms.bedroomImage !== "null",
//           },
//           {
//             id: "bedroomGallery",
//             condition: hasValidImages(Property.bedroomGallery.images),
//           },
//           {
//             id: "bedroomGallery2",
//             condition: hasValidImages(Property.bedroomGallery2.images),
//           },
//           {
//             id: "bedroomGalleryMixed",
//             condition: hasValidImages(Property.bedroomGalleryMixed.images),
//           },
//           {
//             id: "bedroomGalleryMixed2",
//             condition: hasValidImages(Property.bedroomGalleryMixed2.images),
//           },
//           {
//             id: "bedroomGalleryMixed3",
//             condition: hasValidImages(Property.bedroomGalleryMixed3.images),
//           },
//           {
//             id: "bedroomGallery3",
//             condition: hasValidImages(Property.bedroomGallery3.images),
//           },
//           {
//             id: "commonareas",
//             condition: hasValidImages(Property.commonareas.images),
//           },
//           {
//             id: "bedroomGallery4",
//             condition: hasValidImages(Property.bedroomGallery4.images),
//           },
//           {
//             id: "bedroomGallery5",
//             condition: hasValidImages(Property.bedroomGallery5.images),
//           },
//           {
//             id: "bedroomGalleryMixed4",
//             condition: hasValidImages(Property.bedroomGalleryMixed4.images),
//           },
//           {
//             id: "bedroomGallery6",
//             condition: hasValidImages(Property.bedroomGallery6.images),
//           },
//           {
//             id: "bedroomGallery7",
//             condition: hasValidImages(Property.bedroomGallery7.images),
//           },
//           { id: "services", condition: true },
//           { id: "aboutZorba", condition: true },
//           { id: "backCover", condition: true },
//         ];

//         // Filter to only pages that pass their condition
//         const filteredPages = pagesConfig.filter((page) => page.condition);

//         // Build a lookup: pageId → index in filteredPages
//         // e.g. "afterPage9" means after the page at index 9 (1-based) → insert after filteredPages[8]
//         // The section string is like "afterPage9", "afterPage16", etc.
//         const parseAfterIndex = (section) => {
//           const match = section?.match(/afterPage(\d+)/);
//           if (!match) return null;
//           const n = parseInt(match[1]);
//           // If the requested page number exceeds filtered list, insert before backCover
//           return Math.min(n, filteredPages.length - 1);
//         };
//         const sectionToPageId = {
//           afterBedroomGallery: "bedroomGallery",
//           afterBedroomGallery4: "bedroomGallery4",
//         };
//         // Build the final ordered list with dynamic pages inserted at right spots
//         // We insert dynamic pages AFTER the Nth page in the filtered list
//         // Collect all dynamic insertions grouped by target index
//         const insertions = {}; // { afterIndex: [dynamicId, ...] }

//         dynamicPagesData.forEach((page, index) => {
//           const hasImages =
//             page.images &&
//             page.images.length > 0 &&
//             page.images.some(
//               (img) => img && img.trim() !== "" && img !== "null",
//             );
//           if (!hasImages) return;

//           const anchorPageId = sectionToPageId[page.section];
//           if (!anchorPageId) return;

//           if (!insertions[anchorPageId]) insertions[anchorPageId] = [];
//           insertions[anchorPageId].push(`dynamic_${index}`);
//         });

//         // Build final list - inject after the matching page ID
//         const finalPages = [];
//         filteredPages.forEach((page) => {
//           finalPages.push(page.id);
//           if (insertions[page.id]) {
//             insertions[page.id].forEach((dynId) => finalPages.push(dynId));
//           }
//         });

//         setPagesToRender(finalPages);
//       } catch (err) {
//         console.error("Fetch error:", err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBrochure();
//   }, [id]);

//   if (loading)
//     return (
//       <div className="flex items-center justify-center min-h-screen">
//         Loading...
//       </div>
//     );
//   if (error)
//     return (
//       <div className="flex items-center justify-center min-h-screen text-red-500">
//         {error}
//       </div>
//     );
//   if (!brochure) return null;

//   const Property = {
//     villa: {
//       logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
//       title: brochure.villa_name,
//       text: brochure.top_text,
//       mainImage: brochure.img_page1,
//       signature: brochure.location,
//       contact: {
//         website: "www.zorbastays.com",
//         email: "info@zorbastays.com",
//         phones: "63552-31066, 98750-28066",
//       },
//     },
//     amenities: {
//       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
//       items: amenities.map((a) => ({
//         name: a.name,
//         imgSrc: a.url,
//       })),
//     },
//     theVilla: {
//       logo: "https://zorbastays.com/android-chrome-512x512.png",
//       image: brochure.img_page3,
//       villaTitle1: brochure.the_title_prefix,
//       villaTitle2: brochure.villa_title_prefix,
//       paragraph1: brochure.villa_desc1,
//       paragraph2: brochure.villa_desc2,
//     },
//     curation: {
//       title: brochure.the_title,
//       footerWebsite: "www.zorbastays.com",
//       steps: [
//         { heading: brochure.curate_title1, description: brochure.curate_desc1 },
//         { heading: brochure.curate_title2, description: brochure.curate_desc2 },
//         { heading: brochure.curate_title3, description: brochure.curate_desc3 },
//         { heading: brochure.curate_title4, description: brochure.curate_desc4 },
//         { heading: brochure.curate_title5, description: brochure.curate_desc5 },
//       ],
//     },
//     gallery: {
//       signature: brochure.pool_title,
//       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
//       images: [
//         brochure.img_page5_1,
//         brochure.img_page5_2,
//         brochure.img_page5_3,
//       ],
//     },
//     living: {
//       logo: "https://zorbastays.com/android-chrome-512x512.png",
//       livingImage: brochure.img_page6,
//       livingtitle1: brochure.the_title,
//       livingtitle2: brochure.living_title,
//       paragraph1: brochure.living_desc1,
//       paragraph2: brochure.living_desc2,
//     },
//     kitchenDining: {
//       title: brochure.kitchen_title,
//       images: [brochure.img_page7_1, brochure.img_page7_2],
//     },
//     bedrooms: {
//       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
//       bedroomImage: brochure.img_page8,
//       bedroomtitle1: brochure.the_bed_title,
//       bedroomtitle2: brochure.bedroom_title,
//       paragraph1: brochure.bed_desc1,
//       paragraph2: brochure.bed_desc2,
//     },
//     bedroomGallery: { images: [brochure.img_page9_1, brochure.img_page9_2] },
//     bedroomGallery2: { images: [brochure.img_page10_1, brochure.img_page10_2] },
//     bedroomGalleryMixed: {
//       images: [
//         brochure.img_page11_1,
//         brochure.img_page11_2,
//         brochure.img_page11_3,
//       ],
//     },
//     bedroomGalleryMixed2: {
//       images: [
//         brochure.img_page12_1,
//         brochure.img_page12_2,
//         brochure.img_page12_3,
//       ],
//     },
//     bedroomGalleryMixed3: {
//       images: [
//         brochure.img_page13_1,
//         brochure.img_page13_2,
//         brochure.img_page13_3,
//       ],
//     },
//     bedroomGallery3: { images: [brochure.img_page14_1, brochure.img_page14_2] },
//     commonareas: {
//       title: brochure.common_areas,
//       images: [brochure.img_page15_1, brochure.img_page15_2],
//     },
//     bedroomGallery4: { images: [brochure.img_page16_1, brochure.img_page16_2] },
//     bedroomGallery5: { images: [brochure.img_page17_1, brochure.img_page17_2] },
//     bedroomGalleryMixed4: {
//       images: [
//         brochure.img_page18_1,
//         brochure.img_page18_2,
//         brochure.img_page18_3,
//       ],
//     },
//     bedroomGallery6: { images: [brochure.img_page19_1, brochure.img_page19_2] },
//     bedroomGallery7: { images: [brochure.img_page20_1, brochure.img_page20_2] },
//     services: {
//       section1: {
//         title: brochure.destination,
//         description: brochure.destination_desc,
//         bannerText: brochure.travel_title,
//         link: brochure.travel_link,
//       },
//       section2: {
//         title: brochure.service,
//         description: brochure.service_desc,
//         bannerText: brochure.concierge_title,
//         link: brochure.concierge_link,
//       },
//     },
//     aboutZorba: {
//       title: brochure.nature,
//       heading: brochure.nature_desc1,
//       paragraph1: brochure.nature_desc2,
//       paragraph2: brochure.nature_desc3,
//       paragraph3: "",
//     },
//     backCover: {
//       logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
//       quoteLine1: "Indulge in the extraordinary;",
//       quoteLine2: "life's too short for ordinary",
//       contact: {
//         website: "www.zorbastays.com",
//         email: "info@zorbastays.com",
//         phones: "63552-31066, 98750-28066",
//       },
//     },
//   };

//   const handleDownload = () => {
//     window.print();
//   };

//   // Render dynamic page based on layout
//   const renderDynamicPage = (dynamicPage, index) => {
//     const { layout, images, section } = dynamicPage;
//     if (!images || images.length === 0) return null;

//     if (layout === "layout1") {
//       return (
//         <div
//           key={`dynamic_${index}`}
//           className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative overflow-hidden"
//         >
//           <div className="w-full h-full flex flex-col relative pt-16 px-1">
//             <div className="flex flex-col space-y-6 w-full">
//               <div className="h-[450px] overflow-hidden">
//                 <img
//                   src={images[0]}
//                   alt="Dynamic 1"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div className="h-[420px] overflow-hidden">
//                 <img
//                   src={images[1]}
//                   alt="Dynamic 2"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       );
//     }

//     if (layout === "layout2") {
//       return (
//         <div
//           key={`dynamic_${index}`}
//           className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative overflow-hidden"
//         >
//           <div className="w-full h-full flex flex-col relative pt-10 px-1">
//             <div className="flex flex-col space-y-4 w-full h-full pb-16">
//               <div className="w-full h-[450px] overflow-hidden">
//                 <img
//                   src={images[0]}
//                   alt="Dynamic 1"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div className="flex space-x-4 w-full h-[450px]">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={images[1]}
//                     alt="Dynamic 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={images[2]}
//                     alt="Dynamic 3"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       );
//     }

//     if (layout === "layout3") {
//       return (
//         <div
//           key={`dynamic_${index}`}
//           className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative overflow-hidden"
//         >
//           <div className="w-full h-full flex flex-col relative pt-10 px-1">
//             <div className="flex flex-col space-y-4 w-full h-full pb-16">
//               <div className="w-full h-[450px] overflow-hidden">
//                 <img
//                   src={images[0]}
//                   alt="Dynamic 1"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div className="flex space-x-4 w-full items-start">
//                 <div className="flex-1 h-[300px] overflow-hidden">
//                   <img
//                     src={images[1]}
//                     alt="Dynamic 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//                 <div className="flex-1 h-[450px] overflow-hidden">
//                   <img
//                     src={images[2]}
//                     alt="Dynamic 3"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       );
//     }

//     return null;
//   };

//   const renderPage = (pageId) => {
//     // Check if it's a dynamic page
//     if (pageId.startsWith("dynamic_")) {
//       const index = parseInt(pageId.split("_")[1]);
//       const dynamicPage = dynamicPages[index];
//       if (dynamicPage) {
//         return renderDynamicPage(dynamicPage, index);
//       }
//       return null;
//     }

//     switch (pageId) {
//       case "cover":
//         return (
//           <div
//             key="cover"
//             className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative flex flex-col items-center p-12"
//           >
//             <div className="absolute top-0 left-12 w-[1px] h-80 bg-gray-400"></div>
//             <div className="absolute top-0 left-20 w-[1px] h-60 bg-gray-400"></div>

//             <div className="mt-8 flex flex-col items-center">
//               <img
//                 src={Property.villa.logo}
//                 alt={Property.villa.title}
//                 className="h-28 w-auto object-contain"
//               />
//             </div>

//             <h2 className="mt-20 text-4xl PlayfairDisplay text-gray-800 tracking-wide">
//               {Property.villa.title}
//             </h2>

//             <div className="mt-20 w-full relative group px-4">
//               <p className="montserrat absolute -top-4 right-4 text-[10px] tracking-[0.2em] text-gray-800 uppercase">
//                 {Property.villa.text}
//               </p>

//               <div className="w-full aspect-[4/3] bg-gray-200 overflow-hidden">
//                 <img
//                   src={Property.villa.mainImage}
//                   alt={Property.villa.title}
//                   className="w-full h-full object-cover"
//                 />
//               </div>

//               <div className="absolute -mt-2 right-0 transform z-10">
//                 <span className="windsong text-7xl text-gray-900">
//                   {Property.villa.signature}
//                 </span>
//               </div>
//             </div>

//             <div className="montserrat absolute bottom-3">
//               <div className="flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
//                 <a
//                   href={`https://zorbastays.com/`}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <span>{Property.villa.contact.website}</span>
//                 </a>
//                 <span className="h-3 w-[1px] bg-gray-400"></span>
//                 <a href={`mailto:info@zorbastays.com`}>
//                   <span>{Property.villa.contact.email}</span>
//                 </a>
//                 <span className="h-3 w-[1px] bg-gray-400"></span>
//                 <span>{Property.villa.contact.phones}</span>
//               </div>
//             </div>
//           </div>
//         );

//       case "amenities":
//         if (!Property.amenities.items.length) return null;
//         return Array.from(
//           { length: Math.ceil(Property.amenities.items.length / 10) },
//           (_, i) => Property.amenities.items.slice(i * 10, i * 10 + 10),
//         ).map((amenityGroup, pageIndex, allPages) => (
//           <div
//             key={`amenities-${pageIndex}`}
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative flex flex-col"
//           >
//             {pageIndex === 0 && (
//               <div className="mt-8 ml-6 flex-none">
//                 <h1 className="text-3xl EBGaramond text-gray-800">The</h1>
//                 <h2 className="text-4xl PlayfairDisplay tracking-widest text-gray-800 uppercase mt-2">
//                   Amenities
//                 </h2>
//               </div>
//             )}

//             <div
//               className={`flex-grow flex items-start justify-center ${pageIndex === 0 ? "pt-20" : "pt-32"}`}
//             >
//               <div className="grid grid-cols-2 gap-y-12 gap-x-12 px-4 w-full">
//                 {amenityGroup.map((item, index) => (
//                   <div key={index} className="flex items-center space-x-6">
//                     <div className="w-24 h-24 flex items-center justify-center flex-none">
//                       <img
//                         src={item.imgSrc}
//                         alt={item.name}
//                         className="max-w-full max-h-full object-contain brightness-0 grayscale"
//                       />
//                     </div>
//                     <span className="text-[11px] font-medium tracking-[0.2em] uppercase text-gray-800 leading-tight">
//                       {item.name}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             {pageIndex === allPages.length - 1 && (
//               <div className="mt-auto mb-4 flex justify-center items-center space-x-4">
//                 <div className="w-12 h-[1px] bg-gray-400"></div>
//                 <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
//                   <img
//                     src={Property.amenities.logo}
//                     alt="logo"
//                     className="w-8 h-5 brightness-0"
//                   />
//                 </div>
//                 <div className="w-12 h-[1px] bg-gray-400"></div>
//               </div>
//             )}
//           </div>
//         ));

//       case "theVilla":
//         return (
//           <div
//             key="theVilla"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             {(() => {
//               const totalChars =
//                 (Property.theVilla.paragraph1?.length || 0) +
//                 (Property.theVilla.paragraph2?.length || 0);

//               const imageBottom =
//                 totalChars > 600 ? "bottom-[40px]" : "bottom-[170px]";
//               const logoBottom =
//                 totalChars > 600 ? "bottom-[20px]" : "bottom-[70px]";

//               return (
//                 <>
//                   <div className="mb-8 ml-1">
//                     <h1 className="text-3xl EBGaramond text-gray-800 leading-tight">
//                       {Property.theVilla.villaTitle1}
//                     </h1>
//                     <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2">
//                       {Property.theVilla.villaTitle2}
//                     </h2>
//                   </div>

//                   <div
//                     className="montserrat flex flex-col ml-1 space-y-6 text-gray-800 tracking-widest text-base text-justify max-w-[100%]"
//                     style={{ wordSpacing: "1px" }}
//                   >
//                     <p>{Property.theVilla.paragraph1}</p>
//                     <p>{Property.theVilla.paragraph2}</p>
//                   </div>

//                   <div
//                     className={`absolute left-12 right-12 h-[430px] z-20 ${imageBottom}`}
//                   >
//                     <img
//                       src={Property.theVilla.image}
//                       alt="Villa Exterior"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>

//                   <div
//                     className={`absolute left-8 w-28 h-28 opacity-20 grayscale z-10 ${logoBottom}`}
//                   >
//                     <img
//                       src={Property.theVilla.logo}
//                       alt="Logo Watermark"
//                       className="w-full h-full object-contain"
//                     />
//                   </div>
//                 </>
//               );
//             })()}
//           </div>
//         );

//       case "curation":
//         return (
//           <div
//             key="curation"
//             className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col pt-10 px-16 relative">
//               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-20 -ml-5">
//                 The way we curate.
//               </h2>

//               <div className="relative w-full flex-1">
//                 <div className="absolute -top-16 mt-4 -right-5 inset-0 flex justify-center pointer-events-none">
//                   <img
//                     src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/3ea0d39f-9e34-4305-7ea0-07304c880a00/public"
//                     alt="timeline"
//                     className="opacity-60 w-auto h-[750px] object-contain"
//                   />
//                 </div>

//                 <div className="relative z-10 flex flex-col space-y-3">
//                   {Property.curation.steps?.map((step, idx) => (
//                     <div
//                       key={idx}
//                       className={`max-w-[295px] ${
//                         idx === 0
//                           ? "-ml-6 self-start"
//                           : idx === 1
//                             ? "w-full self-end mr-20 relative -top-24 max-w-[290px]"
//                             : idx === 2
//                               ? "w-full self-end mr-10 relative -top-14 max-w-[310px]"
//                               : idx === 3
//                                 ? "w-full self-start relative -top-16 max-w-[300px]"
//                                 : idx === 4
//                                   ? "w-full self-end relative -top-16 max-w-[310px]"
//                                   : ""
//                       }`}
//                     >
//                       <h3 className="PlayfairDisplay text-xl text-gray-800 leading-tight mb-2">
//                         {step.heading}
//                       </h3>

//                       <p className="montserrat text-[13px] text-gray-800 leading-relaxed tracking-wide">
//                         {step.description}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               <div className="absolute -bottom-10 left-0 w-full text-center">
//                 <a
//                   href="https://zorbastays.com/"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <span className="text-[15px] tracking-[0.1em] text-gray-500">
//                     {Property.curation.footerWebsite}
//                   </span>
//                 </a>
//               </div>
//             </div>
//           </div>
//         );

//       case "gallery":
//         return (
//           <div
//             key="gallery"
//             className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12"
//           >
//             <div className="w-full h-full flex flex-col relative">
//               <div className="absolute -top-20 left-6 w-[1px] h-[280px] bg-gray-400"></div>

//               <div className="flex flex-col items-end z-10 mt-24">
//                 <span className="waterfall text-7xl text-gray-900 text-right max-w-[90%]">
//                   {Property.gallery.signature}
//                 </span>
//               </div>

//               <div className="w-full flex flex-row space-x-4">
//                 <div className="flex flex-col space-y-4 w-[65%]">
//                   <div className="aspect-[16/12] overflow-hidden">
//                     <img
//                       src={Property.gallery.images[0]}
//                       alt="Pool view 1"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>

//                   <div className="aspect-[16/12] overflow-hidden">
//                     <img
//                       src={Property.gallery.images[1]}
//                       alt="Archway view"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 </div>

//                 <div className="flex-1 h-[400px] overflow-hidden">
//                   <img
//                     src={Property.gallery.images[2]}
//                     alt="Pool view 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>

//               <div className="absolute -bottom-40 w-full flex justify-center items-center space-x-4">
//                 <div className="w-12 h-[1.5px] bg-gray-400"></div>
//                 <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
//                   <img
//                     src={Property.gallery.logo}
//                     alt={Property.gallery.title}
//                     className="w-8 h-5 brightness-0"
//                   />
//                 </div>
//                 <div className="w-12 h-[1.5px] bg-gray-400"></div>
//               </div>
//             </div>
//           </div>
//         );

//       case "living":
//         return (
//           <div
//             key="living"
//             className="print-page bg-[#f8f7f6] w-[210mm] h-[297mm] p-12 pt-20 flex flex-col shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full relative flex flex-col px-1 pt-10">
//               {/* Watermark */}
//               <div
//                 className="absolute -top-10 right-0 w-[430px] h-[430px] opacity-5 pointer-events-none translate-x-14 -translate-y-14"
//                 style={{ wordSpacing: "4px" }}
//               >
//                 <img
//                   src={Property.living.logo}
//                   alt="Watermark"
//                   className="w-full h-full object-contain grayscale"
//                 />
//               </div>

//               {/* Content */}
//               <div className="relative z-10 flex flex-col h-full">
//                 {/* Heading */}
//                 <div>
//                   <h1 className="text-3xl EBGaramond text-gray-800 leading-tight">
//                     {Property.living.livingtitle1}
//                   </h1>

//                   <h2 className="text-4xl PlayfairDisplay text-gray-800 tracking-widest uppercase mb-8">
//                     {Property.living.livingtitle2}
//                   </h2>

//                   {/* Paragraphs */}
//                   <div className="montserrat flex flex-col space-y-6 text-gray-800 text-[15px] tracking-widest max-w-[100%]">
//                     <p>{Property.living.paragraph1}</p>
//                     <p>{Property.living.paragraph2}</p>
//                   </div>
//                 </div>

//                 {/* Bottom Fixed Image */}
//                 <div className="absolute left-0 right-0 bottom-20 h-[460px]">
//                   <div className="w-full h-[460px] overflow-hidden border-2 border-gray-300">
//                     <img
//                       src={Property.living.livingImage}
//                       alt="Living Area"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* Bottom Lines */}
//               <div className="absolute -bottom-16 left-12 flex gap-6">
//                 <div className="w-[1px] h-36 bg-gray-400"></div>
//                 <div className="w-[1px] h-36 bg-gray-400"></div>
//               </div>
//             </div>
//           </div>
//         );

//       case "kitchenDining":
//         return (
//           <div
//             key="kitchenDining"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="absolute top-4 right-1 z-20">
//                 <span className="waterfall text-7xl text-gray-900 drop-shadow-sm">
//                   {Property.kitchenDining.title}
//                 </span>
//               </div>

//               <div className="flex flex-col space-y-6 w-full h-full pt-20">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.kitchenDining.images[0]}
//                     alt="Kitchen Area"
//                     className="w-full h-[420px] object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.kitchenDining.images[1]}
//                     alt="Dining Area"
//                     className="w-full h-[420px] object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedrooms":
//         return (
//           <div
//             key="bedrooms"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col px-1 pt-20 relative">
//               <div className="mb-8">
//                 <h1 className="text-3xl EBGaramond text-gray-800 leading-tight">
//                   {Property.bedrooms.bedroomtitle1}
//                 </h1>
//                 <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2 tracking-wide">
//                   {Property.bedrooms.bedroomtitle2}
//                 </h2>
//               </div>

//               <div
//                 className="montserrat flex flex-col space-y-8 text-gray-800 tracking-widest text-[14px] text-justify max-w-[95%] leading-relaxed"
//                 style={{ wordSpacing: "1px" }}
//               >
//                 <p>{Property.bedrooms.paragraph1}</p>
//                 <p>{Property.bedrooms.paragraph2}</p>
//               </div>

//               <div className="mt-10 w-full aspect-[16/11] overflow-hidden">
//                 <img
//                   src={Property.bedrooms.bedroomImage}
//                   alt="Bedroom Interior"
//                   className="w-full h-full object-cover"
//                 />
//               </div>

//               <div className="absolute -bottom-12 left-0 w-full flex justify-center items-center space-x-4">
//                 <div className="w-12 h-[2px] bg-gray-400"></div>
//                 <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
//                   <img
//                     src={Property.bedrooms.logo}
//                     alt="Logo"
//                     className="w-7 h-5 brightness-0 opacity-70"
//                   />
//                 </div>
//                 <div className="w-12 h-[2px] bg-gray-400"></div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery":
//         return (
//           <div
//             key="bedroomGallery"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden shadow-sm">
//                   <img
//                     src={Property.bedroomGallery.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-[450px] object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden shadow-sm">
//                   <img
//                     src={Property.bedroomGallery.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-[420px] object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery2":
//         return (
//           <div
//             key="bedroomGallery2"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery2.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery2.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGalleryMixed":
//         return (
//           <div
//             key="bedroomGalleryMixed"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-5 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pb-10">
//                 <div className="w-full h-[45%] overflow-hidden">
//                   <img
//                     src={Property.bedroomGalleryMixed.images[0]}
//                     alt="Master Bedroom View"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex space-x-4 w-full h-[45%]">
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed.images[1]}
//                       alt="Bedroom Seating"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed.images[2]}
//                       alt="Bedroom Detail"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGalleryMixed2":
//         return (
//           <div
//             key="bedroomGalleryMixed2"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-0 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pb-16">
//                 <div className="w-full h-[45%] overflow-hidden">
//                   <img
//                     src={Property.bedroomGalleryMixed2.images[0]}
//                     alt="Master Bedroom View"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex space-x-4 w-full h-[45%]">
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed2.images[1]}
//                       alt="Bedroom Seating"
//                       className="w-full h-[25vh] object-cover"
//                     />
//                   </div>
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed2.images[2]}
//                       alt="Bedroom Detail"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGalleryMixed3":
//         return (
//           <div
//             key="bedroomGalleryMixed3"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-5 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pb-16">
//                 <div className="w-full h-[45%] overflow-hidden">
//                   <img
//                     src={Property.bedroomGalleryMixed3.images[0]}
//                     alt="Master Bedroom View"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex space-x-4 w-full h-[45%]">
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed3.images[1]}
//                       alt="Bedroom Seating"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed3.images[2]}
//                       alt="Bedroom Detail"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery3":
//         return (
//           <div
//             key="bedroomGallery3"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery3.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery3.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "commonareas":
//         return (
//           <div
//             key="commonareas"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="absolute top-0 left-6 z-20 flex items-center w-full">
//                 <span className="waterfall text-7xl text-gray-800 pr-6">
//                   {Property.commonareas.title}
//                 </span>
//                 <div className="flex-1 h-[1px] bg-gray-400 -mr-6"></div>
//               </div>

//               <div className="absolute top-24 left-3 w-[1px] h-[970px] bg-gray-400"></div>

//               <div className="flex flex-col space-y-4 w-full h-[950px] pt-28 pl-16">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.commonareas.images[0]}
//                     alt="Common Area Overview"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.commonareas.images[1]}
//                     alt="Lounge and Staircase"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery4":
//         return (
//           <div
//             key="bedroomGallery4"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-5 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery4.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery4.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery5":
//         return (
//           <div
//             key="bedroomGallery5"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery5.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery5.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGalleryMixed4":
//         return (
//           <div
//             key="bedroomGalleryMixed4"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-5 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pb-16">
//                 <div className="w-full h-[45%] overflow-hidden">
//                   <img
//                     src={Property.bedroomGalleryMixed4.images[0]}
//                     alt="Master Bedroom View"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex space-x-4 w-full h-[45%]">
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed4.images[1]}
//                       alt="Bedroom Seating"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                   <div className="flex-1 overflow-hidden">
//                     <img
//                       src={Property.bedroomGalleryMixed4.images[2]}
//                       alt="Bedroom Detail"
//                       className="w-full h-[25vh] object-cover"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery6":
//         return (
//           <div
//             key="bedroomGallery6"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery6.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery6.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "bedroomGallery7":
//         return (
//           <div
//             key="bedroomGallery7"
//             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
//           >
//             <div className="w-full h-full flex flex-col relative pt-10 px-1">
//               <div className="flex flex-col space-y-4 w-full h-full pt-10">
//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery7.images[0]}
//                     alt="Bedroom Suite 1"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 overflow-hidden">
//                   <img
//                     src={Property.bedroomGallery7.images[1]}
//                     alt="Bedroom Suite 2"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       case "services":
//         return (
//           <div
//             key="services"
//             className="print-page w-[210mm] min-h-[297mm] pl-8 pr-5 pt-20 flex flex-col relative bg-[#f8f7f6] shadow-md"
//           >
//             <div className="mb-12 max-w-[92%] ml-5">
//               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-6">
//                 {Property.services.section1.title}
//               </h2>
//               <p
//                 className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-10"
//                 style={{ wordSpacing: "1px" }}
//               >
//                 {Property.services.section1.description}
//               </p>

//               <div
//                 className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-center"
//                 style={{
//                   backgroundImage:
//                     "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
//                 }}
//               >
//                 <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
//                 <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
//                   {Property.services.section1.bannerText}
//                 </h3>
//                 <a
//                   href={Property.services.section1.link}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
//                     Click Here
//                   </button>
//                 </a>
//               </div>
//             </div>

//             <div className="max-w-[92%] ml-5">
//               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-10 mt-10">
//                 {Property.services.section2.title}
//               </h2>
//               <p
//                 className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-8"
//                 style={{ wordSpacing: "1px" }}
//               >
//                 {Property.services.section2.description}
//               </p>

//               <div
//                 className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-top"
//                 style={{
//                   backgroundImage:
//                     "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
//                 }}
//               >
//                 <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
//                 <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
//                   {Property.services.section2.bannerText}
//                 </h3>
//                 <a
//                   href={Property.services.section2.link}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
//                     Click Here
//                   </button>
//                 </a>
//               </div>
//             </div>
//           </div>
//         );

//       case "aboutZorba":
//         return (
//           <div
//             key="aboutZorba"
//             className="print-page w-[210mm] min-h-[297mm] relative flex flex-col pt-10 pl-5 px-1 overflow-hidden bg-[#f8f7f6] shadow-md"
//           >
//             <div className="absolute top-10 right-12 z-20 flex items-center justify-end w-full">
//               <div className="flex-1 h-[1px] bg-gray-400 ml-0"></div>
//               <span className="waterfall text-8xl text-gray-800 pl-6">
//                 {Property.aboutZorba.title || "About"}
//               </span>
//             </div>

//             <div className="absolute top-32 -bottom-12 right-12 w-[1.5px] bg-gray-400"></div>

//             <div className="flex flex-col justify-center h-full max-w-[95%] pr-16 pl-8 pt-[40vh]">
//               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-8 leading-tight">
//                 {Property.aboutZorba.heading}
//               </h2>

//               <div
//                 className="montserrat flex flex-col space-y-8 text-gray-800 text-[15px] tracking-widest text-justify"
//                 style={{ wordSpacing: "1px" }}
//               >
//                 <p>{Property.aboutZorba.paragraph1}</p>
//                 <p>{Property.aboutZorba.paragraph2}</p>
//                 <p>{Property.aboutZorba.paragraph3}</p>
//               </div>
//             </div>
//           </div>
//         );

//       case "backCover":
//         return (
//           <div
//             key="backCover"
//             className="print-page w-[210mm] min-h-[297mm] flex flex-col justify-between items-center py-16 px-1 bg-[#f8f7f6] shadow-md relative"
//           >
//             <div className="flex flex-col items-center mt-60">
//               <img
//                 src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public"
//                 alt="Logo"
//                 className="h-44 w-auto object-contain"
//               />
//             </div>

//             <div className="flex flex-col items-center space-y-32">
//               <div className="text-center">
//                 <span className="waterfall text-8xl block">
//                   {Property.backCover.quoteLine1}
//                 </span>
//                 <span className="waterfall text-7xl block">
//                   {Property.backCover.quoteLine2}
//                 </span>
//               </div>

//               <div className="montserrat flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
//                 <a
//                   href={`https://zorbastays.com/`}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   {Property.backCover.contact.website}
//                 </a>
//                 <span className="h-3 w-[1px] bg-gray-400"></span>
//                 <a href={`mailto:info@zorbastays.com`}>
//                   {Property.backCover.contact.email}
//                 </a>
//                 <span className="h-3 w-[1px] bg-gray-400"></span>
//                 <span>{Property.backCover.contact.phones}</span>
//               </div>
//             </div>
//           </div>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="bg-white min-h-screen flex flex-col items-center py-10 gap-10 print:gap-0 print:py-0 print:p-0 print:bg-[#f8f7f6]">
//       <div className="fixed right-5 bottom-20 print:hidden">
//         <button
//           onClick={handleDownload}
//           className="flex gap-2 justify-center items-center bg-black text-white w-48 py-3 rounded-md tracking-widest text-sm hover:bg-green-800 transition duration-200 ease-linear"
//         >
//           <FaDownload />
//           Download PDF
//         </button>
//       </div>

//       <div className="fixed right-5 bottom-5 print:hidden">
//         <button
//           onClick={() => navigate("/PropertyBrochure")}
//           className="flex gap-2 justify-center items-center border-2 border-black text-black font-semibold w-48 py-2.5 rounded-md tracking-widest text-sm hover:bg-black hover:text-white transition duration-200 ease-linear"
//         >
//           <CgTemplate />
//           Back to Brochures
//         </button>
//       </div>

//       <style
//         dangerouslySetInnerHTML={{
//           __html: `
//             @page {
//               size: A4 portrait;
//               margin: 0;
//             }

//             @media print {
//               html, body {
//                 width: 210mm;
//                 margin: 0;
//                 padding: 0;
//                 height: auto !important;
//                 -webkit-print-color-adjust: exact;
//                 print-color-adjust: exact;
//               }

//               body {
//                 zoom: 100%;
//               }

//               .print-page {
//                 width: 210mm !important;
//                 min-height: 297mm !important;
//                 page-break-after: always;
//                 break-after: page;
//                 page-break-inside: avoid;
//                 break-inside: avoid;
//                 margin: 0 !important;
//               }

//               .print-page:last-of-type {
//                 page-break-after: auto !important;
//                 break-after: auto !important;
//               }

//               .shadow-md {
//                 box-shadow: none !important;
//               }
//             }
//           `,
//         }}
//       />

//       {pagesToRender.map((pageId) => renderPage(pageId))}
//     </div>
//   );
// };

// export default BrochurePDF;
// //Dee Code Working
// // import React, { useEffect, useState } from "react";
// // import { useNavigate, useParams } from "react-router-dom";
// // import { CgTemplate } from "react-icons/cg";
// // import { FaDownload } from "react-icons/fa6";

// // const BrochurePDF = () => {
// //   const { id } = useParams();
// //   const navigate = useNavigate();
// //   const [brochure, setBrochure] = useState(null);
// //   const [amenities, setAmenities] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [pagesToRender, setPagesToRender] = useState([]);
// //   const [dynamicPages, setDynamicPages] = useState([]);

// //   useEffect(() => {
// //     const fetchBrochure = async () => {
// //       try {
// //         const res = await fetch(
// //           `https://dash.zorbastays.com/web-backend/getBrochure/${id}`,
// //         );

// //         const rawText = await res.text();
// //         console.log("RAW RESPONSE:", rawText);

// //         let json;
// //         try {
// //           json = JSON.parse(rawText);
// //           console.log("Parsed JSON:", json);
// //         } catch (parseError) {
// //           console.error("JSON Parse Error:", parseError);
// //           throw new Error(
// //             `Invalid response from server. Status: ${res.status}`,
// //           );
// //         }

// //         if (!json.success) throw new Error(json.message);
// //         setBrochure(json.data);

// //         // Parse dynamic pages if they exist
// //         let dynamicPagesData = [];
// //         if (json.data.dynamic_pages && Array.isArray(json.data.dynamic_pages)) {
// //           dynamicPagesData = json.data.dynamic_pages;
// //           setDynamicPages(dynamicPagesData);
// //           console.log("Dynamic pages:", dynamicPagesData);
// //         }

// //         const amenityIds = Array.isArray(json.data.amenity_ids)
// //           ? json.data.amenity_ids
// //           : JSON.parse(json.data.amenity_ids || "[]");

// //         let amenitiesData = [];
// //         if (amenityIds.length > 0) {
// //           const amenityRes = await fetch(
// //             `https://dash.zorbastays.com/web-backend/getAmenitiesById?ids=${amenityIds.join(",")}`,
// //           );
// //           const amenityJson = await amenityRes.json();
// //           if (amenityJson.success) {
// //             amenitiesData = amenityJson.data;
// //             setAmenities(amenitiesData);
// //           }
// //         }

// //         // Build Property object to check images
// //         const Property = {
// //           villa: {
// //             logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
// //             title: json.data.villa_name,
// //             text: json.data.top_text,
// //             mainImage: json.data.img_page1,
// //             signature: json.data.location,
// //             contact: {
// //               website: "www.zorbastays.com",
// //               email: "info@zorbastays.com",
// //               phones: "63552-31066, 98750-28066",
// //             },
// //           },
// //           amenities: {
// //             logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //             items: amenitiesData.map((a) => ({
// //               name: a.name,
// //               imgSrc: a.url,
// //             })),
// //           },
// //           theVilla: {
// //             logo: "https://zorbastays.com/android-chrome-512x512.png",
// //             image: json.data.img_page3,
// //             paragraph1: json.data.villa_desc1,
// //             paragraph2: json.data.villa_desc2,
// //           },
// //           curation: {
// //             title: json.data.the_title,
// //             footerWebsite: "www.zorbastays.com",
// //             steps: [
// //               {
// //                 heading: json.data.curate_title1,
// //                 description: json.data.curate_desc1,
// //               },
// //               {
// //                 heading: json.data.curate_title2,
// //                 description: json.data.curate_desc2,
// //               },
// //               {
// //                 heading: json.data.curate_title3,
// //                 description: json.data.curate_desc3,
// //               },
// //               {
// //                 heading: json.data.curate_title4,
// //                 description: json.data.curate_desc4,
// //               },
// //               {
// //                 heading: json.data.curate_title5,
// //                 description: json.data.curate_desc5,
// //               },
// //             ],
// //           },
// //           gallery: {
// //             signature: json.data.pool_title,
// //             logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //             images: [
// //               json.data.img_page5_1,
// //               json.data.img_page5_2,
// //               json.data.img_page5_3,
// //             ],
// //           },
// //           living: {
// //             logo: "https://zorbastays.com/android-chrome-512x512.png",
// //             livingImage: json.data.img_page6,
// //             paragraph1: json.data.living_desc1,
// //             paragraph2: json.data.living_desc2,
// //           },
// //           kitchenDining: {
// //             title: json.data.kitchen_title,
// //             images: [json.data.img_page7_1, json.data.img_page7_2],
// //           },
// //           bedrooms: {
// //             logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //             bedroomImage: json.data.img_page8,
// //             paragraph1: json.data.bed_desc1,
// //             paragraph2: json.data.bed_desc2,
// //           },
// //           bedroomGallery: {
// //             images: [json.data.img_page9_1, json.data.img_page9_2],
// //           },
// //           bedroomGallery2: {
// //             images: [json.data.img_page10_1, json.data.img_page10_2],
// //           },
// //           bedroomGalleryMixed: {
// //             images: [
// //               json.data.img_page11_1,
// //               json.data.img_page11_2,
// //               json.data.img_page11_3,
// //             ],
// //           },
// //           bedroomGalleryMixed2: {
// //             images: [
// //               json.data.img_page12_1,
// //               json.data.img_page12_2,
// //               json.data.img_page12_3,
// //             ],
// //           },
// //           bedroomGalleryMixed3: {
// //             images: [
// //               json.data.img_page13_1,
// //               json.data.img_page13_2,
// //               json.data.img_page13_3,
// //             ],
// //           },
// //           bedroomGallery3: {
// //             images: [json.data.img_page14_1, json.data.img_page14_2],
// //           },
// //           commonareas: {
// //             title: json.data.common_areas,
// //             images: [json.data.img_page15_1, json.data.img_page15_2],
// //           },
// //           bedroomGallery4: {
// //             images: [json.data.img_page16_1, json.data.img_page16_2],
// //           },
// //           bedroomGallery5: {
// //             images: [json.data.img_page17_1, json.data.img_page17_2],
// //           },
// //           bedroomGalleryMixed4: {
// //             images: [
// //               json.data.img_page18_1,
// //               json.data.img_page18_2,
// //               json.data.img_page18_3,
// //             ],
// //           },
// //           bedroomGallery6: {
// //             images: [json.data.img_page19_1, json.data.img_page19_2],
// //           },
// //           bedroomGallery7: {
// //             images: [json.data.img_page20_1, json.data.img_page20_2],
// //           },
// //           services: {
// //             section1: {
// //               title: json.data.destination,
// //               description: json.data.destination_desc,
// //               bannerText: json.data.travel_title,
// //               link: json.data.travel_link,
// //             },
// //             section2: {
// //               title: json.data.service,
// //               description: json.data.service_desc,
// //               bannerText: json.data.concierge_title,
// //               link: json.data.concierge_link,
// //             },
// //           },
// //           aboutZorba: {
// //             title: json.data.nature,
// //             heading: json.data.nature_desc1,
// //             paragraph1: json.data.nature_desc2,
// //             paragraph2: json.data.nature_desc3,
// //             paragraph3: "",
// //           },
// //           backCover: {
// //             logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
// //             quoteLine1: "Indulge in the extraordinary;",
// //             quoteLine2: "life's too short for ordinary",
// //             contact: {
// //               website: "www.zorbastays.com",
// //               email: "info@zorbastays.com",
// //               phones: "63552-31066, 98750-28066",
// //             },
// //           },
// //         };

// //         const hasValidImages = (images) => {
// //           if (!images || !Array.isArray(images)) return false;
// //           return images.some(
// //             (img) => img && img.trim() !== "" && img !== "null",
// //           );
// //         };

// //         const pagesConfig = [
// //           { id: "cover", condition: true },
// //           {
// //             id: "amenities",
// //             condition:
// //               Property.amenities.items && Property.amenities.items.length > 0,
// //           },
// //           {
// //             id: "theVilla",
// //             condition:
// //               Property.theVilla.image &&
// //               Property.theVilla.image.trim() !== "" &&
// //               Property.theVilla.image !== "null",
// //           },
// //           { id: "curation", condition: true },
// //           { id: "gallery", condition: hasValidImages(Property.gallery.images) },
// //           {
// //             id: "living",
// //             condition:
// //               Property.living.livingImage &&
// //               Property.living.livingImage.trim() !== "" &&
// //               Property.living.livingImage !== "null",
// //           },
// //           {
// //             id: "kitchenDining",
// //             condition: hasValidImages(Property.kitchenDining.images),
// //           },
// //           {
// //             id: "bedrooms",
// //             condition:
// //               Property.bedrooms.bedroomImage &&
// //               Property.bedrooms.bedroomImage.trim() !== "" &&
// //               Property.bedrooms.bedroomImage !== "null",
// //           },
// //           {
// //             id: "bedroomGallery",
// //             condition: hasValidImages(Property.bedroomGallery.images),
// //           },
// //           {
// //             id: "bedroomGallery2",
// //             condition: hasValidImages(Property.bedroomGallery2.images),
// //           },
// //           {
// //             id: "bedroomGalleryMixed",
// //             condition: hasValidImages(Property.bedroomGalleryMixed.images),
// //           },
// //           {
// //             id: "bedroomGalleryMixed2",
// //             condition: hasValidImages(Property.bedroomGalleryMixed2.images),
// //           },
// //           {
// //             id: "bedroomGalleryMixed3",
// //             condition: hasValidImages(Property.bedroomGalleryMixed3.images),
// //           },
// //           {
// //             id: "bedroomGallery3",
// //             condition: hasValidImages(Property.bedroomGallery3.images),
// //           },
// //           {
// //             id: "commonareas",
// //             condition: hasValidImages(Property.commonareas.images),
// //           },
// //           {
// //             id: "bedroomGallery4",
// //             condition: hasValidImages(Property.bedroomGallery4.images),
// //           },
// //           {
// //             id: "bedroomGallery5",
// //             condition: hasValidImages(Property.bedroomGallery5.images),
// //           },
// //           {
// //             id: "bedroomGalleryMixed4",
// //             condition: hasValidImages(Property.bedroomGalleryMixed4.images),
// //           },
// //           {
// //             id: "bedroomGallery6",
// //             condition: hasValidImages(Property.bedroomGallery6.images),
// //           },
// //           {
// //             id: "bedroomGallery7",
// //             condition: hasValidImages(Property.bedroomGallery7.images),
// //           },
// //           { id: "services", condition: true },
// //           { id: "aboutZorba", condition: true },
// //           { id: "backCover", condition: true },
// //         ];

// //         // Filter to only pages that pass their condition
// //         const filteredPages = pagesConfig.filter((page) => page.condition);

// //         // Build a lookup: pageId → index in filteredPages
// //         // e.g. "afterPage9" means after the page at index 9 (1-based) → insert after filteredPages[8]
// //         // The section string is like "afterPage9", "afterPage16", etc.
// //         const parseAfterIndex = (section) => {
// //           const match = section?.match(/afterPage(\d+)/);
// //           if (!match) return null;
// //           const n = parseInt(match[1]);
// //           // If the requested page number exceeds filtered list, insert before backCover
// //           return Math.min(n, filteredPages.length - 1);
// //         };
// //         const sectionToPageId = {
// //           afterBedroomGallery: "bedroomGallery",
// //           afterBedroomGallery4: "bedroomGallery4",
// //         };
// //         // Build the final ordered list with dynamic pages inserted at right spots
// //         // We insert dynamic pages AFTER the Nth page in the filtered list
// //         // Collect all dynamic insertions grouped by target index
// //         const insertions = {}; // { afterIndex: [dynamicId, ...] }

// //         dynamicPagesData.forEach((page, index) => {
// //           const hasImages =
// //             page.images &&
// //             page.images.length > 0 &&
// //             page.images.some(
// //               (img) => img && img.trim() !== "" && img !== "null",
// //             );
// //           if (!hasImages) return;

// //           const anchorPageId = sectionToPageId[page.section];
// //           if (!anchorPageId) return;

// //           if (!insertions[anchorPageId]) insertions[anchorPageId] = [];
// //           insertions[anchorPageId].push(`dynamic_${index}`);
// //         });

// //         // Build final list - inject after the matching page ID
// //         const finalPages = [];
// //         filteredPages.forEach((page) => {
// //           finalPages.push(page.id);
// //           if (insertions[page.id]) {
// //             insertions[page.id].forEach((dynId) => finalPages.push(dynId));
// //           }
// //         });

// //         setPagesToRender(finalPages);
// //       } catch (err) {
// //         console.error("Fetch error:", err);
// //         setError(err.message);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchBrochure();
// //   }, [id]);

// //   if (loading)
// //     return (
// //       <div className="flex items-center justify-center min-h-screen">
// //         Loading...
// //       </div>
// //     );
// //   if (error)
// //     return (
// //       <div className="flex items-center justify-center min-h-screen text-red-500">
// //         {error}
// //       </div>
// //     );
// //   if (!brochure) return null;

// //   const Property = {
// //     villa: {
// //       logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
// //       title: brochure.villa_name,
// //       text: brochure.top_text,
// //       mainImage: brochure.img_page1,
// //       signature: brochure.location,
// //       contact: {
// //         website: "www.zorbastays.com",
// //         email: "info@zorbastays.com",
// //         phones: "63552-31066, 98750-28066",
// //       },
// //     },
// //     amenities: {
// //       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //       items: amenities.map((a) => ({
// //         name: a.name,
// //         imgSrc: a.url,
// //       })),
// //     },
// //     theVilla: {
// //       logo: "https://zorbastays.com/android-chrome-512x512.png",
// //       image: brochure.img_page3,
// //       paragraph1: brochure.villa_desc1,
// //       paragraph2: brochure.villa_desc2,
// //     },
// //     curation: {
// //       title: brochure.the_title,
// //       footerWebsite: "www.zorbastays.com",
// //       steps: [
// //         { heading: brochure.curate_title1, description: brochure.curate_desc1 },
// //         { heading: brochure.curate_title2, description: brochure.curate_desc2 },
// //         { heading: brochure.curate_title3, description: brochure.curate_desc3 },
// //         { heading: brochure.curate_title4, description: brochure.curate_desc4 },
// //         { heading: brochure.curate_title5, description: brochure.curate_desc5 },
// //       ],
// //     },
// //     gallery: {
// //       signature: brochure.pool_title,
// //       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //       images: [
// //         brochure.img_page5_1,
// //         brochure.img_page5_2,
// //         brochure.img_page5_3,
// //       ],
// //     },
// //     living: {
// //       logo: "https://zorbastays.com/android-chrome-512x512.png",
// //       livingImage: brochure.img_page6,
// //       paragraph1: brochure.living_desc1,
// //       paragraph2: brochure.living_desc2,
// //     },
// //     kitchenDining: {
// //       title: brochure.kitchen_title,
// //       images: [brochure.img_page7_1, brochure.img_page7_2],
// //     },
// //     bedrooms: {
// //       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //       bedroomImage: brochure.img_page8,
// //       paragraph1: brochure.bed_desc1,
// //       paragraph2: brochure.bed_desc2,
// //     },
// //     bedroomGallery: { images: [brochure.img_page9_1, brochure.img_page9_2] },
// //     bedroomGallery2: { images: [brochure.img_page10_1, brochure.img_page10_2] },
// //     bedroomGalleryMixed: {
// //       images: [
// //         brochure.img_page11_1,
// //         brochure.img_page11_2,
// //         brochure.img_page11_3,
// //       ],
// //     },
// //     bedroomGalleryMixed2: {
// //       images: [
// //         brochure.img_page12_1,
// //         brochure.img_page12_2,
// //         brochure.img_page12_3,
// //       ],
// //     },
// //     bedroomGalleryMixed3: {
// //       images: [
// //         brochure.img_page13_1,
// //         brochure.img_page13_2,
// //         brochure.img_page13_3,
// //       ],
// //     },
// //     bedroomGallery3: { images: [brochure.img_page14_1, brochure.img_page14_2] },
// //     commonareas: {
// //       title: brochure.common_areas,
// //       images: [brochure.img_page15_1, brochure.img_page15_2],
// //     },
// //     bedroomGallery4: { images: [brochure.img_page16_1, brochure.img_page16_2] },
// //     bedroomGallery5: { images: [brochure.img_page17_1, brochure.img_page17_2] },
// //     bedroomGalleryMixed4: {
// //       images: [
// //         brochure.img_page18_1,
// //         brochure.img_page18_2,
// //         brochure.img_page18_3,
// //       ],
// //     },
// //     bedroomGallery6: { images: [brochure.img_page19_1, brochure.img_page19_2] },
// //     bedroomGallery7: { images: [brochure.img_page20_1, brochure.img_page20_2] },
// //     services: {
// //       section1: {
// //         title: brochure.destination,
// //         description: brochure.destination_desc,
// //         bannerText: brochure.travel_title,
// //         link: brochure.travel_link,
// //       },
// //       section2: {
// //         title: brochure.service,
// //         description: brochure.service_desc,
// //         bannerText: brochure.concierge_title,
// //         link: brochure.concierge_link,
// //       },
// //     },
// //     aboutZorba: {
// //       title: brochure.nature,
// //       heading: brochure.nature_desc1,
// //       paragraph1: brochure.nature_desc2,
// //       paragraph2: brochure.nature_desc3,
// //       paragraph3: "",
// //     },
// //     backCover: {
// //       logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
// //       quoteLine1: "Indulge in the extraordinary;",
// //       quoteLine2: "life's too short for ordinary",
// //       contact: {
// //         website: "www.zorbastays.com",
// //         email: "info@zorbastays.com",
// //         phones: "63552-31066, 98750-28066",
// //       },
// //     },
// //   };

// //   const handleDownload = () => {
// //     window.print();
// //   };

// //   // Render dynamic page based on layout
// //   const renderDynamicPage = (dynamicPage, index) => {
// //     const { layout, images, section } = dynamicPage;
// //     if (!images || images.length === 0) return null;

// //     if (layout === "layout1") {
// //       return (
// //         <div
// //           key={`dynamic_${index}`}
// //           className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative overflow-hidden"
// //         >
// //           <div className="w-full h-full flex flex-col relative pt-16 px-1">
// //             <div className="flex flex-col space-y-6 w-full">
// //               <div className="h-[450px] overflow-hidden">
// //                 <img
// //                   src={images[0]}
// //                   alt="Dynamic 1"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //               <div className="h-[420px] overflow-hidden">
// //                 <img
// //                   src={images[1]}
// //                   alt="Dynamic 2"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       );
// //     }

// //     if (layout === "layout2") {
// //       return (
// //         <div
// //           key={`dynamic_${index}`}
// //           className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative overflow-hidden"
// //         >
// //           <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //             <div className="flex flex-col space-y-4 w-full h-full pb-16">
// //               <div className="w-full h-[450px] overflow-hidden">
// //                 <img
// //                   src={images[0]}
// //                   alt="Dynamic 1"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //               <div className="flex space-x-4 w-full h-[450px]">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={images[1]}
// //                     alt="Dynamic 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={images[2]}
// //                     alt="Dynamic 3"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       );
// //     }

// //     if (layout === "layout3") {
// //       return (
// //         <div
// //           key={`dynamic_${index}`}
// //           className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative overflow-hidden"
// //         >
// //           <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //             <div className="flex flex-col space-y-4 w-full h-full pb-16">
// //               <div className="w-full h-[450px] overflow-hidden">
// //                 <img
// //                   src={images[0]}
// //                   alt="Dynamic 1"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //               <div className="flex space-x-4 w-full items-start">
// //                 <div className="flex-1 h-[300px] overflow-hidden">
// //                   <img
// //                     src={images[1]}
// //                     alt="Dynamic 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //                 <div className="flex-1 h-[450px] overflow-hidden">
// //                   <img
// //                     src={images[2]}
// //                     alt="Dynamic 3"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       );
// //     }

// //     return null;
// //   };

// //   const renderPage = (pageId) => {
// //     // Check if it's a dynamic page
// //     if (pageId.startsWith("dynamic_")) {
// //       const index = parseInt(pageId.split("_")[1]);
// //       const dynamicPage = dynamicPages[index];
// //       if (dynamicPage) {
// //         return renderDynamicPage(dynamicPage, index);
// //       }
// //       return null;
// //     }

// //     switch (pageId) {
// //       case "cover":
// //         return (
// //           <div
// //             key="cover"
// //             className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative flex flex-col items-center p-12"
// //           >
// //             <div className="absolute top-0 left-12 w-[1px] h-80 bg-gray-400"></div>
// //             <div className="absolute top-0 left-20 w-[1px] h-60 bg-gray-400"></div>

// //             <div className="mt-8 flex flex-col items-center">
// //               <img
// //                 src={Property.villa.logo}
// //                 alt={Property.villa.title}
// //                 className="h-28 w-auto object-contain"
// //               />
// //             </div>

// //             <h2 className="mt-20 text-4xl PlayfairDisplay text-gray-800 tracking-wide">
// //               {Property.villa.title}
// //             </h2>

// //             <div className="mt-24 w-full relative group px-4">
// //               <p className="montserrat absolute -top-4 right-4 text-[10px] tracking-[0.2em] text-gray-800 uppercase">
// //                 {Property.villa.text}
// //               </p>

// //               <div className="w-full aspect-[4/3] bg-gray-200 overflow-hidden">
// //                 <img
// //                   src={Property.villa.mainImage}
// //                   alt={Property.villa.title}
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>

// //               <div className="absolute -mt-2 right-0 transform z-10">
// //                 <span className="windsong italic text-5xl text-gray-900">
// //                   {Property.villa.signature}
// //                 </span>
// //               </div>
// //             </div>

// //             <div className="montserrat absolute bottom-3">
// //               <div className="flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
// //                 <a
// //                   href={`https://zorbastays.com/`}
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                 >
// //                   <span>{Property.villa.contact.website}</span>
// //                 </a>
// //                 <span className="h-3 w-[1px] bg-gray-400"></span>
// //                 <a href={`mailto:info@zorbastays.com`}>
// //                   <span>{Property.villa.contact.email}</span>
// //                 </a>
// //                 <span className="h-3 w-[1px] bg-gray-400"></span>
// //                 <span>{Property.villa.contact.phones}</span>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "amenities":
// //         if (!Property.amenities.items.length) return null;
// //         return Array.from(
// //           { length: Math.ceil(Property.amenities.items.length / 10) },
// //           (_, i) => Property.amenities.items.slice(i * 10, i * 10 + 10),
// //         ).map((amenityGroup, pageIndex, allPages) => (
// //           <div
// //             key={`amenities-${pageIndex}`}
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative flex flex-col"
// //           >
// //             {pageIndex === 0 && (
// //               <div className="mt-8 ml-6 flex-none">
// //                 <h1 className="text-3xl PlayfairDisplay italic text-gray-800">
// //                   The
// //                 </h1>
// //                 <h2 className="text-4xl PlayfairDisplay tracking-widest text-gray-800 uppercase mt-2">
// //                   Amenities
// //                 </h2>
// //               </div>
// //             )}

// //             <div
// //               className={`flex-grow flex items-start justify-center ${pageIndex === 0 ? "pt-20" : "pt-32"}`}
// //             >
// //               <div className="grid grid-cols-2 gap-y-12 gap-x-12 px-4 w-full">
// //                 {amenityGroup.map((item, index) => (
// //                   <div key={index} className="flex items-center space-x-6">
// //                     <div className="w-24 h-24 flex items-center justify-center flex-none">
// //                       <img
// //                         src={item.imgSrc}
// //                         alt={item.name}
// //                         className="max-w-full max-h-full object-contain brightness-0 grayscale"
// //                       />
// //                     </div>
// //                     <span className="text-[11px] font-medium tracking-[0.2em] uppercase text-gray-800 leading-tight">
// //                       {item.name}
// //                     </span>
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>
// //             {pageIndex === allPages.length - 1 && (
// //               <div className="mt-auto mb-4 flex justify-center items-center space-x-4">
// //                 <div className="w-12 h-[1px] bg-gray-400"></div>
// //                 <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
// //                   <img
// //                     src={Property.amenities.logo}
// //                     alt="logo"
// //                     className="w-8 h-5 brightness-0"
// //                   />
// //                 </div>
// //                 <div className="w-12 h-[1px] bg-gray-400"></div>
// //               </div>
// //             )}
// //           </div>
// //         ));

// //       case "theVilla":
// //         return (
// //           <div
// //             key="theVilla"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             {(() => {
// //               const totalChars =
// //                 (Property.theVilla.paragraph1?.length || 0) +
// //                 (Property.theVilla.paragraph2?.length || 0);

// //               const imageBottom =
// //                 totalChars > 600 ? "bottom-[40px]" : "bottom-[170px]";
// //               const logoBottom =
// //                 totalChars > 600 ? "bottom-[20px]" : "bottom-[70px]";

// //               return (
// //                 <>
// //                   <div className="mb-8 ml-1">
// //                     <h1 className="text-3xl PlayfairDisplay italic text-gray-800 leading-tight">
// //                       The
// //                     </h1>
// //                     <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2">
// //                       Villa
// //                     </h2>
// //                   </div>

// //                   <div
// //                     className="montserrat flex flex-col ml-1 space-y-6 text-gray-800 tracking-widest text-base text-justify max-w-[100%]"
// //                     style={{ wordSpacing: "1px" }}
// //                   >
// //                     <p>{Property.theVilla.paragraph1}</p>
// //                     <p>{Property.theVilla.paragraph2}</p>
// //                   </div>

// //                   <div
// //                     className={`absolute left-12 right-12 h-[430px] z-20 ${imageBottom}`}
// //                   >
// //                     <img
// //                       src={Property.theVilla.image}
// //                       alt="Villa Exterior"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>

// //                   <div
// //                     className={`absolute left-8 w-28 h-28 opacity-20 grayscale z-10 ${logoBottom}`}
// //                   >
// //                     <img
// //                       src={Property.theVilla.logo}
// //                       alt="Logo Watermark"
// //                       className="w-full h-full object-contain"
// //                     />
// //                   </div>
// //                 </>
// //               );
// //             })()}
// //           </div>
// //         );

// //       case "curation":
// //         return (
// //           <div
// //             key="curation"
// //             className="print-page bg-[#f8f7f6] w-[210mm] h-[297mm] p-12 pt-10 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col pt-5 px-16 relative">
// //               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-20 -ml-16">
// //                 {Property.curation.title}
// //               </h2>

// //               <div className="relative w-full flex-1">
// //                 <div className="absolute -top-16 mt-4 -right-5 inset-0 flex justify-center pointer-events-none">
// //                   <img
// //                     src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/3ea0d39f-9e34-4305-7ea0-07304c880a00/public"
// //                     alt="timeline"
// //                     className="opacity-60 w-auto h-[750px] object-contain"
// //                   />
// //                 </div>

// //                 <div className="relative z-0 flex flex-col space-y-16">
// //                   {Property.curation.steps?.map((step, idx) => (
// //                     <div
// //                       key={idx}
// //                       className={`relative max-w-[285px] ${
// //                         idx === 0
// //                           ? "self-start -ml-14"
// //                           : idx === 1
// //                             ? "self-end mr-8 relative -top-10"
// //                             : idx === 2
// //                               ? "self-end mr-20 relative -top-5"
// //                               : idx === 3
// //                                 ? "self-start relative -top-10 -ml-5"
// //                                 : "self-end mr-5 relative -top-5"
// //                       }`}
// //                     >
// //                       <h3 className="PlayfairDisplay text-xl text-gray-800 mb-2 leading-tight">
// //                         {step.heading}
// //                       </h3>
// //                       <p className="montserrat text-[13px] text-gray-800 leading-relaxed tracking-wide">
// //                         {step.description}
// //                       </p>
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>

// //               <div className="absolute -bottom-10 left-0 w-full text-center">
// //                 <a
// //                   href="https://zorbastays.com/"
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                 >
// //                   <span className="text-[15px] tracking-[0.1em] text-gray-500">
// //                     {Property.curation.footerWebsite}
// //                   </span>
// //                 </a>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "gallery":
// //         return (
// //           <div
// //             key="gallery"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative">
// //               <div className="absolute -top-20 left-6 w-[1px] h-[280px] bg-gray-400"></div>

// //               <div className="flex justify-end items-center z-10 mt-32">
// //                 <span className="waterfall italic text-5xl text-gray-900">
// //                   {Property.gallery.signature}
// //                 </span>
// //               </div>

// //               <div className="w-full flex flex-col space-y-4 px-0">
// //                 <div className="flex space-x-4">
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.gallery.images[0]}
// //                       alt="Pool view 1"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                   <div className="w-[30%] overflow-hidden">
// //                     <img
// //                       src={Property.gallery.images[1]}
// //                       alt="Archway view"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                 </div>

// //                 <div className="w-[68%] aspect-[16/10] overflow-hidden">
// //                   <img
// //                     src={Property.gallery.images[2]}
// //                     alt="Pool view 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="absolute -bottom-44 left-0 w-full flex justify-center items-center space-x-4">
// //                 <div className="w-12 h-[2px] bg-gray-400"></div>
// //                 <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
// //                   <img
// //                     src={Property.gallery.logo}
// //                     alt={Property.gallery.title}
// //                     className="w-8 h-5 brightness-0"
// //                   />
// //                 </div>
// //                 <div className="w-12 h-[2px] bg-gray-400"></div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "living":
// //         return (
// //           <div
// //             key="living"
// //             className="print-page bg-[#f8f7f6] w-[210mm] h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative px-1 pt-10">
// //               <div
// //                 className="absolute -top-10 right-0 w-[430px] h-[430px] opacity-5 pointer-events-none translate-x-14 -translate-y-14"
// //                 style={{ wordSpacing: "4px" }}
// //               >
// //                 <img
// //                   src={Property.living.logo}
// //                   alt="Watermark"
// //                   className="w-full h-full object-contain grayscale"
// //                 />
// //               </div>

// //               <div className="relative z-10">
// //                 <h1 className="text-3xl italic PlayfairDisplay text-gray-800 leading-tight">
// //                   The
// //                 </h1>
// //                 <h2 className="text-4xl PlayfairDisplay text-gray-800 tracking-widest uppercase mb-8">
// //                   Living
// //                 </h2>

// //                 <div className="montserrat flex flex-col space-y-6 text-gray-800 text-[15px] tracking-widest max-w-[100%]">
// //                   <p>{Property.living.paragraph1}</p>
// //                   <p>{Property.living.paragraph2}</p>
// //                 </div>

// //                 <div className="mt-12 w-full aspect-[4/3] overflow-hidden">
// //                   <img
// //                     src={Property.living.livingImage}
// //                     alt="Living Area"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="absolute -bottom-[83px] left-12 flex gap-6">
// //                 <div className="w-[2px] h-36 bg-gray-400"></div>
// //                 <div className="w-[2px] h-36 bg-gray-400"></div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "kitchenDining":
// //         return (
// //           <div
// //             key="kitchenDining"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="absolute top-6 right-12 z-20">
// //                 <span className="waterfall italic text-5xl text-gray-900 drop-shadow-sm">
// //                   {Property.kitchenDining.title}
// //                 </span>
// //               </div>

// //               <div className="flex flex-col space-y-4 w-full h-full pt-12">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.kitchenDining.images[0]}
// //                     alt="Kitchen Area"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.kitchenDining.images[1]}
// //                     alt="Dining Area"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedrooms":
// //         return (
// //           <div
// //             key="bedrooms"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col px-1 pt-20 relative">
// //               <div className="mb-8">
// //                 <h1 className="text-3xl PlayfairDisplay italic text-gray-800 leading-tight">
// //                   The
// //                 </h1>
// //                 <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2 tracking-wide">
// //                   Bedrooms
// //                 </h2>
// //               </div>

// //               <div
// //                 className="montserrat flex flex-col space-y-8 text-gray-800 tracking-widest text-[14.5px] text-justify max-w-[95%] leading-relaxed"
// //                 style={{ wordSpacing: "1px" }}
// //               >
// //                 <p>{Property.bedrooms.paragraph1}</p>
// //                 <p>{Property.bedrooms.paragraph2}</p>
// //               </div>

// //               <div className="mt-10 w-full aspect-[16/11] overflow-hidden">
// //                 <img
// //                   src={Property.bedrooms.bedroomImage}
// //                   alt="Bedroom Interior"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>

// //               <div className="absolute -bottom-24 left-0 w-full flex justify-center items-center space-x-4">
// //                 <div className="w-12 h-[2px] bg-gray-400"></div>
// //                 <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
// //                   <img
// //                     src={Property.bedrooms.logo}
// //                     alt="Logo"
// //                     className="w-7 h-5 brightness-0 opacity-70"
// //                   />
// //                 </div>
// //                 <div className="w-12 h-[2px] bg-gray-400"></div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery":
// //         return (
// //           <div
// //             key="bedroomGallery"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden shadow-sm">
// //                   <img
// //                     src={Property.bedroomGallery.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden shadow-sm">
// //                   <img
// //                     src={Property.bedroomGallery.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery2":
// //         return (
// //           <div
// //             key="bedroomGallery2"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery2.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery2.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGalleryMixed":
// //         return (
// //           <div
// //             key="bedroomGalleryMixed"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-5 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pb-10">
// //                 <div className="w-full h-[45%] overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGalleryMixed.images[0]}
// //                     alt="Master Bedroom View"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex space-x-4 w-full h-[45%]">
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed.images[1]}
// //                       alt="Bedroom Seating"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed.images[2]}
// //                       alt="Bedroom Detail"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGalleryMixed2":
// //         return (
// //           <div
// //             key="bedroomGalleryMixed2"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-0 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pb-16">
// //                 <div className="w-full h-[45%] overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGalleryMixed2.images[0]}
// //                     alt="Master Bedroom View"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex space-x-4 w-full h-[45%]">
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed2.images[1]}
// //                       alt="Bedroom Seating"
// //                       className="w-full h-[25vh] object-cover"
// //                     />
// //                   </div>
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed2.images[2]}
// //                       alt="Bedroom Detail"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGalleryMixed3":
// //         return (
// //           <div
// //             key="bedroomGalleryMixed3"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-5 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pb-16">
// //                 <div className="w-full h-[45%] overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGalleryMixed3.images[0]}
// //                     alt="Master Bedroom View"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex space-x-4 w-full h-[45%]">
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed3.images[1]}
// //                       alt="Bedroom Seating"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed3.images[2]}
// //                       alt="Bedroom Detail"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery3":
// //         return (
// //           <div
// //             key="bedroomGallery3"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery3.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery3.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "commonareas":
// //         return (
// //           <div
// //             key="commonareas"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="absolute top-0 left-6 z-20 flex items-center w-full">
// //                 <span className="waterfall italic text-5xl text-gray-800 pr-6">
// //                   {Property.commonareas.title}
// //                 </span>
// //                 <div className="flex-1 h-[1px] bg-gray-400 -mr-6"></div>
// //               </div>

// //               <div className="absolute top-24 left-10 w-[1px] h-[135vh] bg-gray-400"></div>

// //               <div className="flex flex-col space-y-4 w-full h-full pt-28 pl-16">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.commonareas.images[0]}
// //                     alt="Common Area Overview"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.commonareas.images[1]}
// //                     alt="Lounge and Staircase"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery4":
// //         return (
// //           <div
// //             key="bedroomGallery4"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-5 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery4.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery4.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery5":
// //         return (
// //           <div
// //             key="bedroomGallery5"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery5.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery5.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGalleryMixed4":
// //         return (
// //           <div
// //             key="bedroomGalleryMixed4"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-5 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pb-16">
// //                 <div className="w-full h-[45%] overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGalleryMixed4.images[0]}
// //                     alt="Master Bedroom View"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex space-x-4 w-full h-[45%]">
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed4.images[1]}
// //                       alt="Bedroom Seating"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed4.images[2]}
// //                       alt="Bedroom Detail"
// //                       className="w-full h-[25vh] object-cover"
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery6":
// //         return (
// //           <div
// //             key="bedroomGallery6"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery6.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery6.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery7":
// //         return (
// //           <div
// //             key="bedroomGallery7"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery7.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery7.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "services":
// //         return (
// //           <div
// //             key="services"
// //             className="print-page w-[210mm] min-h-[297mm] pl-8 pr-5 pt-20 flex flex-col relative bg-[#f8f7f6] shadow-md"
// //           >
// //             <div className="mb-12 max-w-[92%] ml-5">
// //               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-6">
// //                 {Property.services.section1.title}
// //               </h2>
// //               <p
// //                 className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-10"
// //                 style={{ wordSpacing: "1px" }}
// //               >
// //                 {Property.services.section1.description}
// //               </p>

// //               <div
// //                 className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-center"
// //                 style={{
// //                   backgroundImage:
// //                     "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
// //                 }}
// //               >
// //                 <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
// //                 <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
// //                   {Property.services.section1.bannerText}
// //                 </h3>
// //                 <a
// //                   href={Property.services.section1.link}
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                 >
// //                   <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
// //                     Click Here
// //                   </button>
// //                 </a>
// //               </div>
// //             </div>

// //             <div className="max-w-[92%] ml-5">
// //               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-10 mt-10">
// //                 {Property.services.section2.title}
// //               </h2>
// //               <p
// //                 className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-8"
// //                 style={{ wordSpacing: "1px" }}
// //               >
// //                 {Property.services.section2.description}
// //               </p>

// //               <div
// //                 className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-top"
// //                 style={{
// //                   backgroundImage:
// //                     "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
// //                 }}
// //               >
// //                 <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
// //                 <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
// //                   {Property.services.section2.bannerText}
// //                 </h3>
// //                 <a
// //                   href={Property.services.section2.link}
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                 >
// //                   <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
// //                     Click Here
// //                   </button>
// //                 </a>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "aboutZorba":
// //         return (
// //           <div
// //             key="aboutZorba"
// //             className="print-page w-[210mm] min-h-[297mm] relative flex flex-col pt-10 pl-5 px-1 overflow-hidden bg-[#f8f7f6] shadow-md"
// //           >
// //             <div className="absolute top-10 right-12 z-20 flex items-center justify-end w-full">
// //               <div className="flex-1 h-[1px] bg-gray-400 ml-0"></div>
// //               <span className="waterfall italic text-5xl text-gray-800 pl-6">
// //                 {Property.aboutZorba.title || "About"}
// //               </span>
// //             </div>

// //             <div className="absolute top-32 bottom-0 right-12 w-[1px] bg-gray-400"></div>

// //             <div className="flex flex-col justify-center h-full max-w-[95%] pr-16 pl-8 pt-[40vh]">
// //               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-8 leading-tight">
// //                 {Property.aboutZorba.heading}
// //               </h2>

// //               <div
// //                 className="montserrat flex flex-col space-y-8 text-gray-800 text-[15px] tracking-widest text-justify"
// //                 style={{ wordSpacing: "1px" }}
// //               >
// //                 <p>{Property.aboutZorba.paragraph1}</p>
// //                 <p>{Property.aboutZorba.paragraph2}</p>
// //                 <p>{Property.aboutZorba.paragraph3}</p>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "backCover":
// //         return (
// //           <div
// //             key="backCover"
// //             className="print-page w-[210mm] min-h-[297mm] flex flex-col justify-between items-center py-16 px-1 bg-[#f8f7f6] shadow-md relative"
// //           >
// //             <div className="flex flex-col items-center mt-60">
// //               <img
// //                 src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public"
// //                 alt="Logo"
// //                 className="h-44 w-auto object-contain"
// //               />
// //             </div>

// //             <div className="flex flex-col items-center space-y-32">
// //               <div className="text-center">
// //                 <span className="waterfall text-4xl italic block">
// //                   {Property.backCover.quoteLine1}
// //                 </span>
// //                 <span className="waterfall text-3xl italic block">
// //                   {Property.backCover.quoteLine2}
// //                 </span>
// //               </div>

// //               <div className="montserrat flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
// //                 <a
// //                   href={`https://zorbastays.com/`}
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                 >
// //                   {Property.backCover.contact.website}
// //                 </a>
// //                 <span className="h-3 w-[1px] bg-gray-400"></span>
// //                 <a href={`mailto:info@zorbastays.com`}>
// //                   {Property.backCover.contact.email}
// //                 </a>
// //                 <span className="h-3 w-[1px] bg-gray-400"></span>
// //                 <span>{Property.backCover.contact.phones}</span>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       default:
// //         return null;
// //     }
// //   };

// //   return (
// //     <div className="bg-white min-h-screen flex flex-col items-center py-10 gap-10 print:gap-0 print:py-0 print:p-0 print:bg-[#f8f7f6]">
// //       <div className="fixed right-5 bottom-20 print:hidden">
// //         <button
// //           onClick={handleDownload}
// //           className="flex gap-2 justify-center items-center bg-black text-white w-48 py-3 rounded-md tracking-widest text-sm hover:bg-green-800 transition duration-200 ease-linear"
// //         >
// //           <FaDownload />
// //           Download PDF
// //         </button>
// //       </div>

// //       <div className="fixed right-5 bottom-5 print:hidden">
// //         <button
// //           onClick={() => navigate("/PropertyBrochure")}
// //           className="flex gap-2 justify-center items-center border-2 border-black text-black font-semibold w-48 py-2.5 rounded-md tracking-widest text-sm hover:bg-black hover:text-white transition duration-200 ease-linear"
// //         >
// //           <CgTemplate />
// //           Back to Brochures
// //         </button>
// //       </div>

// //       <style
// //         dangerouslySetInnerHTML={{
// //           __html: `
// //             @page {
// //               size: A4 portrait;
// //               margin: 0;
// //             }

// //             @media print {
// //               html, body {
// //                 width: 210mm;
// //                 margin: 0;
// //                 padding: 0;
// //                 height: auto !important;
// //                 -webkit-print-color-adjust: exact;
// //                 print-color-adjust: exact;
// //               }

// //               body {
// //                 zoom: 100%;
// //               }

// //               .print-page {
// //                 width: 210mm !important;
// //                 min-height: 297mm !important;
// //                 page-break-after: always;
// //                 break-after: page;
// //                 page-break-inside: avoid;
// //                 break-inside: avoid;
// //                 margin: 0 !important;
// //               }

// //               .print-page:last-of-type {
// //                 page-break-after: auto !important;
// //                 break-after: auto !important;
// //               }

// //               .shadow-md {
// //                 box-shadow: none !important;
// //               }
// //             }
// //           `,
// //         }}
// //       />

// //       {pagesToRender.map((pageId) => renderPage(pageId))}
// //     </div>
// //   );
// // };

// // export default BrochurePDF;
// //new
// // import React, { useEffect, useState } from "react";
// // import { useNavigate, useParams } from "react-router-dom";
// // import { CgTemplate } from "react-icons/cg";
// // import { FaDownload } from "react-icons/fa6";

// // const BrochurePDF = () => {
// //   const { id } = useParams();
// //   const navigate = useNavigate();
// //   console.log(id);
// //   const [brochure, setBrochure] = useState(null);
// //   const [amenities, setAmenities] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [pagesToRender, setPagesToRender] = useState([]);

// //   useEffect(() => {
// //     const fetchBrochure = async () => {
// //       try {
// //         // 1. Fetch brochure data
// //         const res = await fetch(
// //           `https://dash.zorbastays.com/web-backend/getBrochure/${id}`,
// //         );

// //         // DEBUG: Log the raw response
// //         const rawText = await res.text();
// //         console.log("RAW RESPONSE:", rawText);
// //         console.log("Response status:", res.status);
// //         console.log("Response headers:", [...res.headers.entries()]);

// //         // Try to parse
// //         let json;
// //         try {
// //           json = JSON.parse(rawText);
// //           console.log("Parsed JSON:", json);
// //         } catch (parseError) {
// //           console.error("JSON Parse Error:", parseError);
// //           console.error("First 100 chars:", rawText.substring(0, 100));
// //           throw new Error(
// //             `Invalid response from server. Status: ${res.status}`,
// //           );
// //         }

// //         if (!json.success) throw new Error(json.message);
// //         setBrochure(json.data);

// //         // 2. Parse amenity IDs - THE FIX IS HERE
// //         // json.data.amenity_ids is already an array from backend, don't parse again!
// //         const amenityIds = Array.isArray(json.data.amenity_ids)
// //           ? json.data.amenity_ids
// //           : JSON.parse(json.data.amenity_ids || "[]");

// //         console.log("amenityIds:", amenityIds);

// //         let amenitiesData = [];
// //         if (amenityIds.length > 0) {
// //           const amenityRes = await fetch(
// //             `https://dash.zorbastays.com/web-backend/getAmenitiesById?ids=${amenityIds.join(",")}`,
// //           );
// //           const amenityJson = await amenityRes.json();
// //           console.log("amenityJson:", amenityJson);

// //           if (amenityJson.success) {
// //             amenitiesData = amenityJson.data;
// //             setAmenities(amenitiesData);
// //           }
// //         }

// //         // Build Property object to check images
// //         const Property = {
// //           villa: {
// //             logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
// //             title: json.data.villa_name,
// //             text: json.data.top_text,
// //             mainImage: json.data.img_page1,
// //             signature: json.data.location,
// //             contact: {
// //               website: "www.zorbastays.com",
// //               email: "info@zorbastays.com",
// //               phones: "63552-31066, 98750-28066",
// //             },
// //           },

// //           amenities: {
// //             logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //             items: amenitiesData.map((a) => ({
// //               name: a.name,
// //               imgSrc: a.url,
// //             })),
// //           },
// //           theVilla: {
// //             logo: "https://zorbastays.com/android-chrome-512x512.png",
// //             image: json.data.img_page3,
// //             paragraph1: json.data.villa_desc1,
// //             paragraph2: json.data.villa_desc2,
// //           },

// //           curation: {
// //             title: json.data.the_title,
// //             footerWebsite: "www.zorbastays.com",
// //             steps: [
// //               {
// //                 heading: json.data.curate_title1,
// //                 description: json.data.curate_desc1,
// //               },
// //               {
// //                 heading: json.data.curate_title2,
// //                 description: json.data.curate_desc2,
// //               },
// //               {
// //                 heading: json.data.curate_title3,
// //                 description: json.data.curate_desc3,
// //               },
// //               {
// //                 heading: json.data.curate_title4,
// //                 description: json.data.curate_desc4,
// //               },
// //               {
// //                 heading: json.data.curate_title5,
// //                 description: json.data.curate_desc5,
// //               },
// //             ],
// //           },

// //           gallery: {
// //             signature: json.data.pool_title,
// //             logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //             images: [
// //               json.data.img_page5_1,
// //               json.data.img_page5_2,
// //               json.data.img_page5_3,
// //             ],
// //           },

// //           living: {
// //             logo: "https://zorbastays.com/android-chrome-512x512.png",
// //             livingImage: json.data.img_page6,
// //             paragraph1: json.data.living_desc1,
// //             paragraph2: json.data.living_desc2,
// //           },

// //           kitchenDining: {
// //             title: json.data.kitchen_title,
// //             images: [json.data.img_page7_1, json.data.img_page7_2],
// //           },

// //           bedrooms: {
// //             logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //             bedroomImage: json.data.img_page8,
// //             paragraph1: json.data.bed_desc1,
// //             paragraph2: json.data.bed_desc2,
// //           },

// //           bedroomGallery: {
// //             images: [json.data.img_page9_1, json.data.img_page9_2],
// //           },
// //           bedroomGallery2: {
// //             images: [json.data.img_page10_1, json.data.img_page10_2],
// //           },
// //           bedroomGalleryMixed: {
// //             images: [
// //               json.data.img_page11_1,
// //               json.data.img_page11_2,
// //               json.data.img_page11_3,
// //             ],
// //           },
// //           bedroomGalleryMixed2: {
// //             images: [
// //               json.data.img_page12_1,
// //               json.data.img_page12_2,
// //               json.data.img_page12_3,
// //             ],
// //           },
// //           bedroomGalleryMixed3: {
// //             images: [
// //               json.data.img_page13_1,
// //               json.data.img_page13_2,
// //               json.data.img_page13_3,
// //             ],
// //           },
// //           bedroomGallery3: {
// //             images: [json.data.img_page14_1, json.data.img_page14_2],
// //           },

// //           commonareas: {
// //             title: json.data.common_areas,
// //             images: [json.data.img_page15_1, json.data.img_page15_2],
// //           },

// //           bedroomGallery4: {
// //             images: [json.data.img_page16_1, json.data.img_page16_2],
// //           },
// //           bedroomGallery5: {
// //             images: [json.data.img_page17_1, json.data.img_page17_2],
// //           },
// //           bedroomGalleryMixed4: {
// //             images: [
// //               json.data.img_page18_1,
// //               json.data.img_page18_2,
// //               json.data.img_page18_3,
// //             ],
// //           },
// //           bedroomGallery6: {
// //             images: [json.data.img_page19_1, json.data.img_page19_2],
// //           },
// //           bedroomGallery7: {
// //             images: [json.data.img_page20_1, json.data.img_page20_2],
// //           },

// //           services: {
// //             section1: {
// //               title: json.data.destination,
// //               description: json.data.destination_desc,
// //               bannerText: json.data.travel_title,
// //               link: json.data.travel_link,
// //             },
// //             section2: {
// //               title: json.data.service,
// //               description: json.data.service_desc,
// //               bannerText: json.data.concierge_title,
// //               link: json.data.concierge_link,
// //             },
// //           },

// //           aboutZorba: {
// //             title: json.data.nature,
// //             heading: json.data.nature_desc1,
// //             paragraph1: json.data.nature_desc2,
// //             paragraph2: json.data.nature_desc3,
// //             paragraph3: "",
// //           },

// //           backCover: {
// //             logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
// //             quoteLine1: "Indulge in the extraordinary;",
// //             quoteLine2: "life's too short for ordinary",
// //             contact: {
// //               website: "www.zorbastays.com",
// //               email: "info@zorbastays.com",
// //               phones: "63552-31066, 98750-28066",
// //             },
// //           },
// //         };

// //         // Helper function to check if images in an array are all null/empty
// //         const hasValidImages = (images) => {
// //           if (!images || !Array.isArray(images)) return false;
// //           return images.some((img) => img && img.trim() !== "");
// //         };

// //         // Helper function to check if all images are null/empty
// //         const areAllImagesNull = (images) => {
// //           if (!images || !Array.isArray(images)) return true;
// //           return images.every((img) => !img || img.trim() === "");
// //         };

// //         // Define all pages with their image checks
// //         const pagesConfig = [
// //           { id: "cover", condition: true }, // Always show cover
// //           {
// //             id: "amenities",
// //             condition:
// //               Property.amenities.items && Property.amenities.items.length > 0,
// //           },
// //           {
// //             id: "theVilla",
// //             condition:
// //               Property.theVilla.image && Property.theVilla.image.trim() !== "",
// //           },
// //           { id: "curation", condition: true }, // Always show curation (has no images)
// //           {
// //             id: "gallery",
// //             condition: hasValidImages(Property.gallery.images),
// //           },
// //           {
// //             id: "living",
// //             condition:
// //               Property.living.livingImage &&
// //               Property.living.livingImage.trim() !== "",
// //           },
// //           {
// //             id: "kitchenDining",
// //             condition: hasValidImages(Property.kitchenDining.images),
// //           },
// //           {
// //             id: "bedrooms",
// //             condition:
// //               Property.bedrooms.bedroomImage &&
// //               Property.bedrooms.bedroomImage.trim() !== "",
// //           },
// //           {
// //             id: "bedroomGallery",
// //             condition: hasValidImages(Property.bedroomGallery.images),
// //           },
// //           {
// //             id: "bedroomGallery2",
// //             condition: hasValidImages(Property.bedroomGallery2.images),
// //           },
// //           {
// //             id: "bedroomGalleryMixed",
// //             condition: hasValidImages(Property.bedroomGalleryMixed.images),
// //           },
// //           {
// //             id: "bedroomGalleryMixed2",
// //             condition: hasValidImages(Property.bedroomGalleryMixed2.images),
// //           },
// //           {
// //             id: "bedroomGalleryMixed3",
// //             condition: hasValidImages(Property.bedroomGalleryMixed3.images),
// //           },
// //           {
// //             id: "bedroomGallery3",
// //             condition: hasValidImages(Property.bedroomGallery3.images),
// //           },
// //           {
// //             id: "commonareas",
// //             condition: hasValidImages(Property.commonareas.images),
// //           },
// //           {
// //             id: "bedroomGallery4",
// //             condition: hasValidImages(Property.bedroomGallery4.images),
// //           },
// //           {
// //             id: "bedroomGallery5",
// //             condition: hasValidImages(Property.bedroomGallery5.images),
// //           },
// //           {
// //             id: "bedroomGalleryMixed4",
// //             condition: hasValidImages(Property.bedroomGalleryMixed4.images),
// //           },
// //           {
// //             id: "bedroomGallery6",
// //             condition: hasValidImages(Property.bedroomGallery6.images),
// //           },
// //           {
// //             id: "bedroomGallery7",
// //             condition: hasValidImages(Property.bedroomGallery7.images),
// //           },
// //           { id: "services", condition: true }, // Always show services (has no images)
// //           { id: "aboutZorba", condition: true }, // Always show about (has no images)
// //           { id: "backCover", condition: true }, // Always show back cover
// //         ];

// //         // Filter pages that should be rendered
// //         const pagesToShow = pagesConfig
// //           .filter((page) => page.condition)
// //           .map((page) => page.id);
// //         setPagesToRender(pagesToShow);
// //       } catch (err) {
// //         console.error("Fetch error:", err);
// //         setError(err.message);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchBrochure();
// //   }, [id]);

// //   if (loading)
// //     return (
// //       <div className="flex items-center justify-center min-h-screen">
// //         Loading...
// //       </div>
// //     );
// //   if (error)
// //     return (
// //       <div className="flex items-center justify-center min-h-screen text-red-500">
// //         {error}
// //       </div>
// //     );
// //   if (!brochure) return null;

// //   // Rebuild Property object with current data
// //   const Property = {
// //     villa: {
// //       logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
// //       title: brochure.villa_name,
// //       text: brochure.top_text,
// //       mainImage: brochure.img_page1,
// //       signature: brochure.location,
// //       contact: {
// //         website: "www.zorbastays.com",
// //         email: "info@zorbastays.com",
// //         phones: "63552-31066, 98750-28066",
// //       },
// //     },

// //     amenities: {
// //       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //       items: amenities.map((a) => ({
// //         name: a.name,
// //         imgSrc: a.url,
// //       })),
// //     },
// //     theVilla: {
// //       logo: "https://zorbastays.com/android-chrome-512x512.png",
// //       image: brochure.img_page3,
// //       paragraph1: brochure.villa_desc1,
// //       paragraph2: brochure.villa_desc2,
// //     },

// //     curation: {
// //       title: brochure.the_title,
// //       footerWebsite: "www.zorbastays.com",
// //       steps: [
// //         { heading: brochure.curate_title1, description: brochure.curate_desc1 },
// //         { heading: brochure.curate_title2, description: brochure.curate_desc2 },
// //         { heading: brochure.curate_title3, description: brochure.curate_desc3 },
// //         { heading: brochure.curate_title4, description: brochure.curate_desc4 },
// //         { heading: brochure.curate_title5, description: brochure.curate_desc5 },
// //       ],
// //     },

// //     gallery: {
// //       signature: brochure.pool_title,
// //       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //       images: [
// //         brochure.img_page5_1,
// //         brochure.img_page5_2,
// //         brochure.img_page5_3,
// //       ],
// //     },

// //     living: {
// //       logo: "https://zorbastays.com/android-chrome-512x512.png",
// //       livingImage: brochure.img_page6,
// //       paragraph1: brochure.living_desc1,
// //       paragraph2: brochure.living_desc2,
// //     },

// //     kitchenDining: {
// //       title: brochure.kitchen_title,
// //       images: [brochure.img_page7_1, brochure.img_page7_2],
// //     },

// //     bedrooms: {
// //       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //       bedroomImage: brochure.img_page8,
// //       paragraph1: brochure.bed_desc1,
// //       paragraph2: brochure.bed_desc2,
// //     },

// //     bedroomGallery: { images: [brochure.img_page9_1, brochure.img_page9_2] },
// //     bedroomGallery2: { images: [brochure.img_page10_1, brochure.img_page10_2] },
// //     bedroomGalleryMixed: {
// //       images: [
// //         brochure.img_page11_1,
// //         brochure.img_page11_2,
// //         brochure.img_page11_3,
// //       ],
// //     },
// //     bedroomGalleryMixed2: {
// //       images: [
// //         brochure.img_page12_1,
// //         brochure.img_page12_2,
// //         brochure.img_page12_3,
// //       ],
// //     },
// //     bedroomGalleryMixed3: {
// //       images: [
// //         brochure.img_page13_1,
// //         brochure.img_page13_2,
// //         brochure.img_page13_3,
// //       ],
// //     },
// //     bedroomGallery3: { images: [brochure.img_page14_1, brochure.img_page14_2] },

// //     commonareas: {
// //       title: brochure.common_areas,
// //       images: [brochure.img_page15_1, brochure.img_page15_2],
// //     },

// //     bedroomGallery4: { images: [brochure.img_page16_1, brochure.img_page16_2] },
// //     bedroomGallery5: { images: [brochure.img_page17_1, brochure.img_page17_2] },
// //     bedroomGalleryMixed4: {
// //       images: [
// //         brochure.img_page18_1,
// //         brochure.img_page18_2,
// //         brochure.img_page18_3,
// //       ],
// //     },
// //     bedroomGallery6: { images: [brochure.img_page19_1, brochure.img_page19_2] },
// //     bedroomGallery7: { images: [brochure.img_page20_1, brochure.img_page20_2] },

// //     services: {
// //       section1: {
// //         title: brochure.destination,
// //         description: brochure.destination_desc,
// //         bannerText: brochure.travel_title,
// //         link: brochure.travel_link,
// //       },
// //       section2: {
// //         title: brochure.service,
// //         description: brochure.service_desc,
// //         bannerText: brochure.concierge_title,
// //         link: brochure.concierge_link,
// //       },
// //     },

// //     aboutZorba: {
// //       title: brochure.nature,
// //       heading: brochure.nature_desc1,
// //       paragraph1: brochure.nature_desc2,
// //       paragraph2: brochure.nature_desc3,
// //       paragraph3: "",
// //     },

// //     backCover: {
// //       logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
// //       quoteLine1: "Indulge in the extraordinary;",
// //       quoteLine2: "life's too short for ordinary",
// //       contact: {
// //         website: "www.zorbastays.com",
// //         email: "info@zorbastays.com",
// //         phones: "63552-31066, 98750-28066",
// //       },
// //     },
// //   };

// //   const handleDownload = () => {
// //     window.print();
// //   };

// //   // Helper function to render pages conditionally
// //   const renderPage = (pageId) => {
// //     switch (pageId) {
// //       case "cover":
// //         return (
// //           <div
// //             key="cover"
// //             className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative flex flex-col items-center p-12"
// //           >
// //             <div className="absolute top-0 left-12 w-[1px] h-80 bg-gray-400"></div>
// //             <div className="absolute top-0 left-20 w-[1px] h-60 bg-gray-400"></div>

// //             <div className="mt-8 flex flex-col items-center">
// //               <img
// //                 src={Property.villa.logo}
// //                 alt={Property.villa.title}
// //                 className="h-28 w-auto object-contain"
// //               />
// //             </div>

// //             <h2 className="mt-20 text-4xl PlayfairDisplay text-gray-800 tracking-wide">
// //               {Property.villa.title}
// //             </h2>

// //             <div className="mt-24 w-full relative group px-4">
// //               <p className="montserrat absolute -top-4 right-4 text-[10px] tracking-[0.2em] text-gray-800 uppercase">
// //                 {Property.villa.text}
// //               </p>

// //               <div className="w-full aspect-[4/3] bg-gray-200 overflow-hidden">
// //                 <img
// //                   src={Property.villa.mainImage}
// //                   alt={Property.villa.title}
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>

// //               <div className="absolute -mt-2 right-0 transform z-10">
// //                 <span className="windsong italic text-5xl text-gray-900">
// //                   {Property.villa.signature}
// //                 </span>
// //               </div>
// //             </div>

// //             <div className="montserrat absolute bottom-3">
// //               <div className="flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
// //                 <a
// //                   href={`https://zorbastays.com/`}
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                 >
// //                   <span>{Property.villa.contact.website}</span>
// //                 </a>
// //                 <span className="h-3 w-[1px] bg-gray-400"></span>
// //                 <a href={`mailto:info@zorbastays.com`}>
// //                   <span>{Property.villa.contact.email}</span>
// //                 </a>
// //                 <span className="h-3 w-[1px] bg-gray-400"></span>
// //                 <span>{Property.villa.contact.phones}</span>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "amenities":
// //         if (!Property.amenities.items.length) return null;
// //         return Array.from(
// //           { length: Math.ceil(Property.amenities.items.length / 10) },
// //           (_, i) => Property.amenities.items.slice(i * 10, i * 10 + 10),
// //         ).map((amenityGroup, pageIndex, allPages) => (
// //           <div
// //             key={`amenities-${pageIndex}`}
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative flex flex-col"
// //           >
// //             {pageIndex === 0 && (
// //               <div className="mt-8 ml-6 flex-none">
// //                 <h1 className="text-3xl PlayfairDisplay italic text-gray-800">
// //                   The
// //                 </h1>
// //                 <h2 className="text-4xl PlayfairDisplay tracking-widest text-gray-800 uppercase mt-2">
// //                   Amenities
// //                 </h2>
// //               </div>
// //             )}

// //             <div
// //               className={`flex-grow flex items-start justify-center ${pageIndex === 0 ? "pt-20" : "pt-32"}`}
// //             >
// //               <div className="grid grid-cols-2 gap-y-12 gap-x-12 px-4 w-full">
// //                 {amenityGroup.map((item, index) => (
// //                   <div key={index} className="flex items-center space-x-6">
// //                     <div className="w-24 h-24 flex items-center justify-center flex-none">
// //                       <img
// //                         src={item.imgSrc}
// //                         alt={item.name}
// //                         className="max-w-full max-h-full object-contain brightness-0 grayscale"
// //                       />
// //                     </div>
// //                     <span className="text-[11px] font-medium tracking-[0.2em] uppercase text-gray-800 leading-tight">
// //                       {item.name}
// //                     </span>
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>
// //             {pageIndex === allPages.length - 1 && (
// //               <div className="mt-auto mb-4 flex justify-center items-center space-x-4">
// //                 <div className="w-12 h-[1px] bg-gray-400"></div>
// //                 <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
// //                   <img
// //                     src={Property.amenities.logo}
// //                     alt="logo"
// //                     className="w-8 h-5 brightness-0"
// //                   />
// //                 </div>
// //                 <div className="w-12 h-[1px] bg-gray-400"></div>
// //               </div>
// //             )}
// //           </div>
// //         ));

// //       case "theVilla":
// //         return (
// //           <div
// //             key="theVilla"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             {(() => {
// //               const totalChars =
// //                 (Property.theVilla.paragraph1?.length || 0) +
// //                 (Property.theVilla.paragraph2?.length || 0);

// //               const imageBottom =
// //                 totalChars > 600 ? "bottom-[40px]" : "bottom-[170px]";
// //               const logoBottom =
// //                 totalChars > 600 ? "bottom-[20px]" : "bottom-[70px]";

// //               return (
// //                 <>
// //                   <div className="mb-8 ml-1">
// //                     <h1 className="text-3xl PlayfairDisplay italic text-gray-800 leading-tight">
// //                       The
// //                     </h1>
// //                     <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2">
// //                       Villa
// //                     </h2>
// //                   </div>

// //                   <div
// //                     className="montserrat flex flex-col ml-1 space-y-6 text-gray-800 tracking-widest text-base text-justify max-w-[100%]"
// //                     style={{ wordSpacing: "1px" }}
// //                   >
// //                     <p>{Property.theVilla.paragraph1}</p>
// //                     <p>{Property.theVilla.paragraph2}</p>
// //                   </div>

// //                   <div
// //                     className={`absolute left-12 right-12 h-[430px] z-20 ${imageBottom}`}
// //                   >
// //                     <img
// //                       src={Property.theVilla.image}
// //                       alt="Villa Exterior"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>

// //                   <div
// //                     className={`absolute left-8 w-28 h-28 opacity-20 grayscale z-10 ${logoBottom}`}
// //                   >
// //                     <img
// //                       src={Property.theVilla.logo}
// //                       alt="Logo Watermark"
// //                       className="w-full h-full object-contain"
// //                     />
// //                   </div>
// //                 </>
// //               );
// //             })()}
// //           </div>
// //         );

// //       case "curation":
// //         return (
// //           <div
// //             key="curation"
// //             className="print-page bg-[#f8f7f6] w-[210mm] h-[297mm] p-12 pt-10 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col pt-5 px-16 relative">
// //               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-20 -ml-16">
// //                 {Property.curation.title}
// //               </h2>

// //               <div className="relative w-full flex-1">
// //                 <div className="absolute -top-16 mt-4 -right-5 inset-0 flex justify-center pointer-events-none">
// //                   <img
// //                     src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/3ea0d39f-9e34-4305-7ea0-07304c880a00/public"
// //                     alt="timeline"
// //                     className="opacity-60 w-auto h-[750px] object-contain"
// //                   />
// //                 </div>

// //                 <div className="relative z-0 flex flex-col space-y-16">
// //                   {Property.curation.steps?.map((step, idx) => (
// //                     <div
// //                       key={idx}
// //                       className={`relative max-w-[285px] ${
// //                         idx === 0
// //                           ? "self-start -ml-14"
// //                           : idx === 1
// //                             ? "self-end mr-8 relative -top-10"
// //                             : idx === 2
// //                               ? "self-end mr-20 relative -top-5"
// //                               : idx === 3
// //                                 ? "self-start relative -top-10 -ml-5"
// //                                 : "self-end mr-5 relative -top-5"
// //                       }`}
// //                     >
// //                       <h3 className="PlayfairDisplay text-xl text-gray-800 mb-2 leading-tight">
// //                         {step.heading}
// //                       </h3>
// //                       <p className="montserrat text-[13px] text-gray-800 leading-relaxed tracking-wide">
// //                         {step.description}
// //                       </p>
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>

// //               <div className="absolute -bottom-10 left-0 w-full text-center">
// //                 <a
// //                   href="https://zorbastays.com/"
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                 >
// //                   <span className="text-[15px] tracking-[0.1em] text-gray-500">
// //                     {Property.curation.footerWebsite}
// //                   </span>
// //                 </a>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "gallery":
// //         return (
// //           <div
// //             key="gallery"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative">
// //               <div className="absolute -top-20 left-6 w-[1px] h-[280px] bg-gray-400"></div>

// //               <div className="flex justify-end items-center z-10 mt-32">
// //                 <span className="waterfall italic text-5xl text-gray-900">
// //                   {Property.gallery.signature}
// //                 </span>
// //               </div>

// //               <div className="w-full flex flex-col space-y-4 px-0">
// //                 <div className="flex space-x-4">
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.gallery.images[0]}
// //                       alt="Pool view 1"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                   <div className="w-[30%] overflow-hidden">
// //                     <img
// //                       src={Property.gallery.images[1]}
// //                       alt="Archway view"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                 </div>

// //                 <div className="w-[68%] aspect-[16/10] overflow-hidden">
// //                   <img
// //                     src={Property.gallery.images[2]}
// //                     alt="Pool view 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="absolute -bottom-44 left-0 w-full flex justify-center items-center space-x-4">
// //                 <div className="w-12 h-[2px] bg-gray-400"></div>
// //                 <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
// //                   <img
// //                     src={Property.gallery.logo}
// //                     alt={Property.gallery.title}
// //                     className="w-8 h-5 brightness-0"
// //                   />
// //                 </div>
// //                 <div className="w-12 h-[2px] bg-gray-400"></div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "living":
// //         return (
// //           <div
// //             key="living"
// //             className="print-page bg-[#f8f7f6] w-[210mm] h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative px-1 pt-10">
// //               <div
// //                 className="absolute -top-10 right-0 w-[430px] h-[430px] opacity-5 pointer-events-none translate-x-14 -translate-y-14"
// //                 style={{ wordSpacing: "4px" }}
// //               >
// //                 <img
// //                   src={Property.living.logo}
// //                   alt="Watermark"
// //                   className="w-full h-full object-contain grayscale"
// //                 />
// //               </div>

// //               <div className="relative z-10">
// //                 <h1 className="text-3xl italic PlayfairDisplay text-gray-800 leading-tight">
// //                   The
// //                 </h1>
// //                 <h2 className="text-4xl PlayfairDisplay text-gray-800 tracking-widest uppercase mb-8">
// //                   Living
// //                 </h2>

// //                 <div className="montserrat flex flex-col space-y-6 text-gray-800 text-[15px] tracking-widest max-w-[100%]">
// //                   <p>{Property.living.paragraph1}</p>
// //                   <p>{Property.living.paragraph2}</p>
// //                 </div>

// //                 <div className="mt-12 w-full aspect-[4/3] overflow-hidden">
// //                   <img
// //                     src={Property.living.livingImage}
// //                     alt="Living Area"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="absolute -bottom-[83px] left-12 flex gap-6">
// //                 <div className="w-[2px] h-36 bg-gray-400"></div>
// //                 <div className="w-[2px] h-36 bg-gray-400"></div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "kitchenDining":
// //         return (
// //           <div
// //             key="kitchenDining"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="absolute top-6 right-12 z-20">
// //                 <span className="waterfall italic text-5xl text-gray-900 drop-shadow-sm">
// //                   {Property.kitchenDining.title}
// //                 </span>
// //               </div>

// //               <div className="flex flex-col space-y-4 w-full h-full pt-12">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.kitchenDining.images[0]}
// //                     alt="Kitchen Area"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.kitchenDining.images[1]}
// //                     alt="Dining Area"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedrooms":
// //         return (
// //           <div
// //             key="bedrooms"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col px-1 pt-20 relative">
// //               <div className="mb-8">
// //                 <h1 className="text-3xl PlayfairDisplay italic text-gray-800 leading-tight">
// //                   The
// //                 </h1>
// //                 <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2 tracking-wide">
// //                   Bedrooms
// //                 </h2>
// //               </div>

// //               <div
// //                 className="montserrat flex flex-col space-y-8 text-gray-800 tracking-widest text-[14.5px] text-justify max-w-[95%] leading-relaxed"
// //                 style={{ wordSpacing: "1px" }}
// //               >
// //                 <p>{Property.bedrooms.paragraph1}</p>
// //                 <p>{Property.bedrooms.paragraph2}</p>
// //               </div>

// //               <div className="mt-10 w-full aspect-[16/11] overflow-hidden">
// //                 <img
// //                   src={Property.bedrooms.bedroomImage}
// //                   alt="Bedroom Interior"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>

// //               <div className="absolute -bottom-24 left-0 w-full flex justify-center items-center space-x-4">
// //                 <div className="w-12 h-[2px] bg-gray-400"></div>
// //                 <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
// //                   <img
// //                     src={Property.bedrooms.logo}
// //                     alt="Logo"
// //                     className="w-7 h-5 brightness-0 opacity-70"
// //                   />
// //                 </div>
// //                 <div className="w-12 h-[2px] bg-gray-400"></div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery":
// //         return (
// //           <div
// //             key="bedroomGallery"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden shadow-sm">
// //                   <img
// //                     src={Property.bedroomGallery.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden shadow-sm">
// //                   <img
// //                     src={Property.bedroomGallery.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery2":
// //         return (
// //           <div
// //             key="bedroomGallery2"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery2.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery2.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGalleryMixed":
// //         return (
// //           <div
// //             key="bedroomGalleryMixed"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-5 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pb-10">
// //                 <div className="w-full h-[45%] overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGalleryMixed.images[0]}
// //                     alt="Master Bedroom View"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex space-x-4 w-full h-[45%]">
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed.images[1]}
// //                       alt="Bedroom Seating"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed.images[2]}
// //                       alt="Bedroom Detail"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGalleryMixed2":
// //         return (
// //           <div
// //             key="bedroomGalleryMixed2"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-0 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pb-16">
// //                 <div className="w-full h-[45%] overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGalleryMixed2.images[0]}
// //                     alt="Master Bedroom View"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex space-x-4 w-full h-[45%]">
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed2.images[1]}
// //                       alt="Bedroom Seating"
// //                       className="w-full h-[25vh] object-cover"
// //                     />
// //                   </div>
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed2.images[2]}
// //                       alt="Bedroom Detail"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGalleryMixed3":
// //         return (
// //           <div
// //             key="bedroomGalleryMixed3"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-5 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pb-16">
// //                 <div className="w-full h-[45%] overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGalleryMixed3.images[0]}
// //                     alt="Master Bedroom View"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex space-x-4 w-full h-[45%]">
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed3.images[1]}
// //                       alt="Bedroom Seating"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed3.images[2]}
// //                       alt="Bedroom Detail"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery3":
// //         return (
// //           <div
// //             key="bedroomGallery3"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery3.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery3.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "commonareas":
// //         return (
// //           <div
// //             key="commonareas"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="absolute top-0 left-6 z-20 flex items-center w-full">
// //                 <span className="waterfall italic text-5xl text-gray-800 pr-6">
// //                   {Property.commonareas.title}
// //                 </span>
// //                 <div className="flex-1 h-[1px] bg-gray-400 -mr-6"></div>
// //               </div>

// //               <div className="absolute top-24 left-10 w-[1px] h-[135vh] bg-gray-400"></div>

// //               <div className="flex flex-col space-y-4 w-full h-full pt-28 pl-16">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.commonareas.images[0]}
// //                     alt="Common Area Overview"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.commonareas.images[1]}
// //                     alt="Lounge and Staircase"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery4":
// //         return (
// //           <div
// //             key="bedroomGallery4"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-5 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery4.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery4.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery5":
// //         return (
// //           <div
// //             key="bedroomGallery5"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery5.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery5.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGalleryMixed4":
// //         return (
// //           <div
// //             key="bedroomGalleryMixed4"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-5 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pb-16">
// //                 <div className="w-full h-[45%] overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGalleryMixed4.images[0]}
// //                     alt="Master Bedroom View"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex space-x-4 w-full h-[45%]">
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed4.images[1]}
// //                       alt="Bedroom Seating"
// //                       className="w-full h-full object-cover"
// //                     />
// //                   </div>
// //                   <div className="flex-1 overflow-hidden">
// //                     <img
// //                       src={Property.bedroomGalleryMixed4.images[2]}
// //                       alt="Bedroom Detail"
// //                       className="w-full h-[25vh] object-cover"
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery6":
// //         return (
// //           <div
// //             key="bedroomGallery6"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery6.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery6.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "bedroomGallery7":
// //         return (
// //           <div
// //             key="bedroomGallery7"
// //             className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden"
// //           >
// //             <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //               <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery7.images[0]}
// //                     alt="Bedroom Suite 1"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>

// //                 <div className="flex-1 overflow-hidden">
// //                   <img
// //                     src={Property.bedroomGallery7.images[1]}
// //                     alt="Bedroom Suite 2"
// //                     className="w-full h-full object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "services":
// //         return (
// //           <div
// //             key="services"
// //             className="print-page w-[210mm] min-h-[297mm] pl-8 pr-5 pt-20 flex flex-col relative bg-[#f8f7f6] shadow-md"
// //           >
// //             <div className="mb-12 max-w-[92%] ml-5">
// //               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-6">
// //                 {Property.services.section1.title}
// //               </h2>
// //               <p
// //                 className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-10"
// //                 style={{ wordSpacing: "1px" }}
// //               >
// //                 {Property.services.section1.description}
// //               </p>

// //               <div
// //                 className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-center"
// //                 style={{
// //                   backgroundImage:
// //                     "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
// //                 }}
// //               >
// //                 <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
// //                 <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
// //                   {Property.services.section1.bannerText}
// //                 </h3>
// //                 <a
// //                   href="https://drive.google.com/file/d/1jOhgd_mzOigpKwZ9ZCWaVt_iyguQlFKa/view"
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                 >
// //                   <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
// //                     Click Here
// //                   </button>
// //                 </a>
// //               </div>
// //             </div>

// //             <div className="max-w-[92%] ml-5">
// //               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-10 mt-10">
// //                 {Property.services.section2.title}
// //               </h2>
// //               <p
// //                 className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-8"
// //                 style={{ wordSpacing: "1px" }}
// //               >
// //                 {Property.services.section2.description}
// //               </p>

// //               <div
// //                 className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-top"
// //                 style={{
// //                   backgroundImage:
// //                     "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
// //                 }}
// //               >
// //                 <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
// //                 <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
// //                   {Property.services.section2.bannerText}
// //                 </h3>
// //                 <a
// //                   href="https://drive.google.com/file/d/1jOhgd_mzOigpKwZ9ZCWaVt_iyguQlFKa/view"
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                 >
// //                   <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
// //                     Click Here
// //                   </button>
// //                 </a>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "aboutZorba":
// //         return (
// //           <div
// //             key="aboutZorba"
// //             className="print-page w-[210mm] min-h-[297mm] relative flex flex-col pt-10 pl-5 px-1 overflow-hidden bg-[#f8f7f6] shadow-md"
// //           >
// //             <div className="absolute top-10 right-12 z-20 flex items-center justify-end w-full">
// //               <div className="flex-1 h-[1px] bg-gray-400 ml-0"></div>
// //               <span className="waterfall italic text-5xl text-gray-800 pl-6">
// //                 {Property.aboutZorba.title || "About"}
// //               </span>
// //             </div>

// //             <div className="absolute top-32 bottom-0 right-12 w-[1px] bg-gray-400"></div>

// //             <div className="flex flex-col justify-center h-full max-w-[95%] pr-16 pl-8 pt-[40vh]">
// //               <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-8 leading-tight">
// //                 {Property.aboutZorba.heading}
// //               </h2>

// //               <div
// //                 className="montserrat flex flex-col space-y-8 text-gray-800 text-[15px] tracking-widest text-justify"
// //                 style={{ wordSpacing: "1px" }}
// //               >
// //                 <p>{Property.aboutZorba.paragraph1}</p>
// //                 <p>{Property.aboutZorba.paragraph2}</p>
// //                 <p>{Property.aboutZorba.paragraph3}</p>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       case "backCover":
// //         return (
// //           <div
// //             key="backCover"
// //             className="print-page w-[210mm] min-h-[297mm] flex flex-col justify-between items-center py-16 px-1 bg-[#f8f7f6] shadow-md relative"
// //           >
// //             <div className="flex flex-col items-center mt-60">
// //               <img
// //                 src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public"
// //                 alt="Logo"
// //                 className="h-44 w-auto object-contain"
// //               />
// //             </div>

// //             <div className="flex flex-col items-center space-y-32">
// //               <div className="text-center">
// //                 <span className="waterfall text-4xl italic block">
// //                   {Property.backCover.quoteLine1}
// //                 </span>
// //                 <span className="waterfall text-3xl italic block">
// //                   {Property.backCover.quoteLine2}
// //                 </span>
// //               </div>

// //               <div className="montserrat flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
// //                 <a
// //                   href={`https://zorbastays.com/`}
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                 >
// //                   {Property.backCover.contact.website}
// //                 </a>
// //                 <span className="h-3 w-[1px] bg-gray-400"></span>
// //                 <a href={`mailto:info@zorbastays.com`}>
// //                   {Property.backCover.contact.email}
// //                 </a>
// //                 <span className="h-3 w-[1px] bg-gray-400"></span>
// //                 <span>{Property.backCover.contact.phones}</span>
// //               </div>
// //             </div>
// //           </div>
// //         );

// //       default:
// //         return null;
// //     }
// //   };
// //   return (
// //     <div className="bg-white min-h-screen flex flex-col items-center py-10 gap-10 print:gap-0 print:py-0 print:p-0 print:bg-[#f8f7f6]">
// //       {/* DOWNLOAD BUTTON */}
// //       <div className="fixed right-5 bottom-20 print:hidden">
// //         <button
// //           onClick={handleDownload}
// //           className="flex gap-2 justify-center items-center bg-black text-white w-48 py-3 rounded-md tracking-widest text-sm hover:bg-green-800 transition duration-200 ease-linear"
// //         >
// //           <FaDownload />
// //           Download PDF
// //         </button>
// //       </div>

// //       <div className="fixed right-5 bottom-5 print:hidden">
// //         <button
// //           onClick={() => navigate("/PropertyBrochure")}
// //           className="flex gap-2 justify-center items-center border-2 border-black text-black font-semibold w-48 py-2.5 rounded-md tracking-widest text-sm hover:bg-black hover:text-white transition duration-200 ease-linear"
// //         >
// //           <CgTemplate />
// //           Back to Brochures
// //         </button>
// //       </div>

// //       <style
// //         dangerouslySetInnerHTML={{
// //           __html: `
// //             @page {
// //               size: A4 portrait;
// //               margin: 0;
// //             }

// //             @media print {
// //               html, body {
// //                 width: 210mm;
// //                 margin: 0;
// //                 padding: 0;
// //                 height: auto !important;
// //                 -webkit-print-color-adjust: exact;
// //                 print-color-adjust: exact;
// //               }

// //               body {
// //                 zoom: 100%;
// //               }

// //               .print-page {
// //                 width: 210mm !important;
// //                 min-height: 297mm !important;
// //                 page-break-after: always;
// //                 break-after: page;
// //                 page-break-inside: avoid;
// //                 break-inside: avoid;
// //                 margin: 0 !important;
// //               }

// //               .print-page:last-of-type {
// //                 page-break-after: auto !important;
// //                 break-after: auto !important;
// //               }

// //               .shadow-md {
// //                 box-shadow: none !important;
// //               }
// //             }
// //           `,
// //         }}
// //       />

// //       {/* Render pages conditionally based on pagesToRender */}
// //       {pagesToRender.map((pageId) => renderPage(pageId))}
// //     </div>
// //   );
// // };

// // export default BrochurePDF;

// //old
// // import React, { useEffect, useState } from "react";
// // import { useNavigate, useParams } from "react-router-dom";
// // import { CgTemplate } from "react-icons/cg";
// // import { FaDownload } from "react-icons/fa6";
// // const BrochurePDF = () => {
// //   const { id } = useParams();
// //   const navigate = useNavigate();
// //   console.log(id);
// //   const [brochure, setBrochure] = useState(null);
// //   const [amenities, setAmenities] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);

// //   useEffect(() => {
// //     const fetchBrochure = async () => {
// //       try {
// //         // 1. Fetch brochure data
// //         const res = await fetch(
// //           `https://dash.zorbastays.com/web-backend/getBrochure/${id}`,
// //         );

// //         // DEBUG: Log the raw response
// //         const rawText = await res.text();
// //         console.log("RAW RESPONSE:", rawText);
// //         console.log("Response status:", res.status);
// //         console.log("Response headers:", [...res.headers.entries()]);

// //         // Try to parse
// //         let json;
// //         try {
// //           json = JSON.parse(rawText);
// //           console.log("Parsed JSON:", json);
// //         } catch (parseError) {
// //           console.error("JSON Parse Error:", parseError);
// //           console.error("First 100 chars:", rawText.substring(0, 100));
// //           throw new Error(
// //             `Invalid response from server. Status: ${res.status}`,
// //           );
// //         }

// //         if (!json.success) throw new Error(json.message);
// //         setBrochure(json.data);

// //         // 2. Parse amenity IDs - THE FIX IS HERE
// //         // json.data.amenity_ids is already an array from backend, don't parse again!
// //         const amenityIds = Array.isArray(json.data.amenity_ids)
// //           ? json.data.amenity_ids
// //           : JSON.parse(json.data.amenity_ids || "[]");

// //         console.log("amenityIds:", amenityIds);

// //         if (amenityIds.length > 0) {
// //           const amenityRes = await fetch(
// //             `https://dash.zorbastays.com/web-backend/getAmenitiesById?ids=${amenityIds.join(",")}`,
// //           );
// //           const amenityJson = await amenityRes.json();
// //           console.log("amenityJson:", amenityJson);

// //           if (amenityJson.success) {
// //             setAmenities(amenityJson.data);
// //           }
// //         }
// //       } catch (err) {
// //         console.error("Fetch error:", err);
// //         setError(err.message);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchBrochure();
// //   }, [id]);
// //   if (loading)
// //     return (
// //       <div className="flex items-center justify-center min-h-screen">
// //         Loading...
// //       </div>
// //     );
// //   if (error)
// //     return (
// //       <div className="flex items-center justify-center min-h-screen text-red-500">
// //         {error}
// //       </div>
// //     );
// //   if (!brochure) return null;

// //   // ── map flat DB row → the shape your JSX already uses ──────────────
// //   const Property = {
// //     villa: {
// //       logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
// //       title: brochure.villa_name,
// //       text: brochure.top_text,
// //       mainImage: brochure.img_page1,
// //       signature: brochure.location,
// //       contact: {
// //         website: "www.zorbastays.com",
// //         email: "info@zorbastays.com",
// //         phones: "63552-31066, 98750-28066",
// //       },
// //     },

// //     // amenities: {
// //     //   logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //     //   items: JSON.parse(brochure.amenity_ids), // your stored amenity array
// //     // },
// //     amenities: {
// //       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //       items: amenities.map((a) => ({
// //         name: a.name,
// //         imgSrc: a.url, // match whatever your DB column is named
// //       })),
// //     },
// //     theVilla: {
// //       logo: "https://zorbastays.com/android-chrome-512x512.png",
// //       image: brochure.img_page3,
// //       paragraph1: brochure.villa_desc1,
// //       paragraph2: brochure.villa_desc2,
// //     },

// //     curation: {
// //       title: brochure.the_title,
// //       footerWebsite: "www.zorbastays.com",
// //       steps: [
// //         { heading: brochure.curate_title1, description: brochure.curate_desc1 },
// //         { heading: brochure.curate_title2, description: brochure.curate_desc2 },
// //         { heading: brochure.curate_title3, description: brochure.curate_desc3 },
// //         { heading: brochure.curate_title4, description: brochure.curate_desc4 },
// //         { heading: brochure.curate_title5, description: brochure.curate_desc5 },
// //       ],
// //     },

// //     gallery: {
// //       signature: brochure.pool_title,
// //       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //       images: [
// //         brochure.img_page5_1,
// //         brochure.img_page5_2,
// //         brochure.img_page5_3,
// //       ],
// //     },

// //     living: {
// //       logo: "https://zorbastays.com/android-chrome-512x512.png",
// //       livingImage: brochure.img_page6,
// //       paragraph1: brochure.living_desc1,
// //       paragraph2: brochure.living_desc2,
// //     },

// //     kitchenDining: {
// //       title: brochure.kitchen_title,
// //       images: [brochure.img_page7_1, brochure.img_page7_2],
// //     },

// //     bedrooms: {
// //       logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
// //       bedroomImage: brochure.img_page8,
// //       paragraph1: brochure.bed_desc1,
// //       paragraph2: brochure.bed_desc2,
// //     },

// //     bedroomGallery: { images: [brochure.img_page9_1, brochure.img_page9_2] },
// //     bedroomGallery2: { images: [brochure.img_page10_1, brochure.img_page10_2] },
// //     bedroomGalleryMixed: {
// //       images: [
// //         brochure.img_page11_1,
// //         brochure.img_page11_2,
// //         brochure.img_page11_3,
// //       ],
// //     },
// //     bedroomGalleryMixed2: {
// //       images: [
// //         brochure.img_page12_1,
// //         brochure.img_page12_2,
// //         brochure.img_page12_3,
// //       ],
// //     },
// //     bedroomGalleryMixed3: {
// //       images: [
// //         brochure.img_page13_1,
// //         brochure.img_page13_2,
// //         brochure.img_page13_3,
// //       ],
// //     },
// //     bedroomGallery3: { images: [brochure.img_page14_1, brochure.img_page14_2] },

// //     commonareas: {
// //       title: brochure.common_areas,
// //       images: [brochure.img_page15_1, brochure.img_page15_2],
// //     },

// //     bedroomGallery4: { images: [brochure.img_page16_1, brochure.img_page16_2] },
// //     bedroomGallery5: { images: [brochure.img_page17_1, brochure.img_page17_2] },
// //     bedroomGalleryMixed4: {
// //       images: [
// //         brochure.img_page18_1,
// //         brochure.img_page18_2,
// //         brochure.img_page18_3,
// //       ],
// //     },
// //     bedroomGallery6: { images: [brochure.img_page19_1, brochure.img_page19_2] },
// //     bedroomGallery7: { images: [brochure.img_page20_1, brochure.img_page20_2] },

// //     services: {
// //       section1: {
// //         title: brochure.destination,
// //         description: brochure.destination_desc,
// //         bannerText: brochure.travel_title,
// //         link: brochure.travel_link,
// //       },
// //       section2: {
// //         title: brochure.service,
// //         description: brochure.service_desc,
// //         bannerText: brochure.concierge_title,
// //         link: brochure.concierge_link,
// //       },
// //     },

// //     aboutZorba: {
// //       title: brochure.nature,
// //       heading: brochure.nature_desc1,
// //       paragraph1: brochure.nature_desc2,
// //       paragraph2: brochure.nature_desc3,
// //       paragraph3: "",
// //     },

// //     backCover: {
// //       logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
// //       quoteLine1: "Indulge in the extraordinary;",
// //       quoteLine2: "life's too short for ordinary",
// //       contact: {
// //         website: "www.zorbastays.com",
// //         email: "info@zorbastays.com",
// //         phones: "63552-31066, 98750-28066",
// //       },
// //     },
// //   };
// //   const handleDownload = () => {
// //     window.print();
// //   };
// //   return (
// //     <div className="bg-white min-h-screen flex flex-col items-center py-10 gap-10 print:gap-0 print:py-0 print:p-0 print:bg-[#f8f7f6]">
// //       {/* DOWNLOAD BUTTON */}
// //       <div className="fixed right-5 bottom-20 print:hidden">
// //         <button
// //           onClick={handleDownload}
// //           className="flex gap-2 justify-center items-center bg-black text-white w-48 py-3 rounded-md tracking-widest text-sm hover:bg-green-800 transition duration-200 ease-linear"
// //         >
// //           <FaDownload />
// //           Download PDF
// //         </button>
// //       </div>

// //       <div className="fixed right-5 bottom-5 print:hidden">
// //         <button
// //           onClick={() => navigate("/PropertyBrochure")}
// //           className="flex gap-2 justify-center items-center border-2 border-black text-black font-semibold w-48 py-2.5 rounded-md tracking-widest text-sm hover:bg-black hover:text-white transition duration-200 ease-linear"
// //         >
// //           <CgTemplate />
// //           Back to Brochures
// //         </button>
// //       </div>
// //       <style
// //         dangerouslySetInnerHTML={{
// //           __html: `
// //             @page {
// //               size: A4 portrait;
// //               margin: 0;
// //             }

// //             @media print {
// //               html, body {
// //                 width: 210mm;
// //                 margin: 0;
// //                 padding: 0;
// //                 height: auto !important;
// //                 -webkit-print-color-adjust: exact;
// //                 print-color-adjust: exact;
// //               }

// //               body {
// //                 zoom: 100%;
// //               }

// //               .print-page {
// //                 width: 210mm !important;
// //                 min-height: 297mm !important;
// //                 page-break-after: always;
// //                 break-after: page;
// //                 page-break-inside: avoid;
// //                 break-inside: avoid;
// //                 margin: 0 !important;
// //               }

// //               .print-page:last-of-type {
// //                 page-break-after: auto !important;
// //                 break-after: auto !important;
// //               }

// //               .shadow-md {
// //                 box-shadow: none !important;
// //               }
// //             }
// //           `,
// //         }}
// //       />

// //       {/* 1 COVER */}
// //       <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative flex flex-col items-center p-12">
// //         <div className="absolute top-0 left-12 w-[1px] h-80 bg-gray-400"></div>
// //         <div className="absolute top-0 left-20 w-[1px] h-60 bg-gray-400"></div>

// //         <div className="mt-8 flex flex-col items-center">
// //           <img
// //             src={Property.villa.logo}
// //             alt={Property.villa.title}
// //             className="h-28 w-auto object-contain"
// //           />
// //         </div>

// //         <h2 className="mt-20 text-4xl PlayfairDisplay text-gray-800 tracking-wide">
// //           {Property.villa.title}
// //         </h2>

// //         <div className="mt-24 w-full relative group px-4">
// //           <p className="montserrat absolute -top-4 right-4 text-[10px] tracking-[0.2em] text-gray-800 uppercase">
// //             {Property.villa.text}
// //           </p>

// //           <div className="w-full aspect-[4/3] bg-gray-200 overflow-hidden">
// //             <img
// //               src={Property.villa.mainImage}
// //               alt={Property.villa.title}
// //               className="w-full h-full object-cover"
// //             />
// //           </div>

// //           <div className="absolute -mt-2 right-0 transform z-10">
// //             <span className="windsong italic text-5xl text-gray-900">
// //               {Property.villa.signature}
// //             </span>
// //           </div>
// //         </div>

// //         <div className="montserrat absolute bottom-3">
// //           <div className="flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
// //             <a
// //               href={`https://zorbastays.com/`}
// //               target="_blank"
// //               rel="noopener noreferrer"
// //             >
// //               <span>{Property.villa.contact.website}</span>
// //             </a>

// //             <span className="h-3 w-[1px] bg-gray-400"></span>

// //             <a href={`mailto:info@zorbastays.com`}>
// //               <span>{Property.villa.contact.email}</span>
// //             </a>

// //             <span className="h-3 w-[1px] bg-gray-400"></span>

// //             <span>{Property.villa.contact.phones}</span>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 2 AMENITIES */}
// //       {Array.from(
// //         { length: Math.ceil(Property.amenities.items.length / 10) },
// //         (_, i) => Property.amenities.items.slice(i * 10, i * 10 + 10),
// //       ).map((amenityGroup, pageIndex, allPages) => (
// //         <div
// //           key={pageIndex}
// //           className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative flex flex-col"
// //         >
// //           {pageIndex === 0 && (
// //             <div className="mt-8 ml-6 flex-none">
// //               <h1 className="text-3xl PlayfairDisplay italic text-gray-800">
// //                 The
// //               </h1>
// //               <h2 className="text-4xl PlayfairDisplay tracking-widest text-gray-800 uppercase mt-2">
// //                 Amenities
// //               </h2>
// //             </div>
// //           )}

// //           <div
// //             className={`flex-grow flex items-start justify-center ${pageIndex === 0 ? "pt-20" : "pt-32"}`}
// //           >
// //             <div className="grid grid-cols-2 gap-y-12 gap-x-12 px-4 w-full">
// //               {amenityGroup.map((item, index) => (
// //                 <div key={index} className="flex items-center space-x-6">
// //                   <div className="w-24 h-24 flex items-center justify-center flex-none">
// //                     <img
// //                       src={item.imgSrc}
// //                       alt={item.name}
// //                       className="max-w-full max-h-full object-contain brightness-0 grayscale"
// //                     />
// //                   </div>
// //                   <span className="text-[11px] font-medium tracking-[0.2em] uppercase text-gray-800 leading-tight">
// //                     {item.name}
// //                   </span>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //           {pageIndex === allPages.length - 1 && (
// //             <div className="mt-auto mb-4 flex justify-center items-center space-x-4">
// //               <div className="w-12 h-[1px] bg-gray-400"></div>
// //               <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
// //                 <img
// //                   src={Property.amenities.logo}
// //                   alt="logo"
// //                   className="w-8 h-5 brightness-0"
// //                 />
// //               </div>
// //               <div className="w-12 h-[1px] bg-gray-400"></div>
// //             </div>
// //           )}
// //         </div>
// //       ))}

// //       {/*3 THE VILLA */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden">
// //         {(() => {
// //           const totalChars =
// //             (Property.theVilla.paragraph1?.length || 0) +
// //             (Property.theVilla.paragraph2?.length || 0);

// //           const imageBottom =
// //             totalChars > 600 ? "bottom-[40px]" : "bottom-[170px]";
// //           const logoBottom =
// //             totalChars > 600 ? "bottom-[20px]" : "bottom-[70px]";

// //           return (
// //             <>
// //               <div className="mb-8 ml-1">
// //                 <h1 className="text-3xl PlayfairDisplay italic text-gray-800 leading-tight">
// //                   The
// //                 </h1>
// //                 <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2">
// //                   Villa
// //                 </h2>
// //               </div>

// //               <div
// //                 className="montserrat flex flex-col ml-1 space-y-6 text-gray-800 tracking-widest text-base text-justify max-w-[100%]"
// //                 style={{ wordSpacing: "1px" }}
// //               >
// //                 <p>{Property.theVilla.paragraph1}</p>
// //                 <p>{Property.theVilla.paragraph2}</p>
// //               </div>

// //               <div
// //                 className={`absolute left-12 right-12 h-[430px] z-20 ${imageBottom}`}
// //               >
// //                 <img
// //                   src={Property.theVilla.image}
// //                   alt="Villa Exterior"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>

// //               <div
// //                 className={`absolute left-8 w-28 h-28 opacity-20 grayscale z-10 ${logoBottom}`}
// //               >
// //                 <img
// //                   src={Property.theVilla.logo}
// //                   alt="Logo Watermark"
// //                   className="w-full h-full object-contain"
// //                 />
// //               </div>
// //             </>
// //           );
// //         })()}
// //       </div>

// //       {/* 4 */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] h-[297mm] p-12 pt-10 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col pt-5 px-16 relative">
// //           <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-20 -ml-16">
// //             {Property.curation.title}
// //           </h2>

// //           <div className="relative w-full flex-1">
// //             <div className="absolute -top-16 mt-4 -right-5 inset-0 flex justify-center pointer-events-none">
// //               <img
// //                 src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/3ea0d39f-9e34-4305-7ea0-07304c880a00/public"
// //                 alt="timeline"
// //                 className="opacity-60 w-auto h-[750px] object-contain"
// //               />
// //             </div>

// //             <div className="relative z-0 flex flex-col space-y-16">
// //               {Property.curation.steps?.map((step, idx) => (
// //                 <div
// //                   key={idx}
// //                   className={`relative max-w-[285px] ${
// //                     idx === 0
// //                       ? "self-start -ml-14"
// //                       : idx === 1
// //                         ? "self-end mr-8 relative -top-10"
// //                         : idx === 2
// //                           ? "self-end mr-20 relative -top-5"
// //                           : idx === 3
// //                             ? "self-start relative -top-10 -ml-5"
// //                             : "self-end mr-5 relative -top-5"
// //                   }`}
// //                 >
// //                   <h3 className="PlayfairDisplay text-xl text-gray-800 mb-2 leading-tight">
// //                     {step.heading}
// //                   </h3>
// //                   <p className="montserrat text-[13px] text-gray-800 leading-relaxed tracking-wide">
// //                     {step.description}
// //                   </p>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>

// //           <div className="absolute -bottom-10 left-0 w-full text-center">
// //             <a
// //               href="https://zorbastays.com/"
// //               target="_blank"
// //               rel="noopener noreferrer"
// //             >
// //               <span className="text-[15px] tracking-[0.1em] text-gray-500">
// //                 {Property.curation.footerWebsite}
// //               </span>
// //             </a>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 5 pool */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative">
// //           <div className="absolute -top-20 left-6 w-[1px] h-[280px] bg-gray-400"></div>

// //           <div className="flex justify-end items-center  z-10 mt-32">
// //             <span className="waterfall italic text-5xl text-gray-900">
// //               {Property.gallery.signature}
// //             </span>
// //           </div>

// //           <div className=" w-full flex flex-col space-y-4 px-0">
// //             <div className="flex space-x-4 ">
// //               <div className="flex-1 overflow-hidden">
// //                 <img
// //                   src={Property.gallery.images[0]}
// //                   alt="Pool view 1"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //               <div className="w-[30%] overflow-hidden">
// //                 <img
// //                   src={Property.gallery.images[1]}
// //                   alt="Archway view"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //             </div>

// //             <div className="w-[68%] aspect-[16/10] overflow-hidden">
// //               <img
// //                 src={Property.gallery.images[2]}
// //                 alt="Pool view 2"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>
// //           </div>

// //           <div className="absolute -bottom-44  left-0 w-full flex justify-center items-center space-x-4">
// //             <div className="w-12 h-[2px] bg-gray-400"></div>
// //             <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
// //               <img
// //                 src={Property.gallery.logo}
// //                 alt={Property.gallery.title}
// //                 className="w-8 h-5 brightness-0"
// //               />
// //             </div>
// //             <div className="w-12 h-[2px] bg-gray-400"></div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 6 living */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative px-1 pt-10">
// //           <div
// //             className="absolute -top-10 right-0 w-[430px] h-[430px] opacity-5 pointer-events-none translate-x-14 -translate-y-14"
// //             style={{ wordSpacing: "4px" }}
// //           >
// //             <img
// //               src={Property.living.logo}
// //               alt="Watermark"
// //               className="w-full h-full object-contain grayscale"
// //             />
// //           </div>

// //           <div className="relative z-10">
// //             <h1 className="text-3xl italic PlayfairDisplay text-gray-800 leading-tight">
// //               The
// //             </h1>
// //             <h2 className="text-4xl PlayfairDisplay text-gray-800 tracking-widest uppercase mb-8">
// //               Living
// //             </h2>

// //             <div className="montserrat flex flex-col space-y-6 text-gray-800 text-[15px] tracking-widest max-w-[100%]">
// //               <p>{Property.living.paragraph1}</p>
// //               <p>{Property.living.paragraph2}</p>
// //             </div>

// //             <div className="mt-12 w-full aspect-[4/3] overflow-hidden">
// //               <img
// //                 src={Property.living.livingImage}
// //                 alt="Living Area"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>
// //           </div>

// //           <div className="absolute -bottom-[83px] left-12 flex gap-6">
// //             <div className="w-[2px] h-36 bg-gray-400"></div>
// //             <div className="w-[2px] h-36 bg-gray-400"></div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 7 kitchen */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //           <div className="absolute top-6 right-12 z-20">
// //             <span className="waterfall italic text-5xl text-gray-900 drop-shadow-sm">
// //               {Property.kitchenDining.title}
// //             </span>
// //           </div>

// //           <div className="flex flex-col space-y-4 w-full h-full pt-12">
// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.kitchenDining.images[0]}
// //                 alt="Kitchen Area"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>

// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.kitchenDining.images[1]}
// //                 alt="Dining Area"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 8 bedroom */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col px-1 pt-20 relative">
// //           <div className="mb-8">
// //             <h1 className="text-3xl PlayfairDisplay italic text-gray-800 leading-tight">
// //               The
// //             </h1>
// //             <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2 tracking-wide">
// //               Bedrooms
// //             </h2>
// //           </div>

// //           <div
// //             className="montserrat flex flex-col space-y-8 text-gray-800 tracking-widest text-[14.5px] text-justify max-w-[95%] leading-relaxed"
// //             style={{ wordSpacing: "1px" }}
// //           >
// //             <p>{Property.bedrooms.paragraph1}</p>
// //             <p>{Property.bedrooms.paragraph2}</p>
// //           </div>

// //           <div className="mt-10 w-full aspect-[16/11] overflow-hidden">
// //             <img
// //               src={Property.bedrooms.bedroomImage}
// //               alt="Bedroom Interior"
// //               className="w-full h-full object-cover"
// //             />
// //           </div>

// //           <div className="absolute -bottom-24 left-0 w-full flex justify-center items-center space-x-4">
// //             <div className="w-12 h-[2px] bg-gray-400"></div>
// //             <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
// //               <img
// //                 src={Property.bedrooms.logo}
// //                 alt="Logo"
// //                 className="w-7 h-5 brightness-0 opacity-70"
// //               />
// //             </div>
// //             <div className="w-12 h-[2px] bg-gray-400"></div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 9 page */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //           <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //             <div className="flex-1 overflow-hidden shadow-sm">
// //               <img
// //                 src={Property.bedroomGallery.images[0]}
// //                 alt="Bedroom Suite 1"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>

// //             <div className="flex-1 overflow-hidden shadow-sm">
// //               <img
// //                 src={Property.bedroomGallery.images[1]}
// //                 alt="Bedroom Suite 2"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 10 page */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //           <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.bedroomGallery2.images[0]}
// //                 alt="Bedroom Suite 1"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>

// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.bedroomGallery2.images[1]}
// //                 alt="Bedroom Suite 2"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 11 page */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative pt-5 px-1">
// //           <div className="flex flex-col space-y-4 w-full h-full pb-10">
// //             <div className="w-full h-[45%] overflow-hidden">
// //               <img
// //                 src={Property.bedroomGalleryMixed.images[0]}
// //                 alt="Master Bedroom View"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>

// //             <div className="flex space-x-4 w-full h-[45%]">
// //               <div className="flex-1 overflow-hidden">
// //                 <img
// //                   src={Property.bedroomGalleryMixed.images[1]}
// //                   alt="Bedroom Seating"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //               <div className="flex-1 overflow-hidden">
// //                 <img
// //                   src={Property.bedroomGalleryMixed.images[2]}
// //                   alt="Bedroom Detail"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 12 page */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative pt-0 px-1">
// //           <div className="flex flex-col space-y-4 w-full h-full pb-16">
// //             <div className="w-full h-[45%] overflow-hidden">
// //               <img
// //                 src={Property.bedroomGalleryMixed2.images[0]}
// //                 alt="Master Bedroom View"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>

// //             <div className="flex space-x-4 w-full h-[45%]">
// //               <div className="flex-1 overflow-hidden">
// //                 <img
// //                   src={Property.bedroomGalleryMixed2.images[1]}
// //                   alt="Bedroom Seating"
// //                   className="w-full h-[25vh] object-cover"
// //                 />
// //               </div>
// //               <div className="flex-1 overflow-hidden">
// //                 <img
// //                   src={Property.bedroomGalleryMixed2.images[2]}
// //                   alt="Bedroom Detail"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 13 page */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative pt-5 px-1">
// //           <div className="flex flex-col space-y-4 w-full h-full pb-16">
// //             <div className="w-full h-[45%] overflow-hidden">
// //               <img
// //                 src={Property.bedroomGalleryMixed3.images[0]}
// //                 alt="Master Bedroom View"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>

// //             <div className="flex space-x-4 w-full h-[45%]">
// //               <div className="flex-1 overflow-hidden">
// //                 <img
// //                   src={Property.bedroomGalleryMixed3.images[1]}
// //                   alt="Bedroom Seating"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //               <div className="flex-1 overflow-hidden">
// //                 <img
// //                   src={Property.bedroomGalleryMixed3.images[2]}
// //                   alt="Bedroom Detail"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 14 page */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //           <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.bedroomGallery3.images[0]}
// //                 alt="Bedroom Suite 1"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>

// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.bedroomGallery3.images[1]}
// //                 alt="Bedroom Suite 2"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 15 page */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //           <div className="absolute top-0 left-6 z-20 flex items-center w-full">
// //             <span className="waterfall italic text-5xl text-gray-800 pr-6">
// //               {Property.commonareas.title}
// //             </span>
// //             <div className="flex-1 h-[1px] bg-gray-400 -mr-6"></div>
// //           </div>

// //           <div className="absolute top-24 left-10 w-[1px] h-[135vh] bg-gray-400"></div>

// //           <div className="flex flex-col space-y-4 w-full h-full pt-28 pl-16">
// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.commonareas.images[0]}
// //                 alt="Common Area Overview"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>

// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.commonareas.images[1]}
// //                 alt="Lounge and Staircase"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 16 page */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative pt-5 px-1">
// //           <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.bedroomGallery4.images[0]}
// //                 alt="Bedroom Suite 1"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>

// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.bedroomGallery4.images[1]}
// //                 alt="Bedroom Suite 2"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 17 page */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //           <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.bedroomGallery5.images[0]}
// //                 alt="Bedroom Suite 1"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>

// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.bedroomGallery5.images[1]}
// //                 alt="Bedroom Suite 2"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 18 page */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative pt-5 px-1">
// //           <div className="flex flex-col space-y-4 w-full h-full pb-16">
// //             <div className="w-full h-[45%] overflow-hidden">
// //               <img
// //                 src={Property.bedroomGalleryMixed4.images[0]}
// //                 alt="Master Bedroom View"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>

// //             <div className="flex space-x-4 w-full h-[45%]">
// //               <div className="flex-1 overflow-hidden">
// //                 <img
// //                   src={Property.bedroomGalleryMixed4.images[1]}
// //                   alt="Bedroom Seating"
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //               <div className="flex-1 overflow-hidden">
// //                 <img
// //                   src={Property.bedroomGalleryMixed4.images[2]}
// //                   alt="Bedroom Detail"
// //                   className="w-full h-[25vh] object-cover"
// //                 />
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 19 page */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //           <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.bedroomGallery6.images[0]}
// //                 alt="Bedroom Suite 1"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>

// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.bedroomGallery6.images[1]}
// //                 alt="Bedroom Suite 2"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 20 page */}
// //       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-5 flex flex-col items-start shadow-md relative overflow-hidden">
// //         <div className="w-full h-full flex flex-col relative pt-10 px-1">
// //           <div className="flex flex-col space-y-4 w-full h-full pt-10">
// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.bedroomGallery7.images[0]}
// //                 alt="Bedroom Suite 1"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>

// //             <div className="flex-1 overflow-hidden">
// //               <img
// //                 src={Property.bedroomGallery7.images[1]}
// //                 alt="Bedroom Suite 2"
// //                 className="w-full h-full object-cover"
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 21 serviceS */}
// //       <div className="print-page w-[210mm] min-h-[297mm] pl-8 pr-5 pt-20 flex flex-col relative bg-[#f8f7f6] shadow-md">
// //         <div className="mb-12 max-w-[92%] ml-5">
// //           <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-6">
// //             {Property.services.section1.title}
// //           </h2>
// //           <p
// //             className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-10"
// //             style={{ wordSpacing: "1px" }}
// //           >
// //             {Property.services.section1.description}
// //           </p>

// //           <div
// //             className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-center"
// //             style={{
// //               backgroundImage:
// //                 "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
// //             }}
// //           >
// //             <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
// //             <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
// //               {Property.services.section1.bannerText}
// //             </h3>
// //             <a
// //               href="https://drive.google.com/file/d/1jOhgd_mzOigpKwZ9ZCWaVt_iyguQlFKa/view"
// //               target="_blank"
// //               rel="noopener noreferrer"
// //             >
// //               <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
// //                 Click Here
// //               </button>
// //             </a>
// //           </div>
// //         </div>

// //         <div className="max-w-[92%] ml-5">
// //           <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-10 mt-10">
// //             {Property.services.section2.title}
// //           </h2>
// //           <p
// //             className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-8"
// //             style={{ wordSpacing: "1px" }}
// //           >
// //             {Property.services.section2.description}
// //           </p>

// //           <div
// //             className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-top"
// //             style={{
// //               backgroundImage:
// //                 "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
// //             }}
// //           >
// //             <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
// //             <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
// //               {Property.services.section2.bannerText}
// //             </h3>
// //             <a
// //               href="https://drive.google.com/file/d/1jOhgd_mzOigpKwZ9ZCWaVt_iyguQlFKa/view"
// //               target="_blank"
// //               rel="noopener noreferrer"
// //             >
// //               <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
// //                 Click Here
// //               </button>
// //             </a>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 22 ABOUT ZORBA */}
// //       <div className="print-page w-[210mm] min-h-[297mm] relative flex flex-col pt-10 pl-5 px-1 overflow-hidden bg-[#f8f7f6] shadow-md">
// //         <div className="absolute top-10 right-12 z-20 flex items-center justify-end w-full">
// //           <div className="flex-1 h-[1px] bg-gray-400 ml-0"></div>

// //           <span className="waterfall italic text-5xl text-gray-800 pl-6">
// //             {Property.aboutZorba.title || "About"}
// //           </span>
// //         </div>

// //         <div className="absolute top-32 bottom-0 right-12 w-[1px] bg-gray-400"></div>

// //         <div className="flex flex-col justify-center h-full max-w-[95%] pr-16 pl-8 pt-[40vh]">
// //           <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-8 leading-tight">
// //             {Property.aboutZorba.heading}
// //           </h2>

// //           <div
// //             className="montserrat flex flex-col space-y-8 text-gray-800 text-[15px] tracking-widest text-justify"
// //             style={{ wordSpacing: "1px" }}
// //           >
// //             <p>{Property.aboutZorba.paragraph1}</p>
// //             <p>{Property.aboutZorba.paragraph2}</p>
// //             <p>{Property.aboutZorba.paragraph3}</p>
// //           </div>
// //         </div>
// //       </div>

// //       {/* 23 BACK COVER */}
// //       <div className="print-page w-[210mm] min-h-[297mm] flex flex-col justify-between items-center py-16 px-1 bg-[#f8f7f6] shadow-md relative">
// //         <div className="flex flex-col items-center mt-60">
// //           <img
// //             src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public"
// //             alt="Logo"
// //             className="h-44 w-auto object-contain"
// //           />
// //         </div>

// //         <div className="flex flex-col items-center space-y-32">
// //           <div className="text-center">
// //             <span className="waterfall text-4xl italic block">
// //               {Property.backCover.quoteLine1}
// //             </span>
// //             <span className="waterfall text-3xl italic block">
// //               {Property.backCover.quoteLine2}
// //             </span>
// //           </div>

// //           <div className="montserrat flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
// //             <a
// //               href={`https://zorbastays.com/`}
// //               target="_blank"
// //               rel="noopener noreferrer"
// //             >
// //               {Property.backCover.contact.website}
// //             </a>

// //             <span className="h-3 w-[1px] bg-gray-400"></span>

// //             <a href={`mailto:info@zorbastays.com`}>
// //               {Property.backCover.contact.email}
// //             </a>

// //             <span className="h-3 w-[1px] bg-gray-400"></span>

// //             <span>{Property.backCover.contact.phones}</span>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default BrochurePDF;
